import Link from "next/link";
import AskobannerImg from "@/assets/images/static/brands/Asko/Asko_hero.webp";
import AskologoImg from "@/assets/images/static/brands/Asko/Asko_logo.webp"; 

import AskoCategory_1 from "@/assets/images/static/brands/Asko/Asko_Washers_1.webp";
import AskoCategory_2 from "@/assets/images/static/brands/Asko/Asko_Dishwashers_2.webp";
import AskoCategory_3 from "@/assets/images/static/brands/Asko/Asko_Refrigerators_3.webp";

import AmanabannerImg from "@/assets/images/static/brands/Amana/Amana_hero.webp";
import AmanalogoImg from "@/assets/images/static/brands/Amana/Amana_logo.webp"; 

import AmanaCategory_1 from "@/assets/images/static/brands/Amana/Amana_Ranges_1.webp";
import AmanaCategory_2 from "@/assets/images/static/brands/Amana/Amana_Refrigerators_2.webp";
import AmanaoCategory_3 from "@/assets/images/static/brands/Amana/Amana_Dryers_3.webp";
import AmanaoCategory_4 from "@/assets/images/static/brands/Amana/Amana_Dishwashers_4.webp";

import AvantibannerImg from "@/assets/images/static/brands/Avanti/Avanti_hero.webp";
import AvantilogoImg from "@/assets/images/static/brands/Avanti/Avanti_logo.webp"; 

import AvantiCategory_1 from "@/assets/images/static/brands/Avanti/Avanti_Ranges_1.webp";
import AvantiCategory_2 from "@/assets/images/static/brands/Avanti/Avanti_Refrigerators_2.webp";
import AvantiCategory_3 from "@/assets/images/static/brands/Avanti/Avanti_Washers_3.webp";

import BekobannerImg from "@/assets/images/static/brands/Beko/Beko_hero.webp";
import BekologoImg from "@/assets/images/static/brands/Beko/Beko_logo.webp"; 

import PerlickbannerImg from "@/assets/images/static/brands/Perlick/Perlick_hero.png";
import PerlicklogoImg from "@/assets/images/static/brands/Perlick/Perlick_logo.png"; 

import PerlickCategory_1 from "@/assets/images/static/brands/Perlick/Perlick_IceMakers_1.png";
import PerlickCategory_2 from "@/assets/images/static/brands/Perlick/Perlick_CompactRefrigerators_2.png";
import PerlickCategory_3 from "@/assets/images/static/brands/Perlick/Perlick_BeerCoolers&Kegerators_3.png";
import PerlickCategory_4 from "@/assets/images/static/brands/Perlick/Perlick_WineCoolers_4.png";

import BekoCategory_1 from "@/assets/images/static/brands/Beko/Beko_Refrigerators_1.webp";
import BekoCategory_2 from "@/assets/images/static/brands/Beko/Beko_Dryers_2.webp";
import BekoCategory_3 from "@/assets/images/static/brands/Beko/Beko_Cooktops_3.webp";
import BekoCategory_4 from "@/assets/images/static/brands/Beko/Beko_Dishwashers_4.webp";

import BertazzonibannerImg from "@/assets/images/static/brands/Bertazzoni/Bertazzoni_hero.webp";
import BertazzonilogoImg from "@/assets/images/static/brands/Bertazzoni/Bertazzoni_logo.webp"; 

import BertazzoniCategory_1 from "@/assets/images/static/brands/Bertazzoni/Bertazzoni_Microwaves_1.webp";
import BertazzoniCategory_2 from "@/assets/images/static/brands/Bertazzoni/Bertazzoni_Refrigerators_2.webp";
import BertazzoniCategory_3 from "@/assets/images/static/brands/Bertazzoni/Bertazzoni_Dishwashers_3.webp";

import BestVentilationbannerImg from "@/assets/images/static/brands/BestVentilation/BestVentilation_hero.webp";
import BestVentilationlogoImg from "@/assets/images/static/brands/BestVentilation/BestVentillation_logo.webp"; 

import BestVentilationCategory_1 from "@/assets/images/static/brands/BestVentilation/BestVentilation_DowndraftRangeHoods_1.webp";
import BestVentilationCategory_2 from "@/assets/images/static/brands/BestVentilation/BestVentilation_ChimneyRangeHoods_2.webp";
import BestVentilationCategory_3 from "@/assets/images/static/brands/BestVentilation/BestVentilation_UnderCabinetRangeHoods_3.webp";
import BestVentilationCategory_4 from "@/assets/images/static/brands/BestVentilation/BestVentilation_IslandRangeHoods_4.webp";

import BluestarbannerImg from "@/assets/images/static/brands/Bluestar/Bluestar_hero.webp";
import BluestarlogoImg from "@/assets/images/static/brands/Bluestar/BlueStar_logo.webp"; 

import BluestarCategory_1 from "@/assets/images/static/brands/Bluestar/Bluestar_Ranges_1.webp";
import BluestarCategory_2 from "@/assets/images/static/brands/Bluestar/Bluestar_Refrigerators_2.webp";

import BoschbannerImg from "@/assets/images/static/brands/Bosch/Bosch_hero.webp";
import BoschlogoImg from "@/assets/images/static/brands/Bosch/Bosch_logo.webp"; 

import BoschCategory_1 from "@/assets/images/static/brands/Bosch/Bosch_Dishwashers_1.webp";
import BoschCategory_2 from "@/assets/images/static/brands/Bosch/Bosch_Refrigerators_2.webp";
import BoschCategory_3 from "@/assets/images/static/brands/Bosch/Bosch_Microwaves_3.webp";
import BoschCategory_4 from "@/assets/images/static/brands/Bosch/Bosch_Washers_4.webp";

import BroanbannerImg from "@/assets/images/static/brands/Broan/bannerImg.webp";
import BroanlogoImg from "@/assets/images/static/brands/Broan/logo.png"; 

import BroanCategory_1 from "@/assets/images/static/brands/Broan/Category_1.webp";
import BroanCategory_2 from "@/assets/images/static/brands/Broan/Category_2.webp";
import BroanCategory_3 from "@/assets/images/static/brands/Broan/Category_3.webp";
import BroanCategory_4 from "@/assets/images/static/brands/Broan/Category_4.webp";


import DacorbannerImg from "@/assets/images/static/brands/Dacor/Dacor_hero.webp";
import DacorlogoImg from "@/assets/images/static/brands/Dacor/Dacor_logo.webp"; 

import DacorCategory_1 from "@/assets/images/static/brands/Dacor/Dacor_Microwaves_1.webp";
import DacorCategory_2 from "@/assets/images/static/brands/Dacor/Dacor_Refrigerators_2.webp";
import DacorCategory_3 from "@/assets/images/static/brands/Dacor/Dacor_Dishwashers_3.webp";

import DCSbannerImg from "@/assets/images/static/brands/DCS/DCS_hero.webp";
import DCSlogoImg from "@/assets/images/static/brands/DCS/DCS_logo.webp"; 

import DCSCategory_1 from "@/assets/images/static/brands/DCS/DCS_OutdoorGrills_1.webp";
import DCSCategory_2 from "@/assets/images/static/brands/DCS/DCS_Refrigerators_2.webp";

import ElectroluxbannerImg from "@/assets/images/static/brands/Electrolux/Electrolux_hero.webp";
import ElectroluxlogoImg from "@/assets/images/static/brands/Electrolux/Electrolux_logo.webp"; 

import ElectroluxCategory_1 from "@/assets/images/static/brands/Electrolux/LaundryCenters.png";
import ElectroluxCategory_2 from "@/assets/images/static/brands/Electrolux/WasherDryerSets.png";
import ElectroluxCategory_3 from "@/assets/images/static/brands/Electrolux/Washers.png";
import ElectroluxCategory_4 from "@/assets/images/static/brands/Electrolux/Dryers.png";

import ElicabannerImg from "@/assets/images/static/brands/Elica/Elica_hero.webp";
import ElicalogoImg from "@/assets/images/static/brands/Elica/Elica_logo.webp"; 

import ElicaCategory_1 from "@/assets/images/static/brands/Elica/Elica_RangeHoods_1.webp";
import ElicaCategory_2 from "@/assets/images/static/brands/Elica/Elica_BeverageCenters_2.webp";
import FisherPaykelbannerImg from "@/assets/images/static/brands/FisherPaykel/FisherPaykel_hero.webp";
import FisherPaykellogoImg from "@/assets/images/static/brands/FisherPaykel/FisherPaykel_logo.webp"; 

import FisherPaykelCategory_1 from "@/assets/images/static/brands/FisherPaykel/FisherPaykel_DishwasherDrawers_1.webp";
import FisherPaykelCategory_2 from "@/assets/images/static/brands/FisherPaykel/FisherPaykel_Refrigerators_2.webp";
import FisherPaykelCategory_3 from "@/assets/images/static/brands/FisherPaykel/FisherPaykel_Ranges_3.webp";

import FornobannerImg from "@/assets/images/static/brands/Forno/Forno_hero.webp";
import FornologoImg from "@/assets/images/static/brands/Forno/Forno_logo.webp"; 

import FornoCategory_1 from "@/assets/images/static/brands/Forno/Forno_Ranges_1.webp";
import FornoCategory_2 from "@/assets/images/static/brands/Forno/Forno_Refrigerators_2.webp";
import FornoCategory_3 from "@/assets/images/static/brands/Forno/Forno_Dishwashers_3.webp";

import FosterbannerImg from "@/assets/images/static/brands/Foster/Foster_hero.webp";
import FosterlogoImg from "@/assets/images/static/brands/Foster/Foster_logo.webp"; 

import FosterCategory_1 from "@/assets/images/static/brands/Foster/Foster_Ranges_1.webp";
import FosterCategory_2 from "@/assets/images/static/brands/Foster/Foster_Cooktops_2.webp";
import FosterCategory_3 from "@/assets/images/static/brands/Foster/Foster_Rangetops_3.webp";

import FrigidairebannerImg from "@/assets/images/static/brands/Frigidaire/Frigidaire_hero.webp";
import FrigidairelogoImg from "@/assets/images/static/brands/Frigidaire/Frigidaire_logo.webp"; 

import FrigidaireCategory_1 from "@/assets/images/static/brands/Frigidaire/Frigidaire_Refrigerators_1.webp";
import FrigidaireCategory_2 from "@/assets/images/static/brands/Frigidaire/Frigidaire_Dishwashers_2.webp";
import FrigidaireCategory_3 from "@/assets/images/static/brands/Frigidaire/Frigidaire_WallOvens_3.webp";
import FrigidaireCategory_4 from "@/assets/images/static/brands/Frigidaire/Frigidaire_LaundryCenters_4.webp";

import FrigidaireGallerybannerImg from "@/assets/images/static/brands/FrigidaireGallery/FrigidareGallery_hero.webp";
import FrigidaireGallerylogoImg from "@/assets/images/static/brands/FrigidaireGallery/FrigidaireGallery_logo.webp"; 

import FrigidaireGalleryCategory_1 from "@/assets/images/static/brands/FrigidaireGallery/FrigidaireGallery_Refrigerators_1.webp";
import FrigidaireGalleryCategory_2 from "@/assets/images/static/brands/FrigidaireGallery/FrigidaireGallery_Dishwasher_2.webp";
import FrigidaireGalleryCategory_3 from "@/assets/images/static/brands/FrigidaireGallery/FrigidaireGallery_WallOvens_3.webp";

import FrigidaireProbannerImg from "@/assets/images/static/brands/Frigidaire_Pro/FrigidareProfessional_hero.webp";
import FrigidairePrologoImg from "@/assets/images/static/brands/Frigidaire_Pro/FrigidaireProfessional_logo.webp"; 

import FrigidaireProCategory_1 from "@/assets/images/static/brands/Frigidaire_Pro/FrigidaireProfessional_Refrigerators_1.webp";
import FrigidaireProCategory_2 from "@/assets/images/static/brands/Frigidaire_Pro/FrigidaireProfessional_Dishwashers_2.webp";
import FrigidaireProCategory_3 from "@/assets/images/static/brands/Frigidaire_Pro/FrigidaireProfessional_Microwaves_3.webp";

import GaggenaubannerImg from "@/assets/images/static/brands/Gaggenau/Gaggenau_hero.webp";
import GaggenaulogoImg from "@/assets/images/static/brands/Gaggenau/Gaggenau_logo.webp"; 

import GaggenauCategory_1 from "@/assets/images/static/brands/Gaggenau/Gaggenau_Cooktops_1.webp";
import GaggenauCategory_2 from "@/assets/images/static/brands/Gaggenau/Gaggenau_Refrigerators_2.webp";
import GaggenauCategory_3 from "@/assets/images/static/brands/Gaggenau/Gaggenau_Dishwashers_3.webp";

import KitchenAidbannerImg from "@/assets/images/static/brands/KitchenAid/Kitchenaid_hero.webp";
import KitchenAidlogoImg from "@/assets/images/static/brands/KitchenAid/KitchenAid_logo.webp"; 

import KitchenAidCategory_1 from "@/assets/images/static/brands/KitchenAid/Kitchenaid_Dishwashers_1.webp";
import KitchenAidCategory_2 from "@/assets/images/static/brands/KitchenAid/Kitchenaid_Refrigerators_2.webp";
import KitchenAidCategory_3 from "@/assets/images/static/brands/KitchenAid/Kitchenaid_Microwaves_3.webp";

import LG_AppliancesbannerImg from "@/assets/images/static/brands/LG_Appliances/LG_hero.webp";
import LG_ApplianceslogoImg from "@/assets/images/static/brands/LG_Appliances/LG_logo.webp"; 

import LG_AppliancesCategory_1 from "@/assets/images/static/brands/LG_Appliances/LG_Washers_1.webp";
import LG_AppliancesCategory_2 from "@/assets/images/static/brands/LG_Appliances/LG_Refrigerators_2.webp";
import LG_AppliancesCategory_3 from "@/assets/images/static/brands/LG_Appliances/LG_Dishwashers_3.webp";
import LG_AppliancesCategory_4 from "@/assets/images/static/brands/LG_Appliances/LG_Microwaves_4.webp";

import LG_StudiobannerImg from "@/assets/images/static/brands/LG_Studio/LGStudio_hero.webp";
import LG_StudiologoImg from "@/assets/images/static/brands/LG_Studio/LGStudio_logo.webp"; 

import LG_StudioCategory_1 from "@/assets/images/static/brands/LG_Studio/LGStudio_Refrigerators_1.webp";
import LG_StudioCategory_2 from "@/assets/images/static/brands/LG_Studio/LGStudio_Microwaves_2.webp";
import LG_StudioCategory_3 from "@/assets/images/static/brands/LG_Studio/LGStudio_LaundryCenters_3.webp";
import LG_StudioCategory_4 from "@/assets/images/static/brands/LG_Studio/LGStudio_Dishwashers_4.webp";

import Marvel_RefrigerationbannerImg from "@/assets/images/static/brands/Marvel_Refrigeration/MarvelRefrigeration_hero.webp";
import Marvel_RefrigerationlogoImg from "@/assets/images/static/brands/Marvel_Refrigeration/MarvelRefrigeration_logo.webp";

import Marvel_RefrigerationCategory_1 from "@/assets/images/static/brands/Marvel_Refrigeration/MarvelRefrigeration_UnderCounterIceMakers_1.webp";
import Marvel_RefrigerationCategory_2 from "@/assets/images/static/brands/Marvel_Refrigeration/MarvelRefrigeration_BeverageCenters_2.webp";
import Marvel_RefrigerationCategory_3 from "@/assets/images/static/brands/Marvel_Refrigeration/MarvelRefrigeration_BeerCoolers&Kegerators_3.webp";
import Marvel_RefrigerationCategory_4 from "@/assets/images/static/brands/Marvel_Refrigeration/MarvelRefrigeration_Freezers_4.webp";
import Marvel_RefrigerationCategory_5 from "@/assets/images/static/brands/Marvel_Refrigeration/MarvelRefrigeration_WineCoolers_5.webp";

import MaytagbannerImg from "@/assets/images/static/brands/Maytag/Maytag_hero.webp";
import MaytaglogoImg from "@/assets/images/static/brands/Maytag/Maytag_logo.webp";

import MaytagCategory_1 from "@/assets/images/static/brands/Maytag/Maytag_Washers_1.webp";
import MaytagCategory_2 from "@/assets/images/static/brands/Maytag/Maytag_Dishwashers_2.webp";
import MaytagCategory_3 from "@/assets/images/static/brands/Maytag/Maytag_Refrigerators_3.webp";
import MaytagCategory_4 from "@/assets/images/static/brands/Maytag/Maytag_Ranges_4.webp";

import MielebannerImg from "@/assets/images/static/brands/Miele/Miele_hero.webp";
import MielelogoImg from "@/assets/images/static/brands/Miele/Miele_logo.webp";

import MieleCategory_1 from "@/assets/images/static/brands/Miele/Miele_Washers_1.webp";
import MieleCategory_2 from "@/assets/images/static/brands/Miele/Miele_Dishwashers_2.webp";
import MieleCategory_3 from "@/assets/images/static/brands/Miele/Miele_Microwaves_3.webp";

import PremierbannerImg from "@/assets/images/static/brands/Premier/Premier_hero.webp";
import PremierlogoImg from "@/assets/images/static/brands/Premier/Premier_logo.webp";

import PremierCategory_1 from "@/assets/images/static/brands/Premier/Premier_Ranges_1.webp";

import Samsung_AppliancesbannerImg from "@/assets/images/static/brands/Samsung_Appliances/Samsung_hero.webp";
import Samsung_ApplianceslogoImg from "@/assets/images/static/brands/Samsung_Appliances/Samsung_logo.webp";

import Samsung_AppliancesCategory_1 from "@/assets/images/static/brands/Samsung_Appliances/Samsung_Refrigerators_1.webp";
import Samsung_AppliancesCategory_2 from "@/assets/images/static/brands/Samsung_Appliances/Samsung_Ranges_2.webp";
import Samsung_AppliancesCategory_3 from "@/assets/images/static/brands/Samsung_Appliances/Samsung_Washers_3.webp";
import Samsung_AppliancesCategory_4 from "@/assets/images/static/brands/Samsung_Appliances/Samsung_Dishwashers_4.webp";

import SharpbannerImg from "@/assets/images/static/brands/Sharp/Sharp_hero.webp";
import SharplogoImg from "@/assets/images/static/brands/Sharp/Sharp_logo.webp";

import SharpCategory_1 from "@/assets/images/static/brands/Sharp/Sharp_Microwaves_1.webp";
import SharpCategory_2 from "@/assets/images/static/brands/Sharp/Sharp_WallOvens_2.webp";
import SharpCategory_3 from "@/assets/images/static/brands/Sharp/Sharp_Cooktops_3.webp";

import SignatureKitchenbannerImg from "@/assets/images/static/brands/SignatureKitchen/SignatureKitchenSuite_hero.webp";
import SignatureKitchenSuitelogoImg from "@/assets/images/static/brands/SignatureKitchen/SignatureKitchenSuite_logo.webp"; 

import SignatureKitchenSuiteCategory_1 from "@/assets/images/static/brands/SignatureKitchen/SignatureKitchenSuite_Refrigerators_1.webp";
import SignatureKitchenSuiteCategory_2 from "@/assets/images/static/brands/SignatureKitchen/SignatureKitchenSuite_Ranges_2.webp";
import SignatureKitchenSuiteCategory_3 from "@/assets/images/static/brands/SignatureKitchen/SignatureKitchenSuite_Dishwashers_3.webp";

import SpeedQueenbannerImg from "@/assets/images/static/brands/Speed_Queen/SpeedQueen_hero.webp";
import SpeedQueenlogoImg from "@/assets/images/static/brands/Speed_Queen/SpeedQueen_logo.webp";

import SpeedQueenCategory_1 from "@/assets/images/static/brands/Speed_Queen/SpeedQueen_TopLoadWashers_1.webp";
import SpeedQueenCategory_2 from "@/assets/images/static/brands/Speed_Queen/SpeedQueen_FrontLoadWashers_2.webp";
import SpeedQueenCategory_3 from "@/assets/images/static/brands/Speed_Queen/SpeedQueen_Dryers_3.webp";
import SpeedQueenCategory_4 from "@/assets/images/static/brands/Speed_Queen/SpeedQueen_LaundryCenters_4.webp";

import SummitbannerImg from "@/assets/images/static/brands/Summit/Summit_hero.webp";
import SummitlogoImg from "@/assets/images/static/brands/Summit/Summit_logo.webp";

import SummitCategory_1 from "@/assets/images/static/brands/Summit/Summit_Dishwashers_1.webp";
import SummitCategory_2 from "@/assets/images/static/brands/Summit/Summit_Cooktops_2.webp";
import SummitCategory_3 from "@/assets/images/static/brands/Summit/Summit_Refrigerators_3.webp";
import SummitCategory_4 from "@/assets/images/static/brands/Summit/Summit_WasherDryerCombos_4.webp";

import ThermadorbannerImg from "@/assets/images/static/brands/Thermador/Thermador_hero.webp";
import ThermadorlogoImg from "@/assets/images/static/brands/Thermador/Thermador_logo.webp"; 

import ThermadorCategory_1 from "@/assets/images/static/brands/Thermador/Thermador_Refrigerators_1.webp";
import ThermadorCategory_2 from "@/assets/images/static/brands/Thermador/Thermador_Ranges_2.webp";
import ThermadorCategory_3 from "@/assets/images/static/brands/Thermador/Thermador_Dishwashers_3.webp";

import ThorKitchenbannerImg from "@/assets/images/static/brands/Thor_Kitchen/ThorKitchen_hero.webp";
import ThorKitchenlogoImg from "@/assets/images/static/brands/Thor_Kitchen/ThorKitchen_logo.webp";

import ThorKitchenCategory_1 from "@/assets/images/static/brands/Thor_Kitchen/ThorKitchen_Ranges_1.webp";
import ThorKitchenCategory_2 from "@/assets/images/static/brands/Thor_Kitchen/ThorKitchen_WineCoolers_2.webp";
import ThorKitchenCategory_3 from "@/assets/images/static/brands/Thor_Kitchen/ThorKitchen_Dishwashers_3.webp";

import UlinebannerImg from "@/assets/images/static/brands/U_Line/Uline_hero.webp";
import UlinelogoImg from "@/assets/images/static/brands/U_Line/Uline_logo.webp";

import UlineCategory_1 from "@/assets/images/static/brands/U_Line/Uline_BeverageCenters_1.webp";
import UlineCategory_2 from "@/assets/images/static/brands/U_Line/Uline_IceMakers_2.webp";
import UlineCategory_3 from "@/assets/images/static/brands/U_Line/Uline_WineCoolers_3.webp";
import UlineCategory_4 from "@/assets/images/static/brands/U_Line/Uline_BeerCoolers&Kegerators_4.webp";

import UniqueAppliancesbannerImg from "@/assets/images/static/brands/Unique/Unique_hero.webp";
import UniqueApplianceslogoImg from "@/assets/images/static/brands/Unique/Unique_logo.webp";

import UniqueAppliancesCategory_1 from "@/assets/images/static/brands/Unique/Unique_Refrigerators_1.webp";
import UniqueAppliancesCategory_2 from "@/assets/images/static/brands/Unique/Unique_RangeHoods_2.webp";
import UniqueAppliancesCategory_3 from "@/assets/images/static/brands/Unique/Unique_Dishwashers_3.webp";

import Vent_A_HoodbannerImg from "@/assets/images/static/brands/Vent_A_Hood/VentaHood_hero.webp";
import Vent_A_HoodlogoImg from "@/assets/images/static/brands/Vent_A_Hood/Vent A Hood_logo.webp";

import Vent_A_HoodCategory_1 from "@/assets/images/static/brands/Vent_A_Hood/VentAHood_InsertRangeHoods_1.webp";
import Vent_A_HoodCategory_2 from "@/assets/images/static/brands/Vent_A_Hood/VentAHood_UnderCabinetRangeHoods_2.webp";
import Vent_A_HoodCategory_3 from "@/assets/images/static/brands/Vent_A_Hood/VentAHood_WallMountedRangeHoods_3.webp";
import Vent_A_HoodCategory_4 from "@/assets/images/static/brands/Vent_A_Hood/VentAHood_IslandRangeHoods_4.webp";

import VikingbannerImg from "@/assets/images/static/brands/Viking/Viking_hero.webp";
import VikinglogoImg from "@/assets/images/static/brands/Viking/Viking_logo.webp";

import VikingCategory_1 from "@/assets/images/static/brands/Viking/Viking_Cooktops_1.webp";
import VikingCategory_2 from "@/assets/images/static/brands/Viking/Viking_Refrigerators_2.webp";
import VikingCategory_3 from "@/assets/images/static/brands/Viking/Viking_Dishwashers_3.webp";
import VikingCategory_4 from "@/assets/images/static/brands/Viking/Viking_Ranges_4.webp";

import WolfbannerImg from "@/assets/images/static/brands/Wolf/WSC_hero.webp";
import WolflogoImg from "@/assets/images/static/brands/Wolf/wolf-sub-zero-cove_logo.webp";

import WolfCategory_1 from "@/assets/images/static/brands/Wolf/SUBZERO_REFRIGERATION.webp";
import WolfCategory_2 from "@/assets/images/static/brands/Wolf/COVE_DISHWASHING.webp";
import WolfCategory_3 from "@/assets/images/static/brands/Wolf/WOLF_COOKING.webp";

import WhirlpoolbannerImg from "@/assets/images/static/brands/Whirlpool/Whirlpool_hero.webp";
import WhirlpoollogoImg from "@/assets/images/static/brands/Whirlpool/Whirlpool_logo.webp";

import WhirlpoolCategory_1 from "@/assets/images/static/brands/Whirlpool/Whirlpool_Dryers_1.webp";
import WhirlpoolCategory_2 from "@/assets/images/static/brands/Whirlpool/Whirlpool_Refrigerators_2.webp";
import WhirlpoolCategory_3 from "@/assets/images/static/brands/Whirlpool/Whirlpool_Dishwashers_3.webp";
import WhirlpoolCategory_4 from "@/assets/images/static/brands/Whirlpool/Whirlpool_Cooktops_4.webp";

import ZephyrbannerImg from "@/assets/images/static/brands/Zephyr/Zephyr_hero.webp";
import ZephyrlogoImg from "@/assets/images/static/brands/Zephyr/Zephyr_logo.webp";

import ZephyrCategory_1 from "@/assets/images/static/brands/Zephyr/Zephyr_RangeHoods_1.webp";
import ZephyrCategory_2 from "@/assets/images/static/brands/Zephyr/Zephyr_Refrigerators_2.webp";

import ZlinebannerImg from "@/assets/images/static/brands/Zline/Zline_hero.webp";
import ZlinelogoImg from "@/assets/images/static/brands/Zline/Zline_logo.webp";

import ZlineCategory_1 from "@/assets/images/static/brands/Zline/Zline_Ranges_1.webp";
import ZlineCategory_2 from "@/assets/images/static/brands/Zline/Zline_Refrigerators_2.webp";
import ZlineCategory_3 from "@/assets/images/static/brands/Zline/Zline_Dishwashers_3.webp";
import ZlineCategory_4 from "@/assets/images/static/brands/Zline/Zline_WallOvens_4.webp";
import ZlineCategory_5 from "@/assets/images/static/brands/Zline/Zline_Cooktops_5.webp";
import ZlineCategory_6 from "@/assets/images/static/brands/Zline/Zline_RangeHoods_6.webp";
import ZlineCategory_7 from "@/assets/images/static/brands/Zline/Zline_Microwaves_7.webp";

import JennairbannerImg from "@/assets/images/static/brands/Jennair/Jennair_hero.webp";
import JennairlogoImg from "@/assets/images/static/brands/Jennair/Jennair_logo.webp"; 

import JennairCategory_1 from "@/assets/images/static/brands/Jennair/Jennair_Ranges_1.webp";
import JennairCategory_2 from "@/assets/images/static/brands/Jennair/Jennair_Refrigerators_2.webp";
import JennairCategory_3 from "@/assets/images/static/brands/Jennair/Jennair_Dishwashers_3.webp";

import LiebherrbannerImg from "@/assets/images/static/brands/Liebherr/Liebherr_hero.webp";
import LiebherrlogoImg from "@/assets/images/static/brands/Liebherr/Liebherr_logo.webp"; 

import LiebherrOption_1 from "@/assets/images/static/brands/Liebherr/Liebherr_FrenchDoorRefrigerators_1.webp";
import LiebherrOption_2 from "@/assets/images/static/brands/Liebherr/Liebherr_BottomFreezerRefrigerators_2.webp";
import LiebherrOption_3 from "@/assets/images/static/brands/Liebherr/Liebherr_WineCoolers_3.webp";
import LiebherrOption_4 from "@/assets/images/static/brands/Liebherr/Liebherr_Freezers_4.webp";


import MonogrambannerImg from "@/assets/images/static/brands/Monogram/Monogram_hero.webp";
import MonogramlogoImg from "@/assets/images/static/brands/Monogram/Monogram_logo.webp";

import MonogramOption_1 from "@/assets/images/static/brands/Monogram/Monogram_Ranges_1.webp";
import MonogramOption_2 from "@/assets/images/static/brands/Monogram/Monogram_Refrigerators_2.webp";
import MonogramOption_3 from "@/assets/images/static/brands/Monogram/Monogram_WallOvens_3.webp";
import MonogramOption_4 from "@/assets/images/static/brands/Monogram/Monogram_Dishwashers_4.webp";
import MonogramOption_5 from "@/assets/images/static/brands/Monogram/Monogram_Cooktops_5.webp";


import HotpointbannerImg from "@/assets/images/static/brands/Hotpoint/Hotpoint_hero.webp";
import HotpointlogoImg from "@/assets/images/static/brands/Hotpoint/Hotpoint_logo.webp";

import HotpointOption_1 from "@/assets/images/static/brands/Hotpoint/Hotpoint_Ranges_1.webp";
import HotpointOption_2 from "@/assets/images/static/brands/Hotpoint/Hotpoint_Refrigerators_2.webp";
import HotpointOption_3 from "@/assets/images/static/brands/Hotpoint/Hotpoint_Dishwashers_3.webp";
import HotpointOption_4 from "@/assets/images/static/brands/Hotpoint/Hotpoint_Microwaves_4.webp";
import HotpointOption_5 from "@/assets/images/static/brands/Hotpoint/Hotpoint_Laundry_5.webp"; 
 
import HaierbannerImg from "@/assets/images/static/brands/Haier/Haier_hero.webp";
import HaierlogoImg from "@/assets/images/static/brands/Haier/Haier_logo.webp";

import HaierOption_1 from "@/assets/images/static/brands/Haier/Haier_Ranges_1.webp";
import HaierOption_2 from "@/assets/images/static/brands/Haier/Haier_Refrigerators_2.webp";
import HaierOption_3 from "@/assets/images/static/brands/Haier/Haier_Dishwashers_3.webp";
import HaierOption_4 from "@/assets/images/static/brands/Haier/Haier_Microwaves_4.webp"; 
 
import CafebannerImg from "@/assets/images/static/brands/Cafe/Cafe_hero.webp";
import CafelogoImg from "@/assets/images/static/brands/Cafe/Cafe_logo.webp";

import CafeOption_1 from "@/assets/images/static/brands/Cafe/Cafe_Ranges_1.webp";
import CafeOption_2 from "@/assets/images/static/brands/Cafe/Cafe_Refrigerators_2.webp";
import CafeOption_3 from "@/assets/images/static/brands/Cafe/Cafe_WallOvens_3.webp";
import CafeOption_4 from "@/assets/images/static/brands/Cafe/Cafe_Dishwashers_4.webp";
import CafeOption_5 from "@/assets/images/static/brands/Cafe/Cafe_Cooktops_5.webp";

import trueResidential_hero from "@/assets/images/static/brands/TrueResidential/TrueResidential_hero.webp";
import TrueResidential_logo from "@/assets/images/static/brands/TrueResidential/TrueResidential_logo.webp"
import TrueResidential_SidebySideRefrigerators_1 from "@/assets/images/static/brands/TrueResidential/TrueResidential_SidebySideRefrigerators_1.webp";
import TrueResidential_BottomFreezerRefrigerators_2 from "@/assets/images/static/brands/TrueResidential/TrueResidential_BottomFreezerRefrigerators_2.webp";
import TrueResidential_ColumnRefrigerators_3 from "@/assets/images/static/brands/TrueResidential/TrueResidential_ColumnRefrigerators_3.webp";
import TrueResidential_UnderCounterRefrigerators_4 from "@/assets/images/static/brands/TrueResidential/TrueResidential_UnderCounterRefrigerators_4.webp";
import TrueResidential_IceMakers_5 from "@/assets/images/static/brands/TrueResidential/TrueResidential_IceMakers_5.webp";
import { Content } from "next/font/google";

import GE_AppliancesbannerImg from "@/assets/images/static/brands/GEAppliances/GE_hero.webp";
import GE_ApplianceslogoImg from "@/assets/images/static/brands/GEAppliances/GE_logo.webp";

import GE_AppliancesOption_1 from "@/assets/images/static/brands/GEAppliances/GE_Ranges_1.webp";
import GE_AppliancesOption_2 from "@/assets/images/static/brands/GEAppliances/GE_Refrigerators_2.webp";
import GE_AppliancesOption_3 from "@/assets/images/static/brands/GEAppliances/GE_WallOvens_3.webp";
import GE_AppliancesOption_4 from "@/assets/images/static/brands/GEAppliances/GE_Dishwashers_4.webp";
import GE_AppliancesOption_5 from "@/assets/images/static/brands/GEAppliances/GE_Laundry_5.webp";
import GE_AppliancesOption_6 from "@/assets/images/static/brands/GEAppliances/GE_Microwaves_6.webp";
 
import GE_ProfilebannerImg from "@/assets/images/static/brands/GEProfile/GEProfile_hero.webp";
import GE_ProfilelogoImg from "@/assets/images/static/brands/GEProfile/GEProfile_logo.webp";

import GE_ProfileOption_1 from "@/assets/images/static/brands/GEProfile/GEProfile_Ranges_1.webp";
import GE_ProfileOption_2 from "@/assets/images/static/brands/GEProfile/GEProfile_Refrigerators_2.webp";
import GE_ProfileOption_3 from "@/assets/images/static/brands/GEProfile/GEProfile_WallOvens_3.webp";
import GE_ProfileOption_4 from "@/assets/images/static/brands/GEProfile/GEProfile_Dishwashers_4.webp";
import GE_ProfileOption_5 from "@/assets/images/static/brands/GEProfile/GEProfile_Cooktops_5.webp";
import GE_ProfileOption_6 from "@/assets/images/static/brands/GEProfile/GEProfile_Laundry_6.webp";
 

export const allBrandList = [ 
  {
    Amana: {
      id: 11,
      title: "Amana",  
      videoLink: "https://www.youtube.com/watch?v=Ys69xGegyI0",
      BannerData: {
        subheading: "Just Right",
        descriptionTxt:
          "Provides simple, dependable appliances with practical features at an affordable price.",
        bannerImg: AmanabannerImg,
        logoImg: AmanalogoImg,
      },
      brandOptions: [
        { 
          img: AmanaCategory_1,
          title:'Ranges',
          slug: '/all-brands/amana/ranges',
         },       
        { 
          img: AmanaCategory_2,
          title:'Refrigerators', 
          slug: '/all-brands/amana/refrigerators',
        },
          
        { 
          img: AmanaoCategory_3,
          title:'Dryers', 
          slug: '/all-brands/amana/laundry/dryers',
        },
        { 
          img: AmanaoCategory_4,
          title:'Dishwashers',
          slug: '/all-brands/amana/dishwashers',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Amana is a trusted name in home appliances, known for offering affordable and reliable products designed to make life easier. At Airport Appliance, we carry a wide selection of Amana products, including cooktops, refrigerators, ranges, laundry appliances, and microwaves."
        },
        {        
          mainHeading: "Why Choose Amana Appliances?",
          title: "Amana Cooktops:",        
          descriptionTxt : "Whether you prefer gas or electric, Amana cooktops deliver the performance and ease you need to cook your favorite meals. Designed to be durable and easy to clean, they are perfect for everyday cooking in busy homes."
        },
        {        
          mainHeading: "",
          title: "Amana Refrigerators:",        
          descriptionTxt : "With Amana’s energy-efficient refrigerators, you can keep your food fresh and organized. Offering a range of styles, including top-freezer and side-by-side models, these refrigerators are built for convenience and designed to fit seamlessly into your kitchen."
        },
        {        
          mainHeading: "",
          title: "Amana Ranges:",        
          descriptionTxt : "Amana ranges offer both gas and electric options, providing flexibility for all types of cooking. Whether you’re preparing a family meal or simply reheating leftovers, Amana’s dependable performance and easy-to-use controls will make your cooking experience smooth and efficient."
        },
        {        
          mainHeading: "",
          title: "Amana Laundry Appliances:",        
          descriptionTxt : "Amana washers and dryers are built to handle large loads, making laundry day a breeze. With energy-efficient options and reliable performance, you can count on these appliances to tackle your laundry needs, no matter how big the job."
        },
        {        
          mainHeading: "",
          title: "Amana Microwaves:",        
          descriptionTxt : "Amana microwaves are perfect for busy families looking for quick, convenient cooking. From reheating meals to cooking from scratch, Amana’s microwaves are designed to be fast, efficient, and easy to use."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full range of Amana home appliances at Airport Appliance. Whether you’re outfitting your kitchen or upgrading your laundry room, we have the perfect solution to meet your needs. Affordable, reliable, and built to last—Amana appliances are a smart choice for any home."
        },
      ]
    },
  },
  {
    Smeg: {
      id: 28,
      title: "Smeg",  
    },
  },
  {
    Waste_King: {
      id: 57,
      title: "Waste King",   
    },
  },
  {
    Azure_Refrigeration: {
      id: 159,
      title: "Azure Refrigeration",  
    },
  },
  {
    Asko: {
      id: 35,
      title: "Asko Appliances",
      videoLink: "https://www.youtube.com/watch?v=rtjjvHUOaRM",
      BannerData: {
        subheading: "Inspired by Scandinavia",
        descriptionTxt:
          "Offers Scandinavian-inspired appliances that focus on minimalist design, durability, and environmental sustainability.",
        bannerImg: AskobannerImg,
        logoImg: AskologoImg,
      },
      brandOptions: [
        { 
          img: AskoCategory_1,
          title:'Washers',
          slug: '/all-brands/asko/laundry/washers',
         },       
        { 
          img: AskoCategory_2,
          title:'Dishwashers',
          slug: '/all-brands/asko/dishwashers',
        },
        { 
          img: AskoCategory_3,
          title:'Refrigerators', 
          slug: '/all-brands/asko/refrigerators/all-refrigerators',
        }
      ],
      collectionList: [
        {
          title:"Asko Extended 5-Year Limited Warranty Promotion",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=PKVPTDHB.pdf",
          descriptionTxt : "Receive a 5-Year Limited Warranty on select Asko Dishwashers.",
          validDate:"valid from 10/1/2023 to 12/31/2024"
        },
        {
          title:"Asko $150 Dishwasher Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=WGDJXMJL.pdf",
          descriptionTxt : "Receive a $150 rebate with purchase of select Asko Dishwashers.",
          validDate:"valid from 01/01/2024 to 12/31/2024"
        },
        {
          title:"Asko Wine Climate Cabinet Promotion",
          img:'',
          link: "",
          pdf: "https://www.airportappliance.com/pub/media/pdfs/ASKO_EXT5YR_WARRANTY_2024.pdf",
          descriptionTxt : "Receive a FREE Orrefors Wine Decanter with purchase of an Asko Wine Climate Cabinet.",
          validDate:"valid from 01/01/2024 to 12/31/2024"
        },
        {
          title:"Asko 10 Year Steel Seal Warranty Rebate",
          img:'',
          link: "",
          pdf: "https://airportappliance.com/pub/media/pdfs/Asko_SAVE_150-1.pdf?_gl=1*bpc8gk*_gcl_au*MzU4ODE5MjQxLjE3MzUxMzMzMDk.*_ga*NDQxNzc2MjkyLjE3MjczNTQzOTQ.*_ga_XN7LWN00D8*MTczNTIxMTY3Mi4xNTQuMS4xNzM1MjEyNjM5LjQzLjAuMTA0MjYzMDExNQ..",
          descriptionTxt : "Purchase a qualifying Asko Washing Machine and receive a free 10 Year Steel Seal Warranty.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Asko 10 Year Steel Seal Warranty Rebate",
          img:'',
          link: "",
          pdf: "https://airportappliance.com/pub/media/pdfs/ASKO_DECANTER_PROMO.pdf?_gl=1*1ql7okk*_gcl_au*MzU4ODE5MjQxLjE3MzUxMzMzMDk.*_ga*NDQxNzc2MjkyLjE3MjczNTQzOTQ.*_ga_XN7LWN00D8*MTczNTIxMTY3Mi4xNTQuMS4xNzM1MjEyNjk2LjYwLjAuMTA0MjYzMDExNQ..",
          descriptionTxt : "Purchase a qualifying Asko Washing Machine and receive a free 10 Year Steel Seal Warranty.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Asko 50 Series Dishwasher Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=ILBMDWGR.pdf",
          descriptionTxt : "Receive up to a $350 rebate with purchase of qualifying Asko Dishwasher.",
          validDate:"valid from 5/10/2024 to 12/31/2024"
        },
        {
          title:"Asko Free Decanter Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=VWLMEAES.pdf",
          descriptionTxt : "Receive a Free Decanter with purchase of qualifying Asko Wine Climate Cabinet.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "Elevate Your Home with Asko Luxury Appliances",          
          descriptionTxt : "Asko brings Scandinavian elegance and precision engineering to your home with its range of premium dishwashers and laundry appliances. Known for their sleek designs and exceptional functionality, Asko appliances deliver high performance while enhancing the aesthetic appeal of your home.."
        },
        {        
          mainHeading: "",
          title: "Innovative Dishwashers:",        
          descriptionTxt : "Experience sparkling clean dishes with Asko's innovative dishwashers. Equipped with advanced features like Turbo Drying™ and multiple cleaning cycles, Asko dishwashers ensure impeccable results while operating quietly. Their durable stainless-steel interiors and ergonomic designs make them a reliable choice for modern kitchens."
        },
        {        
          mainHeading: "",
          title: "Superior Laundry Solutions:",        
          descriptionTxt : "Asko laundry appliances are designed to handle your laundry needs with care and efficiency. From washing machines with Quattro™ suspension systems to tumble dryers with gentle air technology, these appliances protect your fabrics while providing powerful cleaning and drying performance."
        },
        {        
          mainHeading: "",
          title: "Why Choose Asko?",        
          descriptionTxt : "- Luxury Meets Functionality: Sleek Scandinavian designs that complement your home."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "- Durable Materials: Built with robust stainless steel for lasting reliability."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "- Eco-Friendly Innovation: Energy-efficient technologies that reduce environmental impact."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Transform your daily chores into a luxury experience with Asko. Shop now at Airport Appliance and discover how Asko appliances combine sophistication and performance to redefine your home."
        },
      ]
    },
  },
  {
    Avanti: {
      id: 158,
      title: "Avanti",
      videoLink: "https://www.youtube.com/watch?v=7dURGwVueH4",
      BannerData: {
        subheading: "Quality and Style for Every Space",
        descriptionTxt:
          "Offers compact, stylish appliances with a focus on space efficiency and affordability.",
        bannerImg: AvantibannerImg,
        logoImg: AvantilogoImg,
      },
      brandOptions: [
        { 
          img: AvantiCategory_1,
          title:'Ranges',
          slug: '/all-brands/avanti/ranges',
         },       
        { 
          img: AvantiCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/avanti/refrigerators',
        },
        { 
          img: AvantiCategory_3,
          title:'Washers', 
          slug: '/all-brands/avanti/laundry/washers',
        },
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Avanti is a brand known for offering compact and efficient appliances that don’t compromise on performance. At Airport Appliance, we carry a selection of Avanti products, including dishwashers and ranges, perfect for smaller homes, apartments, or anyone looking for high-quality appliances in a more compact form."
        },
        {        
          mainHeading: "Why Choose Avanti Appliances?",
          title: "Avanti Dishwashers:",        
          descriptionTxt : "Avanti dishwashers are designed to fit in tight spaces while still providing powerful cleaning performance. These dishwashers are ideal for homes with limited kitchen space, delivering convenience and efficiency with every load. Whether you're washing delicate dishes or tough pots and pans, Avanti dishwashers have the versatility to get the job done."
        },
        {        
          mainHeading: "",
          title: "Avanti Ranges:",        
          descriptionTxt : "Avanti ranges combine style and functionality, providing electric and gas options to suit your cooking needs. With features like easy-to-use controls and durable construction, Avanti ranges are built to handle everyday cooking tasks. Whether you’re whipping up a family meal or preparing a quick snack, these ranges offer reliable performance without taking up too much space."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full range of Avanti home appliances at Airport Appliance. Perfect for compact kitchens and homes looking for smart, space-saving solutions, Avanti appliances are affordable, reliable, and designed to last."
        },       
      ]
    },
  },
  {
    Beko: {
      id: 22,
      title: "Beko Appliances",
      videoLink: "https://www.youtube.com/watch?v=3Zf8dTXpFHQ",
      BannerData: {
        subheading: 'Healthy living',
        descriptionTxt:'Recognized for eco-friendly innovations and efficient, affordable appliances that promote healthy living.',
        bannerImg: BekobannerImg,
        logoImg: BekologoImg,
      },
      brandOptions: [
        { 
          img: BekoCategory_1,
          title:'Refrigerator',
          slug: '/all-brands/beko/refrigerators',
        },       
        { 
          img: BekoCategory_2,
          title:'Dryer',
          slug: '/all-brands/beko/laundry/dryers',
        },
        { 
          img: BekoCategory_3,
          title:'Cooktops',
          slug: '/all-brands/beko/cooktops',
        },
        { 
          img: BekoCategory_4,
          title:'Dishwashers',
          slug: '/all-brands/beko/dishwashers',
        }      
      ],
      collectionList: [
        {
          title:"Beko Pro Kitchen Suite Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=CMUJKELE.pdf",
          descriptionTxt : "Receive up to a $500 rebate with purchase of qualifying Beko Appliances.",
          validDate:"valid from 4/15/2024 to 12/31/2024"
        },
        {
          title:"Beko Delivery Or Installation Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=CMS&FORM_NUMBER=523315",
          descriptionTxt : "Receive up to a $100 Delivery or Installation rebate with purchase of qualifying Beko Dishwasher.",
          validDate:"valid from 7/11/2024 to 12/31/2024"
        },
        {
          title:"Beko Kitchen Suite Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=XHCRBCLS.pdf",
          descriptionTxt : "Receive up to a $400 rebate with purchase of qualifying Beko Appliances.",
          validDate:"valid from 4/15/2024 to 12/31/2024"
        },
        {
          title:"Beko Dishwasher Installation Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=YIUMFLXO.pdf",
          descriptionTxt : "Receive up to a $100 installation rebate with purchase of qualifying Beko Dishwasher.",
          validDate:"valid from 7/11/2024 to 12/31/2024"
        },
        {
          title:"Beko Fit Guarantee Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=CQRCNZAG.pdf",
          descriptionTxt : "Receive up to a $300 installation rebate with purchase of qualifying Beko Wall Oven.",
          validDate:"valid from 4/15/2024 to 12/31/2024"
        },
        {
          title:"Beko Refrigerator Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=OYCMQKFG.pdf",
          descriptionTxt : "Receive up to a $150 rebate with purchase of qualifying Beko Refrigerator.",
          validDate:"valid from 4/15/2024 to 12/31/2024"
        }
      ],
      contentList:[
       {        
         mainHeading: "",
         title: "",          
         descriptionTxt : "Beko is a leading global brand known for its commitment to delivering high-performance, energy-efficient appliances that enhance everyday living. At Airport Appliance, we proudly offer a selection of Beko products, including ovens, dishwashers, refrigerators, ranges, and cooktops. Beko appliances are designed to fit seamlessly into modern homes while offering reliable, cutting-edge technology."
       },
       {        
         mainHeading: "Why Choose Beko Appliances?",
         title: "Beko Ovens:",        
         descriptionTxt : "Beko ovens provide innovative cooking features that help you prepare meals with ease. Whether you're baking, broiling, or roasting, these ovens offer consistent performance with advanced functions like self-cleaning and multi-functional cooking modes. Perfect for any kitchen, Beko ovens are designed to make cooking more convenient and efficient."
       },
       {        
         mainHeading: "",
         title: "Beko Dishwashers:",        
         descriptionTxt : "Say goodbye to dishwashing stress with Beko dishwashers. Known for their quiet operation and excellent cleaning power, Beko dishwashers feature a variety of wash cycles to handle everything from delicate china to heavily soiled pots. With energy-efficient options, Beko dishwashers not only save you time but also conserve water and energy."
       },
       {        
         mainHeading: "",
         title: "Beko Refrigerators:",        
         descriptionTxt : "Beko refrigerators combine style, innovation, and energy efficiency. With spacious interiors and smart features like adjustable shelves and temperature zones, these refrigerators are built to keep your food fresh and organized. Whether you need a top-freezer, French door, or bottom-freezer model, Beko offers a wide range of refrigerators to suit your kitchen needs."
       },
       {        
         mainHeading: "",
         title: "Beko Ranges:",        
         descriptionTxt : "Beko ranges bring flexibility and precision to your cooking. With both gas and electric options, these ranges feature powerful burners, convection ovens, and sleek designs that complement any kitchen. Beko ranges provide excellent heat control, making them perfect for both everyday meals and gourmet cooking.."
       },
       {        
         mainHeading: "",
         title: "Beko Cooktops:",        
         descriptionTxt : "Beko cooktops offer efficient cooking performance with a variety of styles, including gas, electric, and induction. Their responsive heat control and easy-to-clean surfaces make them a popular choice for busy kitchens. Whether you're searing, simmering, or boiling, Beko cooktops provide the reliability and precision you need."
       },
       {        
         mainHeading: "",
         title: "",        
         descriptionTxt : "Explore the full range of Beko home appliances at Airport Appliance. Whether you’re upgrading your kitchen or outfitting a new home, Beko appliances deliver reliable performance and modern features at an affordable price. Built to last and designed to meet your everyday needs, Beko appliances are a smart choice for any home."
       }
     ]
    },
  },
  {
    Bertazzoni: {
      id: 40,
      title: "Bertazzoni",
      videoLink: "https://www.youtube.com/watch?v=RJJn7aq1_PA",
      BannerData: {
        subheading: "Cooking Beautifully",
        descriptionTxt:
          "Celebrates Italian craftsmanship with beautifully designed, high-performance cooking appliances.",
        bannerImg: BertazzonibannerImg,
        logoImg: BertazzonilogoImg,
      },
      brandOptions: [
        { 
          img: BertazzoniCategory_1,
          title:'Microwaves',
          slug: '/all-brands/bertazzoni/microwaves-otr',
          imageFlag: true,

        },       
        { 
          img: BertazzoniCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/bertazzoni/refrigerators',
        },
        { 
          img: BertazzoniCategory_3,
          title:'Dishwashers', 
          slug: '/all-brands/bertazzoni/dishwashers',
        },
      ],
      collectionList: [
        {
          title:"Bertazzoni",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=HVTAFRHL.pdf",
          descriptionTxt : "Designed with you in mind, Liebherr's Monolith line represents the pinnacle of 65 years of refrigeration innovation and expertise, offering unmatched performance, cutting-edge technology, and sleek design to elevate your kitchen experience.",
          validDate:"valid from 10/1/2023 to 12/31/2024"
        },
        {
          title:"Bertazzoni",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=UKXIVGCW.pdf",
          descriptionTxt : "Say goodbye to the ordinary and embrace the extraordinary with Liebherr's OpenStage Drawers. Inspired by fine delicatessen displays, these transparent drawers offer a clear, ergonomic view of all your fridge’s contents, setting a new standard in both design and convenience.",
          validDate:"valid from 10/1/2023 to 12/31/2024"
        }
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "Bertazzoni: Our Luxury Partner",          
          descriptionTxt: "Bertazzoni Appliances represent the pinnacle of luxury and performance, seamlessly blending Italian craftsmanship with modern innovation. As one of our distinguished luxury partners, Bertazzoni offers high-performance solutions that redefine kitchen elegance and functionality."
        },
        {        
          mainHeading: "Why Choose Bertazzoni Luxury Appliances?",
          title: "Luxury Ranges for Culinary Excellence",          
          descriptionTxt : (
            <>
              <Link 
                href="/all-brands/bertazzoni/ranges" 
                className="text-blue5 cursor-pointer"
              >
                Bertazzoni ranges
              </Link>{" "}
              combine precision, durability, and style to empower your cooking endeavors. With spacious ovens, even heating, and advanced temperature controls, these ranges allow you to create gourmet dishes effortlessly.
            </>
          )
        },
        {        
          mainHeading: "",
          title: "Sleek and Spacious Refrigerators",          
          descriptionTxt : (
            <>             
              Designed for freshness and style, {" "}
              <Link 
                href="/all-brands/bertazzoni/refrigerators" 
                className="text-blue5 cursor-pointer"
              >
                Bertazzoni refrigerators
              </Link>{" "}
               deliver exceptional cooling with flexible storage options. Their contemporary designs and innovative features add sophistication to any kitchen.
            </>
          )         
        },
        {        
          mainHeading: "",
          title: "Range Hoods: Performance Meets Elegance",     
          descriptionTxt : (
            <> 
              <Link 
                href="/all-brands/bertazzoni/range-hoods" 
                className="text-blue5 cursor-pointer"
              >
                Bertazzoni range hoods
              </Link>{" "}
              are built for efficiency, offering powerful ventilation that keeps your kitchen clean and odor-free. Their refined designs complement luxury kitchens perfectly.
            </>
          )       
        },
        {        
          mainHeading: "",
          title: "Precision Cooktops and Wall Ovens",   
          descriptionTxt : (
            <> 
             Crafted for modern culinary needs,{" "}
              <Link 
                href="/all-brands/bertazzoni/cooktops" 
                className="text-blue5 cursor-pointer"
              >
                Bertazzoni cooktops
              </Link>{" "}
              and wall ovens provide precise controls and professional-level performance, making every cooking session enjoyable and efficient.
            </>
          )          
        },
        {        
          mainHeading: "",
          title: "Dishwashers with Impeccable Cleaning Power",     
          descriptionTxt : (
            <> 
              <Link 
                href="/all-brands/bertazzoni/dishwashers"  
                className="text-blue5 cursor-pointer"
              >
               Bertazzoni dishwashers
              </Link>{" "}
              deliver outstanding cleaning with quiet operation and sleek aesthetics. They integrate seamlessly into your luxury kitchen, maintaining a refined appearance while providing top-tier functionality.
            </>
          )
        },
        {        
          mainHeading: "",
          title: "Freezers, Ice Makers, and More",     
          descriptionTxt : (
            <> 
            From stylish {" "}
              <Link 
                href="/all-brands/bertazzoni/freezers"  
                className="text-blue5 cursor-pointer"
              >
               freezers
              </Link>{" "}
              to innovative ice makers, Bertazzoni offers solutions tailored to your kitchen’s needs. These appliances combine convenience with timeless elegance.
            </>
          )
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Transform your kitchen into a masterpiece of luxury with Bertazzoni Appliances. As a proud luxury partner, Airport Appliance provides a curated selection of Bertazzoni products that merge unmatched quality and Italian sophistication. Shop now and bring your culinary vision to life with Bertazzoni."
        },
      ]
    },
  }, 
  {
    Best_Ventillation: {
      id: 5,
      title: "Best Ventilation",
      videoLink: "https://www.youtube.com/watch?v=S6FXcDZpuc0",
      BannerData: {
        subheading: "Performance that Inspires",
        descriptionTxt:
          "Transforms kitchens with sleek, powerful, and whisper-quiet range hoods, blending cutting-edge technology with unmatched craftsmanship for a superior cooking experience.",
        bannerImg: BestVentilationbannerImg,
        logoImg: BestVentilationlogoImg,
      },
      brandOptions: [
        { 
          img: BestVentilationCategory_1,
          title:'Downdraft Range Hoods',
          slug: '/all-brands/best-ventillation/range-hoods/downdraft-range-hoods',
          imageFlag: true
        },       
        { 
          img: BestVentilationCategory_2,
          title:'Wall Mounted Range Hoods', 
          slug: '/all-brands/best-ventillation/range-hoods/wall-mounted-range-hoods',
          imageFlag: true
        },
        { 
          img: BestVentilationCategory_3,
          title:'Undercabinet Range Hoods',
          slug: '/all-brands/best-ventillation/range-hoods/under-cabinet-range-hoods',
          imageFlag: true
        },
        { 
          img: BestVentilationCategory_4,
          title:'Island Range Hoods', 
          slug: '/all-brands/best-ventillation/range-hoods/island-range-hoods',
          imageFlag: true

        },
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "Best Ventilation: Powerful Performance for a Fresher Kitchen",
          title: "",          
          descriptionTxt : "Best Ventilation appliances are designed to deliver exceptional airflow, ensuring a clean and comfortable kitchen environment. With innovative technology and stylish designs, Best Ventilation offers high-performance range hoods that effectively eliminate smoke, grease, and odors while seamlessly blending into your kitchen space."
        },
        {        
          mainHeading: "Why Choose Best Ventilation?",
          title: "Downdraft Range Hoods: Space-Saving Ventilation",          
          descriptionTxt : "Best Ventilation downdraft range hoods provide an innovative solution for kitchens where traditional overhead hoods aren&#39;t an option. These hoods retract when not in use and rise at the touch of a button, efficiently capturing smoke and odors directly from the cooktop."
        },
        {        
          mainHeading: "",
          title: "Chimney Range Hoods: A Stylish and Functional Statement",          
          descriptionTxt : "Designed to complement both modern and classic kitchens, Best Ventilation chimney range hoods offer powerful ventilation with a bold, sophisticated design. These wall-mounted hoods effectively remove airborne grease and odors while enhancing your kitchen’s aesthetic."
        },
        {        
          mainHeading: "",
          title: "Under-Cabinet Range Hoods: Compact and Efficient",          
          descriptionTxt : "Best Ventilation under-cabinet range hoods provide powerful airflow in a space-saving design. Installed beneath your kitchen cabinetry, these hoods offer efficient ventilation without taking up additional space, making them perfect for any kitchen layout."
        },
        {        
          mainHeading: "",
          title: "Island Range Hoods: Elevated Ventilation for Open Kitchens",          
          descriptionTxt : "For kitchens with an island cooktop, Best Ventilation island range hoods deliver top-tier performance from all angles. Suspended from the ceiling, these hoods provide powerful extraction while adding a sleek, modern touch to your kitchen."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "At Airport Home Appliance, we are proud to offer Best Ventilation products that combine cutting-edge technology with elegant design. Shop Best Ventilation today to find the perfect range hood for your home!"
        }          
      ]
    },
  }, 
  {
    Bluestar: {
      id: 19,
      title: "BlueStar",
      videoLink: "https://www.youtube.com/watch?v=IwsUYYIWA3w",
      BannerData: {
        subheading: "Built on Trust",
        descriptionTxt:
          "Specializes in high-performance cooking appliances, offering customizable ranges for serious cooking enthusiasts.",
        bannerImg: BluestarbannerImg,
        logoImg: BluestarlogoImg,
      },
      brandOptions: [
        { 
          img: BluestarCategory_1,
          title:'Ranges',
          slug: '/all-brands/bluestar/ranges',
        },       
        { 
          img: BluestarCategory_2,
          title:'Refrigerators', 
          slug: '/all-brands/bluestar/refrigerators',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "BlueStar: Our Luxury Partner",          
          descriptionTxt : "BlueStar Appliances embody the essence of luxury and performance, offering professional-grade features tailored for home kitchens. As one of our esteemed luxury partners, BlueStar combines innovative engineering with handcrafted designs, delivering appliances that elevate culinary experiences and kitchen aesthetics."
        },
        {        
          mainHeading: "Why Choose BlueStar Luxury Appliances?",
          title: "Iconic Ranges for Professional Results",        
          descriptionTxt : "BlueStar ranges are a dream for culinary enthusiasts. With high-performance burners, customizable designs, and expansive oven capacities, these ranges bring restaurant-level precision to your home kitchen."
        },
        {        
          mainHeading: "",
          title: "High-Quality Range Hoods for Efficient Ventilation",        
          descriptionTxt : "BlueStar range hoods provide powerful ventilation to keep your kitchen fresh and clean. Available in customizable finishes, they blend function and design seamlessly for a luxurious cooking space."
        },
        {        
          mainHeading: "",
          title: "Cooktops Designed for Precision",        
          descriptionTxt : "BlueStar range hoods offer precision cooking with high-BTU burners and durable grates. Their thoughtful designs ensure perfect control, making them ideal for both novice cooks and seasoned chefs."
        }, 
        {        
          mainHeading: "",
          title: "Stylish Refrigerators with Superior Cooling",        
          descriptionTxt : "BlueStar refrigerators feature advanced cooling technology to preserve your ingredients’ freshness while offering customizable panel options to match your kitchen’s unique style."
        },
        {        
          mainHeading: "",
          title: "Specialized Freezers and Ice Makers",        
          descriptionTxt : "Complete your kitchen setup with BlueStar’s freezers and ice makers, crafted for durability and performance. These appliances provide efficient storage and a steady supply of ice for entertaining or everyday use."
        },
        {        
          mainHeading: "",
          title: "Elegant Wall Ovens for Versatile Cooking",        
          descriptionTxt : "BlueStar wall ovens are engineered for even heating and optimal baking performance, offering versatile cooking options that cater to your culinary creativity."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "At Airport Appliance, we’re proud to feature BlueStar as one of our luxury partners. Shop BlueStar Appliances today to bring unmatched craftsmanship, professional-grade performance, and customizable style to your home."
        }
      ]
    },
  },
   { 
    Bosch: {
      id: 20,
      title: "Bosch",
      videoLink: "https://www.youtube.com/watch?v=usEqMfydk6c",
      BannerData: {
        subheading: "Invented for life",
        descriptionTxt:
          "Renowned for precision engineering and energy-efficient designs that balance performance and sustainability.",
        bannerImg: BoschbannerImg,
        logoImg: BoschlogoImg,
      },
      brandOptions: [
        { 
          img: BoschCategory_1,
          title:'Dishwashers',
          slug: '/all-brands/bosch/dishwashers',
        },       
        { 
          img: BoschCategory_2,
          title:'Refrigerators', 
          slug: '/all-brands/bosch/refrigerators',
        },
        { 
          img: BoschCategory_3,
          title:'Microwaves',
          slug: '/all-brands/bosch/microwaves-otr',
        },       
        { 
          img: BoschCategory_4,
          title:'Washers', 
          slug: '/all-brands/bosch/laundry/washers',
        }
      ],
      collectionList: [
        {
          title:"Bosch Buy More Save More Rebate",
          img:BoschlogoImg,
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=WSSIOBVO.pdf",
          descriptionTxt : "Receive up to a $1500 rebate with purchase of 2 or more qualifying Bosch products plus eligible cooking bonuses.",
          validDate:"valid from 7/11/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Bosch is renowned for its superior craftsmanship, innovative technology, and sleek design. As a leading name in kitchen appliances, Bosch brings cutting-edge features to your kitchen, offering high-performance products that make cooking and cleaning easier. At Airport Appliance, we proudly carry a wide selection of Bosch appliances, including cooktops, refrigerators, ovens, dishwashers, and ranges, perfect for those looking to elevate their kitchen experience."
        },
        {        
          mainHeading: "Why Choose Bosch Appliances?",
          title: "Bosch Buy More Save More Rebate",        
          descriptionTxt : "Bosch is renowned for its superior craftsmanship, innovative technology, and sleek design. As a leading name in kitchen appliances, Bosch brings cutting-edge features to your kitchen, offering high-performance products that make cooking and cleaning easier. At Airport Appliance, we proudly carry a wide selection of Bosch appliances, including cooktops, refrigerators, ovens, dishwashers, and ranges, perfect for those looking to elevate their kitchen experience."
        },
        {        
          mainHeading: "",
          title: "Bosch Cooktops:",        
          descriptionTxt : "Bosch cooktops are designed to combine precision with style. Available in gas, electric, and induction options, these cooktops offer responsive controls and efficient cooking power. Their sleek design and intuitive touch controls allow you to create the perfect meal every time, while seamlessly blending with modern kitchen decor."
        },
        {        
          mainHeading: "",
          title: "Bosch Refrigerators:",        
          descriptionTxt : "Bosch refrigerators are engineered for efficiency and convenience. Offering spacious layouts, customizable shelving, and energy-saving features, Bosch refrigerators provide optimal storage for fresh food and beverages. With innovative technologies like FreshSense and VitaFresh, your ingredients stay fresh longer, all while maintaining a stylish appearance."
        },
        {        
          mainHeading: "",
          title: "Bosch Ovens:",        
          descriptionTxt : "Bosch ovens take cooking to the next level with advanced technology and precise cooking features. Whether you choose a single oven, double oven, or wall oven, you’ll enjoy quick preheating, consistent cooking results, and a variety of cooking modes. With options like convection cooking and self-cleaning, Bosch ovens make meal preparation more efficient."
        },
        {        
          mainHeading: "",
          title: "Bosch Dishwashers:",        
          descriptionTxt : "Bosch dishwashers are known for their quiet operation and exceptional cleaning performance. Featuring advanced cleaning technologies like PrecisionWash and AutoAir, Bosch dishwashers ensure spotless dishes every time, even in the most demanding loads. With energy-efficient options and sleek, modern designs, Bosch dishwashers are the perfect blend of style and functionality."
        },
        {        
          mainHeading: "",
          title: "Bosch Ranges:",        
          descriptionTxt : "Bosch ranges offer both gas and electric options that combine powerful cooking performance with innovative features. Whether you prefer the precision of gas burners or the even heat distribution of an electric range, Bosch ranges provide even cooking results and easy cleanup. Their intuitive controls and sleek design make them a standout in any kitchen."
        },
        {        
          mainHeading: "",
          title: "Bosch Kitchen Packages:",        
          descriptionTxt : "For those looking to fully upgrade their kitchen, Bosch kitchen packages offer a complete solution. These comprehensive packages combine the best of Bosch appliances, offering everything you need for a stylish, efficient kitchen. From refrigerators and ovens to cooktops and dishwashers, Bosch kitchen packages are designed to work seamlessly together, ensuring top-notch performance and cohesive style."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "xplore the full range of Bosch appliances at Airport Appliance. Whether you’re renovating your kitchen or simply looking for individual high-performance appliances, Bosch has you covered. From sleek designs to advanced technology, Bosch appliances elevate the look and function of any kitchen."
        }
      ]
    }
  },
  {
    Broan_Ventillation: {
      id: 6,
      title: "Broan Ventillation",
      videoLink: "https://www.youtube.com/watch?v=TgEzc7Kn-Ig",
      BannerData: {
        subheading: "Improve the Air You Breathe",
        descriptionTxt:
          "Leading provider of effective, energy-efficient ventilation solutions that improve indoor air quality.",
        bannerImg: BroanbannerImg,
        logoImg: BroanlogoImg,
      },
      brandOptions: [
        { 
          img: BroanCategory_1,
          title:'Undercabinet Range Hoods',
          slug: '/all-brands/broan-ventillation/range-hoods/under-cabinet-range-hoods',
          imageFlag: true
        },       
        { 
          img: BroanCategory_2,
          title:'Island Range Hoods',
          slug: '/all-brands/broan-ventillation/range-hoods/island-range-hoods',
          imageFlag: true
        },
        { 
          img: BroanCategory_3,
          title:'Downdraft Range Hoods',
          slug: '/all-brands/broan-ventillation/range-hoods/downdraft-range-hoods',
          imageFlag: true

        },       
        { 
          img: BroanCategory_4,
          title:'Downdraft Range Hoods', 
          slug: '/all-brands/broan-ventillation/range-hoods/downdraft-range-hoods',
        },       
        // { 
        //   img: BroanCategory_5,
        //   title:'Island Range Hoods', 
        // }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "Broan Ventilation: Trusted Airflow Solutions for Every Kitchen",
          title: "",          
          descriptionTxt : "Broan is a leader in home ventilation, providing high-performance range hoods designed to keep your kitchen fresh, clean, and free from smoke, grease, and odors. With innovative engineering and stylish designs, Broan ventilation appliances offer a perfect blend of efficiency and aesthetics, making them a top choice for modern homes."
        },
        {        
          mainHeading: "Why Choose Broan Ventilation?",
          title: "Under-Cabinet Range Hoods: Space-Saving Power",          
          descriptionTxt : "Broan under-cabinet range hoods deliver powerful ventilation in a compact design. Installed beneath your kitchen cabinetry, these hoods effectively eliminate cooking fumes while blending seamlessly into your kitchen layout. Available in multiple styles and finishes, they offer both function and elegance."
        },
        {        
          mainHeading: "",
          title: "Island Range Hoods: Ventilation from Every Angle",          
          descriptionTxt : "Designed for open-concept kitchens, Broan island range hoods provide 360-degree ventilation. Suspended from the ceiling, these hoods offer powerful air filtration while serving as a sleek focal point in your cooking space. With advanced fan speeds and efficient grease capture, they ensure optimal air quality."
        },
        {        
          mainHeading: "",
          title: "Downdraft Range Hoods: Hidden Performance",          
          descriptionTxt : "For kitchens without overhead ventilation options, Broan downdraft range hoods offer a discreet yet effective solution. These hoods rise from the countertop when needed, pulling smoke and odors away directly from the cooking surface before retracting out of sight when not in use."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "At Airport Home Appliance, we are proud to feature Broan Ventilation products that provide reliable performance and modern design. Shop Broan today to find the perfect ventilation solution for your kitchen!"
        }
      ]
    },
  },
  {
    Cafe: {
      id: 25,
      title: "Cafe",
      videoLink: "https://www.youtube.com/watch?v=ETZd8HT4hTE",
      BannerData: {
        subheading: "Distinct by Design",
        descriptionTxt:
          "Blends luxury aesthetics with customizable features to create stylish, high-end kitchen spaces.",
        bannerImg: CafebannerImg,
        logoImg: CafelogoImg,
      },
      brandOptions: [
        { img: CafeOption_1,
          title:'Ranges',
          slug: '/all-brands/cafe/ranges',
         },       
        { 
          img: CafeOption_2,
          title:'Refrigerators', 
          slug: '/all-brands/cafe/refrigerators',
        },
        {
          img: CafeOption_3,
          title:'Wall Ovens', 
          slug: '/all-brands/cafe/wall-ovens',
        },
        { 
          img: CafeOption_4,
          title:'Dishwashers', 
          slug: '/all-brands/cafe/dishwashers',
        },
        { 
          img: CafeOption_5,
          title:'Cooktops & Rangetops',
          slug: '/all-brands/cafe/cooktops/rangetops?fieldIds=38&fieldValueIds=22661',
          imageFlag: true

        }, 
      ],
      collectionList: [
        {
          title:"Monogram One For You One For Free Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=NBMEBMQC.pdf",
          descriptionTxt : "Receive a generous rebate or up to 3 Free Monogram Appliances with purchase of qualifying Monogram Range or Appliance Package.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
          },
        {
          title:"Cafe Free Hestan Cue Smart Pan Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=YIAWPIRB.pdf",
          descriptionTxt : "Inspired by the way light plays on glass, the Café Modern Glass Collection of appliances lets you create a kitchen that’s a total reflection of you. The smooth glass surface echoes the aura of your cooking space with a nod to modern design.",
          validDate:"valid from 7/11/2024 to 12/31/2024"  
        },
        {
          title:"Cafe Fit Guarantee",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EKFWTLSG.pdf",
          descriptionTxt : "Replace your Cooktop or Wall Oven with a qualifying Cafe Cooktop, Wall Oven, Advantium Oven, or Slide In Range and receive up to a $300 installation rebate.",
          validDate:"valid from 7/1/2024 to 12/31/2024"  
        },
        {
          title:"Cafe Express Yourself Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=WBUBFXKV.pdf",
          descriptionTxt : "Receive up to a $3000 rebate with purchase of qualifying Cafe Appliances.",
          validDate:"valid from 7/1/2024 to 12/31/2024"  
        }

      ],
       contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Café is a premium kitchen appliance brand that blends bold design with exceptional performance. Known for its sleek, professional-grade appliances, Café offers an elevated cooking experience. At Airport Appliance, we carry an extensive selection of Café appliances, including cooktops, refrigerators, ovens, dishwashers, and ranges. Whether you're remodeling your kitchen or outfitting a new home, Café appliances are designed to impress and deliver lasting reliability."
        },
        {        
          mainHeading: "Why Choose Café Appliances?",
          title: "Café Cooktops:",        
          descriptionTxt : "Café cooktops combine luxury with practicality. Available in gas, electric, and induction models, these cooktops offer powerful burners and sleek surfaces that make cooking both enjoyable and efficient. Designed for precision, Café cooktops provide responsive heat control for every culinary need, from delicate sauces to high-heat searing."
        },
        {        
          mainHeading: "",
          title: "Café Refrigerators:",        
          descriptionTxt : "Café refrigerators are built to keep your food fresh and organized, with flexible storage options and advanced cooling technologies. Featuring options like French door, side-by-side, and bottom-freezer models, these refrigerators offer spacious interiors and stylish exteriors that complement any kitchen. Innovative features like advanced cooling and energy-efficient designs ensure your ingredients stay at their peak."
        },
        {        
          mainHeading: "",
          title: "Café Ovens:",        
          descriptionTxt : "Café ovens are the heart of your kitchen. With convection cooking, Wi-Fi connectivity, and a variety of cooking modes, these ovens deliver even cooking results, whether you're roasting a holiday turkey or baking a fresh batch of cookies. Café ovens are designed to offer both performance and style, with their professional-inspired look that fits seamlessly into your kitchen."
        },
        {        
          mainHeading: "",
          title: "Café Dishwashers:",        
          descriptionTxt : "Café dishwashers combine quiet performance with impressive cleaning power. With advanced wash cycles and powerful jets, these dishwashers ensure spotless results every time. Their sleek, modern design fits perfectly with Café’s other kitchen appliances, while features like bottle jets, hard food disposers, and built-in Wi-Fi make these dishwashers more efficient and convenient."
        },
        {        
          mainHeading: "",
          title: "Café Ranges:",        
          descriptionTxt : "Café ranges bring together precision cooking and stylish design. Available in both gas and electric models, these ranges feature powerful burners, convection ovens, and a variety of cook modes to accommodate everything from weekday meals to gourmet feasts. Café ranges are designed with advanced technology that makes cooking more efficient, while their sleek, professional-inspired style elevates your kitchen."
        },
        {        
          mainHeading: "",
          title: "Café Kitchen Appliances:",        
          descriptionTxt : "For those looking to create a coordinated, stylish kitchen, Café kitchen appliances provide a premium solution. With matching designs across all product categories—refrigerators, ovens, cooktops, dishwashers, and ranges—Café offers a seamless and sophisticated look. These high-performance appliances are perfect for homeowners who want both beauty and functionality in their kitchens."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full range of Café appliances at Airport Appliance. From professional-style ranges to high-tech dishwashers and refrigerators, Café kitchen appliances are crafted to deliver top-tier performance and style. Upgrade your kitchen with Café’s premium lineup and make cooking and entertaining a luxurious experience."
        }
      ]
    },
  }, 
  {
    Cove: {
      id: 41,
      title: "Cove",
      videoLink: "https://www.youtube.com/watch?v=Oi_qhW4qpg8&embeds_referring_euri=https%3A%2F%2Fwww.airportappliance.com%2F&embeds_referring_origin=https%3A%2F%2Fwww.airportappliance.com&source_ve_path=OTY3MTQ",
      BannerData: {
        subheading: "Three Specialists. One Extraordinary Kitchen",
        descriptionTxt: 
          "Icons of design and paragons of performance, Sub-Zero, Wolf, and Cove are the pinnacle of luxury in refrigeration, cooking, and dishwashing. Together, these brands craft a kitchen experience that transcends the ordinary, delivering a symphony of luxury, performance, and innovation.",
        bannerImg: WolfbannerImg,
        logoImg: WolflogoImg,
      },
      brandOptions: [
        { 
          img: WolfCategory_3,
          title:'Wolf Cooking', 
          slug: '',
          desc: 'With a proven professional kitchen pedigree, Wolf equips home cooks with the confidence to create the meals that the most delicious memories are made of.',
          fullImage: true
        },
        { 
          img: WolfCategory_1,
          title:'Sub-Zero Refrigeration',
          slug: '',
          desc: 'More than just a refrigerator, Sub-Zero is the preservation specialist keeping food fresher longer and guarding wine against its enemies.',
          fullImage: true
        },
        { 
          img: WolfCategory_2,
          title:'Cove Dishwashing',
          slug: '',
          desc: 'From completely flexible interiors to near-silent operation, Cove ensures spotlessly clean and dry dishes with every load.',
          fullImage: true
        },
       
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Cove: Our Luxury Partner",        
          descriptionTxt : "Cove Appliances redefine kitchen luxury with their blend of cutting-edge technology, superior durability, and timeless design. As one of our luxury partners, Cove offers premium dishwashers, cooktops, and refrigeratorstailored for discerning homeowners who value elegance and efficiency."
        },
        {        
          mainHeading: "Why Choose Cove Luxury Appliances?",
          title: "Superior Dishwashers for Spotless Results",        
          descriptionTxt : "Cove dishwashers are designed with advanced cleaning technology, providing unmatched performance for sparkling dishes. With flexible configurations, they adapt to various kitchen needs while ensuring quiet operation and long-lasting reliability."
        },
        {        
          mainHeading: "",
          title: "Precision Cooktops for Culinary Excellence",        
          descriptionTxt : "Cove cooktops offer exceptional precision, enabling you to craft culinary masterpieces with ease. With robust construction and sleek designs, these cooktops blend seamlessly into any modern kitchen while delivering professional-grade performance."
        },
        {        
          mainHeading: "",
          title: "Refrigerators Built for Freshness",        
          descriptionTxt : "Cove refrigerators combine innovative cooling systems with elegant designs to preserve your food in optimal conditions. Their versatile storage solutions and durable construction ensure a perfect balance of functionality and sophistication."
        },
        {        
          mainHeading: "",
          title: "Luxury Meets Longevity",        
          descriptionTxt : "Every Cove appliance is engineered to provide years of reliable service, making them a worthwhile investment for your kitchen. With thoughtful design and a focus on sustainability, Cove stands out as a trusted brand for luxury kitchen solutions."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore Cove Appliances at Airport Appliance today and elevate your kitchen with premium dishwashers, cooktops, and refrigerators designed for a seamless and sophisticated lifestyle."
        },
      ]
    },
  },
  {
    Dacor: {
      id: 37,
      title: "Dacor",
      videoLink: "https://www.youtube.com/watch?v=QKdqco2Tr60",
      BannerData: {
        subheading: "Life and Luxury, Connected",
        descriptionTxt:
          "Blends modern design with high-end, smart technology to deliver performance-focused kitchen appliances.",
        bannerImg: DacorbannerImg,
        logoImg: DacorlogoImg,
      },
      brandOptions: [
        { 
          img: DacorCategory_1,
          title:'Microwaves',
          slug: '/all-brands/dacor/microwaves-otr',
          imageFlag: true

        },
        { 
          img: DacorCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/dacor/refrigerators',
        },
        { 
          img: DacorCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/dacor/dishwashers',
        },        
      ],
      collectionList: [
        {
          title:"Dacor Seasonal Savings Event Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=NYDCZWJM.pdf",
          descriptionTxt : " Receive up to a $2000 rebate with purchase of qualifying Dacor Refrigerator or Range.",
          validDate:"valid from 10/1/2024 to 3/31/2025"  
        },
        {
          title:"Dacor 5 10 20 Promotion",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=UGHAVHKH.pdf",
          descriptionTxt : "5-10-20 Promotion. Get up to 20% off. Spend $5,000 + get 5% off. Spend $10,000 + get 10% off. Spend $20,000 + get 20% off.",
          validDate:"valid from 1/1/2023 to 12/31/2024"  
        },
        {
          title:"Dacor Appliances Delivery Or Installation Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=CMS&FORM_NUMBER=524449",
          descriptionTxt : "Receive up to a $800 Delivery or Installation rebate with purchase of qualifying Dacor Appliances.",
          validDate:"valid from 10/1/2024 to 12/31/2024"  
        }
      ],
      contentList:[
       {        
         mainHeading: "",
         title: "Dacor: Our Luxury Partner",          
         descriptionTxt : "Dacor Appliances redefine modern luxury in kitchen design with innovative technology and exceptional craftsmanship. As one of our luxury partners, Dacor offers an exclusive collection of cooktops, ranges, ovens, dishwashers, and refrigerators that deliver professional-grade performance and timeless aesthetics."
       },
       {        
         mainHeading: "Why Choose Dacor Luxury Appliances?",
         title: "Innovative Cooktops for Precision Cooking",        
         descriptionTxt : "Dacor cooktops provide precise temperature control and sleek designs that fit seamlessly into your kitchen. Whether you prefer gas or induction, these cooktops offer advanced features for effortless cooking."
       },
       {        
         mainHeading: "",
         title: "Sophisticated Ranges and Ovens",        
         descriptionTxt : "Dacor ranges and ovens are designed to meet the needs of professional chefs and home cooks alike. With cutting-edge features like steam assist and smart connectivity, these appliances ensure perfect results every time while elevating your kitchen's style."
       },
       {        
         mainHeading: "",
         title: "Refrigerators That Redefine Freshness",        
         descriptionTxt : "Dacor refrigerators are engineered to maintain optimal freshness for your ingredients. With customizable interiors, intuitive temperature control, and sleek finishes, these refrigerators are a true blend of form and function."
       },
       {        
         mainHeading: "",
         title: "Quiet and Efficient Dishwashers",        
         descriptionTxt : "acor dishwashers deliver spotless results with minimal noise. Equipped with advanced cleaning cycles and customizable racks, they cater to your every need while adding a touch of luxury to your kitchen."
       },
       {        
         mainHeading: "",
         title: "Unmatched Quality and Elegance",        
         descriptionTxt : "Dacor appliances are crafted for those who value precision, durability, and style. With innovative features and luxurious designs, they transform your kitchen into a culinary haven."
       },
       {        
         mainHeading: "",
         title: "",        
         descriptionTxt : "Discover the full range of Dacor luxury appliances at Airport Appliance and experience the perfect combination of performance and elegance for your home."
       },
     ]
    },
  },
  {
    Dcs: {
      id: 160,
      title: "Dynamic Cooking System",
      videoLink: "https://www.youtube.com/watch?v=QvBD6ajtavY",
      BannerData: {
        subheading: "Born and Raised Outdoors",
        descriptionTxt:
          "Combines high-performance cooking technology with robust, professional-grade designs for the modern chef.",
        bannerImg: DCSbannerImg,
        logoImg: DCSlogoImg,
      },
      brandOptions: [
        { 
          img: DCSCategory_1,
          title:'Outdoor Grills',
          slug: '/all-brands/dcs/grills-outdoor-kitchens',
        },
        { 
          img: DCSCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/dcs/refrigerators',
        },     
      ],
      collectionList: [
        {
          title:"DCS 10% Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=DCYXJSWM.pdf",
          descriptionTxt : "Spend $1,499 or more on qualifying DCS Products and receive a 10% rebate.",
          validDate:"valid from 4/1/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "DCS Appliances is synonymous with innovation, durability, and professional-grade quality. Whether you're enhancing your outdoor cooking setup or upgrading your kitchen, DCS offers reliable and high-performing appliances that blend seamlessly into modern homes. At Airport Appliance, we proudly feature a curated selection of DCS appliances, including refrigerators and outdoor grills, perfect for those who value style, functionality, and performance."
        },
        {        
          mainHeading: "Why Choose DCS Appliances?",
          title: "DCS Refrigerators:",        
          descriptionTxt : "DCS refrigerators are engineered to provide superior cooling and storage solutions. With spacious interiors, precise temperature controls, and energy-efficient designs, these refrigerators keep your food fresher for longer. Their sleek and durable build ensures they complement any modern kitchen while delivering top-tier performance. DCS refrigerators are perfect for homeowners who demand both functionality and sophistication."
        },
        {        
          mainHeading: "",
          title: "DCS Outdoor Grills:",        
          descriptionTxt : "Elevate your outdoor cooking game with DCS outdoor grills. Designed for grilling enthusiasts and professionals alike, these grills feature powerful burners, even heat distribution, and durable stainless-steel construction. Whether you're hosting a backyard barbecue or preparing a family dinner, DCS grills offer unmatched versatility and precision. With smart designs and customizable options, they make outdoor entertaining seamless and enjoyable."
        },
        {        
          mainHeading: "",
          title: "DCS Appliances for Every Home:",        
          descriptionTxt : "DCS appliances are built to meet the demands of modern living. With a focus on quality, innovation, and style, DCS offers products that stand out in performance and reliability. Whether you're creating a gourmet outdoor kitchen or upgrading your indoor appliances, DCS delivers solutions tailored to your lifestyle."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "At Airport Appliance, we make it easy to find the perfect DCS appliance for your needs. From refrigerators that redefine kitchen storage to outdoor grills designed for unforgettable gatherings, explore our selection and bring home the quality of DCS."
        }
      ]
    },
  },
  {
    Electrolux: {
      id: 42,
      title: "Electrolux",
      videoLink: "https://www.youtube.com/watch?v=3tNqhjbiv04",
      BannerData: {
        subheading: "Shape Living for the Better",
        descriptionTxt:
          "Prioritizes innovation and sustainability to improve living while reducing environmental impact.",
        bannerImg: ElectroluxbannerImg,
        logoImg: ElectroluxlogoImg,
      },
      brandOptions: [
        { 
          img: ElectroluxCategory_1,
          title:'Laundry Centers',
          slug: '/all-brands/electrolux/laundry/stacked-washer-dryer-sets',
        },
        { 
          img: ElectroluxCategory_2,
          title:'Washer and Dryer Sets',
          slug: '/laundry/washer-dryer-sets?page=1&brandIds=42',
          imageFlag: true
        },
        { 
          img: ElectroluxCategory_3,
          title:'Washers',
          slug: '/all-brands/electrolux/laundry/washers',
          imageFlag: true

        },
        { 
          img: ElectroluxCategory_4,
          title:'Dryers',
          slug: '/all-brands/electrolux/laundry/dryers',
          imageFlag: true
        }       
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Electrolux is a global leader in home appliances, offering innovative, energy-efficient solutions that redefine convenience and performance. Known for its sleek designs and advanced technology, Electrolux appliances are crafted to enhance your daily routine while adding a touch of sophistication to your home. At Airport Appliance, we proudly offer a diverse range of Electrolux products, including cooktops, refrigerators, ranges, laundry solutions, and dishwashers."
        },
        {        
          mainHeading: "Why Choose Electrolux Appliances?",
          title: "Electrolux Cooktops:",        
          descriptionTxt : "Electrolux cooktops deliver precision and power for effortless cooking. Available in gas, electric, and induction options, these cooktops feature intuitive controls and sleek designs that complement modern kitchens. Whether you're simmering sauces or searing steaks, Electrolux cooktops offer consistent, professional-grade results."
        },
        {        
          mainHeading: "",
          title: "Electrolux Refrigerators:",        
          descriptionTxt : "Electrolux refrigerators are designed to keep your groceries fresh and organized. With spacious interiors, customizable shelving, and innovative cooling technologies, these refrigerators make storing food convenient and efficient. Their stylish exteriors and energy-saving features make them a must-have for any kitchen."
        },
        {        
          mainHeading: "",
          title: "Electrolux Ranges:",        
          descriptionTxt : "Electrolux ranges bring versatility and performance to your kitchen. With dual-fuel, gas, and electric options, these ranges feature precise temperature controls, convection cooking, and self-cleaning capabilities. Electrolux ranges are perfect for everything from quick weeknight meals to gourmet creations."
        },
        {        
          mainHeading: "",
          title: "Electrolux Laundry Solutions:",        
          descriptionTxt : "Electrolux laundry appliances combine cutting-edge technology with eco-friendly performance. Their washers and dryers are engineered to handle the toughest stains while being gentle on fabrics. With features like steam cleaning and energy efficiency, Electrolux laundry appliances make caring for your clothes easy and effective."
        },
        {        
          mainHeading: "",
          title: "Electrolux Dishwashers:",        
          descriptionTxt : "Electrolux dishwashers offer powerful cleaning performance and whisper-quiet operation. With advanced cleaning technologies, multiple wash cycles, and energy-efficient designs, they ensure spotless results every time. Their modern appearance perfectly complements other Electrolux kitchen appliances."
        },
        {        
          mainHeading: "",
          title: "Elevate Your Home with Electrolux Appliances",        
          descriptionTxt : "Electrolux is dedicated to delivering appliances that simplify your life and enhance your home. Whether you're upgrading your kitchen or modernizing your laundry room, Electrolux appliances combine style, innovation, and functionality to meet your needs."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full range of Electrolux appliances at Airport Appliance. From high-performance cooktops and refrigerators to efficient dishwashers and laundry solutions, Electrolux products deliver exceptional quality and reliability. Find your perfect appliance today!"
        }
      ]
    },
  },
  {
    Elica: {
      id: 157,
      title: "Elica",
      videoLink: "https://www.youtube.com/watch?v=Dp5q8D398Pw",
      BannerData: {
        subheading: "Extraordinary Cooking",
        descriptionTxt:'Combines innovative air purification technology with sleek, modern designs for superior kitchen ventilation.',
        bannerImg: ElicabannerImg,
        logoImg: ElicalogoImg,
      },
      brandOptions: [
        { 
          img: ElicaCategory_1,
          title:'Range Hoods',
          slug: '/all-brands/elica/range-hoods',
        },
        { 
          img: ElicaCategory_2,
          title:'Beverage Centers',
          slug: '/all-brands/elica/beverage-centers',
        },
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Elica is a globally renowned brand specializing in innovative kitchen solutions that combine advanced technology, efficiency, and stylish design. Known for its commitment to quality, Elica offers premium appliances that enhance both the functionality and aesthetics of your kitchen. At Airport Appliance, we feature a selection of Elica appliances, including range hoods and cooktops, crafted to meet the needs of modern kitchens."
        },
        {        
          mainHeading: "Why Choose Elica Appliances?",
          title: "Elica Range Hoods:",        
          descriptionTxt : "Elica range hoods are designed to keep your kitchen air fresh and clean. Featuring powerful ventilation systems, whisper-quiet operation, and modern designs, these hoods effectively remove smoke, grease, and odors while adding elegance to your kitchen. Whether you're looking for a wall-mounted, island, or under-cabinet model, Elica range hoods offer versatile solutions that suit any kitchen layout."
        },
        {        
          mainHeading: "",
          title: "Elica Cooktops:",        
          descriptionTxt : "Elica cooktops bring precision cooking to your fingertips. Available in gas and induction options, these cooktops deliver exceptional performance with sleek surfaces that are easy to clean. With intuitive controls and efficient burners, Elica cooktops make every meal a pleasure to prepare, combining style with functionality."
        },
        {        
          mainHeading: "",
          title: "Elevate Your Kitchen with Elica Appliances",        
          descriptionTxt : "Elica appliances are the perfect blend of innovation and design, ideal for homeowners who value high-performance and contemporary aesthetics. Whether you're upgrading your kitchen or starting a renovation, Elica range hoods and cooktops deliver a seamless balance of form and function."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Discover the excellence of Elica appliances at Airport Appliance. From stylish range hoods that improve air quality to versatile cooktops that elevate your cooking experience, explore our collection and find the perfect addition to your kitchen"
        },
      ]
    },
  },
  {
    Fisher_Paykel: {
      id: 13,
      title: "Fisher & Paykel",
      videoLink: "https://www.youtube.com/watch?v=I-948aoy190",
      BannerData: {
        subheading: "Design for a Changing World",
        descriptionTxt:
          "Known for design innovation and seamless integration of appliances into contemporary homes.",
        bannerImg: FisherPaykelbannerImg,
        logoImg: FisherPaykellogoImg,
      },
      brandOptions: [
        { 
          img: FisherPaykelCategory_1,
          title:'Dishwasher Drawers',
          slug: '/all-brands/fisher-paykel/dishwashers/dishwasher-drawers',
        },
        { 
          img: FisherPaykelCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/fisher-paykel/refrigerators',
        },
        { 
          img: FisherPaykelCategory_3,
          title:'Ranges',
          slug: '/all-brands/fisher-paykel/ranges',
        },     
      ],
      collectionList: [
        {
          title:"Fisher and Paykel Create Kitchen Perfection Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=KYXHSFWB.pdf",
          descriptionTxt : "Receive up to a 15% rebate and a 5 Year Warranty with purchase of qualifying Fisher and Paykel Appliances.",
          validDate:"valid from 3/1/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "Fisher & Paykel: Our Luxury Partner",          
          descriptionTxt : "Fisher & Paykel is renowned for its innovative and beautifully crafted appliances, designed to elevate your kitchen experience. As one of our luxury partners, Fisher & Paykel offers a versatile range of dishwashers, refrigerators, ranges, ovens, and cooktops that blend cutting-edge technology with stunning aesthetics."
        },
        {        
          mainHeading: "Why Choose Fisher & Paykel Luxury Appliances?",
          title: "Effortless Dishwashing Solutions",        
          descriptionTxt : "Fisher & Paykel dishwashers are engineered for ultimate convenience and efficiency. With flexible loading options, powerful cleaning cycles, and whisper-quiet operation, these dishwashers simplify your cleanup routine while complementing your kitchen’s design."
        },
        {        
          mainHeading: "",
          title: "Refrigerators Built for Freshness",        
          descriptionTxt : "Fisher & Paykel refrigerators prioritize food preservation with innovative cooling technologies and customizable storage solutions. Their sleek designs and premium finishes make them a stylish addition to any luxury kitchen."
        },
        {        
          mainHeading: "",
          title: "Ranges & Ovens for Culinary Excellence",        
          descriptionTxt : "Fisher & Paykel ranges and ovens deliver precision cooking with advanced features like multi-function convection and self-cleaning capabilities. Whether you’re preparing a quick meal or hosting a gourmet dinner, these appliances ensure flawless performance."
        },
        {        
          mainHeading: "",
          title: "Cooktops for Every Cooking Style",        
          descriptionTxt : "Choose from gas, induction, or electric cooktops, each designed for efficiency and control. Fisher & Paykel cooktops feature seamless surfaces and intuitive controls, making them perfect for any modern kitchen."
        },
        {        
          mainHeading: "",
          title: "Innovative Design Meets Premium Performance",        
          descriptionTxt : "Fisher & Paykel’s commitment to quality and innovation ensures every appliance offers superior functionality and timeless elegance. Whether you're upgrading your kitchen or creating your dream space, Fisher & Paykel delivers appliances tailored to your lifestyle."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore Fisher & Paykel luxury appliances at Airport Appliance and discover how they can transform your home into a culinary haven."
        },
        
      ]
    },
  },
  {
    Forno: {
      id: 45,
      title: "Forno",
      videoLink: "https://www.youtube.com/watch?v=wvwIlYhNCy8",
      BannerData: {
        subheading: "Inspired by Italian cooking",
        descriptionTxt:
          "Delivers bold, professional-grade cooking appliances with European design influences at an affordable price point.",
        bannerImg: FornobannerImg,
        logoImg: FornologoImg,
      },
      brandOptions: [
        { 
          img: FornoCategory_1,
          title:'Ranges',
          slug: '/all-brands/forno/ranges',
        },
        { 
          img: FornoCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/forno/refrigerators',
        },
        { 
          img: FornoCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/forno/dishwashers',
        },     
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Forno is synonymous with exceptional craftsmanship and innovative design, offering high-performance appliances that elevate the heart of your home. At Airport Appliance, we proudly feature a diverse selection of Forno appliances, including cooktops, refrigerators, dishwashers, ranges, and ovens. Whether you’re outfitting a new kitchen or upgrading your current setup, Forno appliances deliver reliability, style, and advanced features that simplify your daily life."
        },
        {        
          mainHeading: "Why Choose Forno Appliances?",
          title: "Forno Cooktops:",        
          descriptionTxt : "Experience precision and control with Forno cooktops. Available in gas and electric options, these cooktops are designed to meet the demands of home chefs. With sleek designs and powerful burners, Forno cooktops ensure efficient and even cooking every time."
        },
        {        
          mainHeading: "",
          title: "Forno Refrigerators:",        
          descriptionTxt : "Forno refrigerators combine spacious storage, energy efficiency, and innovative cooling technology to keep your groceries fresh. With customizable shelving and elegant designs, these refrigerators enhance both functionality and aesthetics in your kitchen."
        },
        {        
          mainHeading: "",
          title: "Forno Dishwashers:",        
          descriptionTxt : "Forno dishwashers make cleanup a breeze with advanced cleaning systems and whisper-quiet operation. Engineered for efficiency, they deliver spotless dishes while using less water and energy, making them an eco-friendly choice for any home."
        },
        {        
          mainHeading: "",
          title: "Forno Ranges and Ovens:",        
          descriptionTxt : "Forno ranges and ovens provide versatile cooking options for culinary enthusiasts. With precise temperature control, convection technology, and a range of sizes, they help you prepare everything from everyday meals to gourmet creations with ease."
        },
        {        
          mainHeading: "",
          title: "Elevate Your Kitchen with Forno Appliances",        
          descriptionTxt : "Forno is committed to delivering high-quality appliances that combine form and function. Whether you’re cooking, cleaning, or storing, Forno appliances are designed to make life more convenient and stylish."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full range of Forno appliances at Airport Appliance and discover how these innovative solutions can transform your kitchen. From powerful cooktops to efficient dishwashers and stylish refrigerators, Forno has everything you need for a modern, high-performance home."
        },
       
      ]
    },
  },
  {
    Foster: {
      id: 156,
      title: "Foster",
      videoLink: "https://www.youtube.com/watch?v=C_mJ5-DmJm0",
      BannerData: {
        subheading: "Italian Quality",
        descriptionTxt:
          "Delivers Italian design and artisanship, outstanding quality and manufactures products with superb performance and exquisite beauty.",
        bannerImg: FosterbannerImg,
        logoImg: FosterlogoImg,
      },
      brandOptions: [
        { 
          img: FosterCategory_1,
          title:'Ranges',
          slug: '/all-brands/foster/ranges',
        },
        { 
          img: FosterCategory_2,
          title:'Cooktops',
          slug: '/all-brands/foster/cooktops',
          imageFlag: true
        },

        { 
          img: FosterCategory_3,
          title:'Rangetops',
          slug: '/all-brands/foster/cooktops/rangetops',
          imageFlag: true

        },     
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Foster: Our Luxury Partner",          
          descriptionTxt : "Foster is synonymous with Italian craftsmanship, offering high-performance appliances designed for sophisticated kitchens. As one of our luxury partners, Foster provides a curated range of cooktops, range hoods, wall ovens, ranges, and dishwashers, delivering functionality and elegance to your home."
        },
        {        
          mainHeading: "Why Choose Foster Luxury Appliances?",
          title: "Cooktops with Precision Control",        
          descriptionTxt : "Foster cooktops combine innovative design with professional-grade performance. Available in gas, induction, and electric models, these cooktops feature precise controls, sleek surfaces, and efficient operation, perfect for culinary enthusiasts."
        },
        {        
          mainHeading: "",
          title: "Elegant Range Hoods",        
          descriptionTxt : "Foster range hoods offer powerful ventilation while adding a touch of sophistication to your kitchen. Their advanced filtration systems ensure clean air, while the modern designs seamlessly integrate into any space."
        },
        {        
          mainHeading: "",
          title: "Wall Ovens for Gourmet Cooking",        
          descriptionTxt : "Foster wall ovens provide even heat distribution and multi-function capabilities, making every dish a masterpiece. With user-friendly controls and stunning finishes, these ovens are a must-have for any luxury kitchen."
        },
        {        
          mainHeading: "",
          title: "Versatile Ranges",        
          descriptionTxt : "Foster ranges deliver unmatched cooking versatility, combining robust cooktops with spacious ovens. Perfect for aspiring chefs and home cooks alike, these ranges are built for efficiency and style."
        },
        {        
          mainHeading: "",
          title: "Efficient Dishwashers",        
          descriptionTxt : "Foster’s dishwasher exemplifies simplicity and reliability. Engineered for optimal cleaning, it ensures spotless results with every cycle while maintaining a compact, modern design."
        },
        {        
          mainHeading: "",
          title: "Experience Italian Excellence in Your Kitchen",        
          descriptionTxt : "Foster appliances are designed to enhance your cooking experience while adding a luxurious touch to your home. Their blend of cutting-edge technology and timeless aesthetics ensures every product meets the highest standards of quality and performance."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore Foster’s luxury collection at Airport Appliance and redefine your kitchen with Italian elegance."
        }
      ]
    },
  },
  {
    Frigidaire: {
      id: 44,
      title: "Frigidaire",
      videoLink: "https://www.youtube.com/watch?v=6F3IkcTuxqs",
      BannerData: {
        subheading: "Designed to Make Your Life Easier",
        descriptionTxt:'Practical and affordable appliances designed to simplify daily household tasks.',
        bannerImg: FrigidairebannerImg,
        logoImg: FrigidairelogoImg,
      },
      brandOptions: [
        { 
          img: FrigidaireCategory_1,
          title:'Refrigerators',
          slug: '/all-brands/frigidaire/refrigerators',
        },
        { 
          img: FrigidaireCategory_2,
          title:'Dishwashers',
          slug: '/all-brands/frigidaire/dishwashers',
        },
        { 
          img: FrigidaireCategory_3,
          title:'Wall Ovens',
          slug: '/all-brands/frigidaire/wall-ovens',
          imageFlag: true

        }, 
        { 
          img: FrigidaireCategory_4,
          title:'Laundry Centers',
          slug: '/all-brands/frigidaire/laundry/stacked-washer-dryer-sets',
        } 
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Frigidaire has been a trusted name in home appliances for generations, known for delivering exceptional performance, durability, and innovation. At Airport Appliance, we offer a wide selection of Frigidaire appliances, including cooktops, refrigerators, ranges, dishwashers, and ovens, all designed to meet the needs of busy households. Whether you're upgrading your kitchen or starting fresh, Frigidaire provides reliable solutions that combine style and functionality."
        },
        {        
          mainHeading: "Why Choose Frigidaire Appliances?",
          title: "Frigidaire Cooktops:",        
          descriptionTxt : "Frigidaire cooktops offer precision and versatility, whether you prefer gas, electric, or induction. Their sleek designs, intuitive controls, and advanced technology make cooking easier and more enjoyable."
        },
        {        
          mainHeading: "",
          title: "Frigidaire Refrigerators:",        
          descriptionTxt : "Keep your food fresh with Frigidaire refrigerators,, featuring spacious interiors, customizable storage, and energy-efficient cooling. Available in French door, side-by-side, and top-freezer designs, they fit seamlessly into any kitchen layout."
        },
        {        
          mainHeading: "",
          title: "Frigidaire Ranges & Ovens:",        
          descriptionTxt : "Frigidaire ranges and combine style and performance, with features like convection cooking and quick preheat for perfectly cooked meals. Choose from gas or electric models to suit your cooking preferences."
        },
        {        
          mainHeading: "",
          title: "Frigidaire Dishwashers:",        
          descriptionTxt : "Frigidaire dishwashers offer powerful cleaning performance with advanced technology to handle tough messes. With quiet operation and energy efficiency, they make cleanup effortless."
        },
        {        
          mainHeading: "",
          title: "Upgrade Your Home with Frigidaire Appliances",        
          descriptionTxt : "Frigidaire appliances are designed to simplify your life, offering reliable solutions that deliver long-term value. From cooking to cleaning to refrigeration, every product is crafted with innovation and durability in mind."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "hop the full range of Frigidaire appliances at Airport Appliance today. Discover how their high-quality cooktops, refrigerators, ranges, dishwashers, and ovens can transform your kitchen into a space that’s both functional and stylish."
        }
      ]
    },
  },
  {
    Frigidaire_Gallery: {
      id: 46,
      title: "Frigidaire Gallery",
      videoLink: "https://www.youtube.com/watch?v=6cFW5snk67Y",
      BannerData: {
        subheading: "Practicality Redefined",
        descriptionTxt:
          "Combines style and functionality with appliances designed for the modern family kitchen.",
        bannerImg: FrigidaireGallerybannerImg,
        logoImg: FrigidaireGallerylogoImg,
      },
      brandOptions: [
        { 
          img: FrigidaireGalleryCategory_1,
          title:'Refrigerators',
          slug: '/all-brands/frigidaire-gallery/refrigerators',
        },
        { 
          img: FrigidaireGalleryCategory_2,
          title:'Dishwashers',
          slug: '/all-brands/frigidaire-gallery/dishwashers',
        },
        { 
          img: FrigidaireGalleryCategory_3,
          title:'Wall Ovens',
          slug: '/all-brands/frigidaire-gallery/wall-ovens',
          imageFlag: true

        },  
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Frigidaire has been a trusted name in home appliances for generations, known for delivering exceptional performance, durability, and innovation. At Airport Appliance, we offer a wide selection of Frigidaire appliances, including cooktops, refrigerators, ranges, dishwashers, and ovens, all designed to meet the needs of busy households. Whether you're upgrading your kitchen or starting fresh, Frigidaire provides reliable solutions that combine style and functionality."
        },       
        {        
          mainHeading: "Why Choose Frigidaire Gallery Appliances?",
          title: "Frigidaire Gallery Cooktops:",        
          descriptionTxt : "Enjoy precise cooking with Frigidaire Gallery cooktops. Featuring gas, electric, and induction options, these cooktops are built for efficiency and easy operation, making meal prep effortles"
        },
        {        
          mainHeading: "",
          title: "Frigidaire Gallery Refrigerators:",        
          descriptionTxt : "Frigidaire Gallery refrigerators offer sleek designs with innovative cooling technology to keep your food fresh and organized. With options like French doors and side-by-side models, they add sophistication and practicality to your kitchen."
        },       
        {        
          mainHeading: "",
          title: "Frigidaire Gallery Microwaves:",        
          descriptionTxt : "Frigidaire Gallery microwaves combine style and functionality with features like sensor cooking and multi-stage cooking settings. Perfect for reheating, defrosting, and quick meals, they are a must-have in any kitchen."
        },       
        {        
          mainHeading: "",
          title: "Frigidaire Gallery Dishwashers:",        
          descriptionTxt : "Clean up with ease using Frigidaire Gallery dishwashers. Engineered for efficiency and quiet operation, they provide a thorough clean with innovative spray systems and energy-saving features."
        },       
        {        
          mainHeading: "",
          title: "Upgrade Your Kitchen with Frigidaire Gallery Appliances",        
          descriptionTxt : "Frigidaire Gallery appliances are designed to make life easier, blending cutting-edge technology with a sleek aesthetic. Whether you’re cooking, cleaning, or cooling, these appliances ensure lasting quality and convenience."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full lineup of Frigidaire Gallery appliances at Airport Appliance today. From high-performance cooktops to stylish refrigerators and efficient dishwashers, we have everything you need to create a beautiful and functional kitchen."
        }
      ]
    },
  },
  {
    Frigidaire_Pro: {
      id: 48,
      title: "Frigidaire Pro",
      videoLink: "https://www.youtube.com/watch?v=N-Czcy9ZLZU",
      BannerData: {
        subheading: "The Balance Between Form and Function",
        descriptionTxt:'Professional-grade performance with powerful, precision appliances for home chefs.',
        bannerImg: FrigidaireProbannerImg,
        logoImg: FrigidairePrologoImg,
      },
      brandOptions: [
        { 
          img: FrigidaireProCategory_1,
          title:'Refrigerators',
          slug: '/all-brands/frigidaire-pro/refrigerators',
        },
        { 
          img: FrigidaireProCategory_2,
          title:'Dishwashers',
          slug: '/all-brands/frigidaire-pro/dishwashers',
        },
        { 
          img: FrigidaireProCategory_3,
          title:'Microwaves',
          slug: '/all-brands/frigidaire-pro/microwaves-otr',
          imageFlag: true

        }
      ],
      collectionList: [
        {
          title:"Frigidaire Cooktop Fit Promise Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=LJBVQTNJ.pdf",
          descriptionTxt : "Receive up to a $100 rebate toward a cabinet cutout or countertop modifcation if your new qualifying Frigidaire 30in or 36in Cooktop does not fit your current Cooktop cutout.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Frigidaire Wall Oven Fit Promise Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=ZQBICVUT.pdf",
          descriptionTxt : "Receive up to a $300 rebate toward a cabinet cutout modifcation if your new qualifying Frigidaire 27in or 30in Built-In Wall Oven does not fit your current Wall Oven cutout.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Frigidaire Buy More Save More Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=ZYQHNRJV.pdf",
          descriptionTxt : "Receive up to a $1000 rebate with purchase of 2 or more qualifying Frigidaire Appliances.",
          validDate:"valid from 10/17/2024 to 1/1/2025",
        },
        {
          title:"Frigidaire Range Fit Promise Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=ZPYBAQLX.pdf",
          descriptionTxt : "Receive up to a $100 rebate toward a cabinet cutout or countertop modifcation if your new qualifying Frigidaire 30in or 36in Freestanding Range does not fit your current Range cutout.",
          validDate:"valid from 1/1/2024 to 12/31/2024",
        },
        {
          title:"Frigidaire and Frigidaire Professional Buy More Save More Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=ZYQHNRJV.pdf",
          descriptionTxt : "Receive up to a $1000 rebate with purchase of 2 or more qualifying Frigidaire Appliances.",
          validDate:"valid from 10/17/2024 to 1/1/2025",
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Frigidaire Professional appliances bring commercial-grade performance into your home, offering exceptional durability, advanced technology, and sophisticated design. At Airport Appliance, we proudly offer a variety of Frigidaire Professional appliances, including cooktops, refrigerators, ranges, dishwashers, and ovens. Designed for culinary enthusiasts and busy households, these appliances deliver precision, efficiency, and style."
        },
        {        
          mainHeading: "Why Choose Frigidaire Professional Appliances?",
          title: "Frigidaire Professional Cooktops:",        
          descriptionTxt : "Frigidaire Professional cooktops are crafted for precision cooking with gas, electric, and induction options. Enjoy intuitive controls and durable materials that withstand heavy use."
        },
        {        
          mainHeading: "",
          title: "Frigidaire Professional Refrigerators:",        
          descriptionTxt : "Frigidaire Professional refrigerators offer advanced cooling systems, customizable storage, and spacious designs. Keep your food fresher for longer while adding a modern touch to your kitchen."
        },
        {        
          mainHeading: "",
          title: "Frigidaire Professional Ranges & Ovens:",        
          descriptionTxt : "These ranges and ovens are built for superior cooking results with features like convection baking, air frying, and self-cleaning technology. Choose from gas or electric models tailored to your needs."
        },
        {        
          mainHeading: "",
          title: "Frigidaire Professional Dishwashers:",        
          descriptionTxt : "Engineered for powerful cleaning, Frigidaire Professional dishwashers handle even the toughest messes. With quiet operation and energy-efficient features, cleanup becomes a breeze."
        },
        {        
          mainHeading: "",
          title: "Elevate Your Kitchen with Frigidaire Professional Appliances",        
          descriptionTxt : "Frigidaire Professional appliances are the ideal choice for homeowners seeking high-end performance and style. Whether you're a gourmet chef or need reliable appliances for daily use, this line delivers unmatched quality and innovation."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full range of Frigidaire Professional appliances at Airport Appliance today. With cooktops, refrigerators, ranges, dishwashers, and ovens, you’ll find everything you need to create a kitchen that’s both functional and beautiful."
        },        
      ]
    },
  },
  {
    Gaggenau: {
      id: 12,
      title: "Gaggenau",
      videoLink: "https://www.youtube.com/watch?v=HktLNZLXZPk",
      BannerData: {
        subheading: "The difference is Gaggenau",
        descriptionTxt:
          "Offers luxurious, precision-engineered appliances that embody professional-grade performance and refined craftsmanship.",
        bannerImg: GaggenaubannerImg,
        logoImg: GaggenaulogoImg,
      },
      brandOptions: [
        { 
          img: GaggenauCategory_1,
          title:'Cooktops',
          slug: '/all-brands/gaggenau/cooktops',
          imageFlag: true
        },
        { 
          img: GaggenauCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/gaggenau/refrigerators',
        },
        { 
          img: GaggenauCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/gaggenau/dishwashers',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Gaggenau: Our Luxury Partner",          
          descriptionTxt : "Gaggenau sets the standard for luxury appliances, offering unparalleled craftsmanship, innovative technology, and timeless design. As one of our luxury partners, Gaggenau provides an exquisite range of wall ovens, cooktops, range hoods, refrigerators, dishwashers, freezers, and microwaves designed for the modern, sophisticated kitchen."
        },
        {        
          mainHeading: "Why Choose Gaggenau Appliances?",
          title: "Wall Ovens for Precision Cooking",        
          descriptionTxt : "Gaggenau wall ovens bring professional-grade performance to your home. With cutting-edge features like steam cooking, precise temperature control, and sleek finishes, these ovens allow you to master culinary perfection."
        },
        {        
          mainHeading: "",
          title: "Innovative Cooktops",        
          descriptionTxt : "From induction to gas cooktops, Gaggenau offers options that cater to every cooking style. Their advanced technologies and minimalist designs make cooking an effortless and stylish experience."
        },
        {        
          mainHeading: "",
          title: "Powerful Range Hoods",        
          descriptionTxt : "Gaggenau range hoods combine powerful ventilation with contemporary aesthetics. Engineered for quiet yet effective operation, they keep your kitchen fresh and free from cooking odors."
        },
        {        
          mainHeading: "",
          title: "Premium Refrigerators and Freezers",        
          descriptionTxt : "Gaggenau refrigerators and freezers are designed with precision cooling technology to preserve food at its peak freshness. Their integrated designs ensure they blend seamlessly into your kitchen."
        },
        {        
          mainHeading: "",
          title: "Dishwashers for Seamless Cleaning",        
          descriptionTxt : "Gaggenau dishwashers deliver impeccable cleaning performance with advanced features such as customizable racks, whisper-quiet operation, and energy efficiency."
        },
        {        
          mainHeading: "",
          title: "Microwaves for Modern Convenience",        
          descriptionTxt : "Gaggenau microwaves provide versatile functionality and sleek designs, making meal preparation quick and efficient without compromising style."
        },  
        {        
          mainHeading: "",
          title: "Experience True Luxury with Gaggenau",        
          descriptionTxt : "Gaggenau appliances redefine luxury, offering a blend of timeless aesthetics and state-of-the-art functionality. Whether you’re renovating or upgrading your kitchen, Gaggenau ensures every element reflects sophistication and quality."
        },  
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Visit Airport Appliance today to explore the Gaggenau collection and elevate your culinary space with these premium appliances."
        },      
      ]
    },
  },
  {
    Ge_Appliances: {
      id: 26,
      title: "GE Appliances",
      videoLink: "https://www.youtube.com/watch?v=Oj55FDmni-k",
      BannerData: {
        subheading: "Good Things for Life",
        descriptionTxt: "Reliable, high-quality appliances with a focus on efficiency and ease of use.",
        bannerImg: GE_AppliancesbannerImg,
        logoImg: GE_ApplianceslogoImg,
      },
      brandOptions: [
        { img: GE_AppliancesOption_1,
          title:'Ranges',
          slug: '/all-brands/ge-appliances/ranges',
         },       
        { 
          img: GE_AppliancesOption_2,
          title:'Refrigerators',
          slug: '/all-brands/ge-appliances/refrigerators',
        },
        { 
          img: GE_AppliancesOption_3,
          title:'Wall Ovens',
          slug: '/all-brands/ge-appliances/wall-ovens',
        },
        { 
            img: GE_AppliancesOption_4,
            title:'Dishwashers',
            slug: '/all-brands/ge-appliances/dishwashers',
        },
        { 
          img: GE_AppliancesOption_5,
          title:'Laundry', 
          slug: '/all-brands/ge-appliances/laundry',
        }, 
        { 
          img: GE_AppliancesOption_6,
          title:'Microwaves',
          slug: '/all-brands/ge-appliances/microwaves-otr',
          imageFlag: true
        }, 
      ],
      collectionList: [
        {
          title:"GE Free Hestan Cue Smart Pan Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=YTAHTSDN.pdf",
          descriptionTxt : "Receive a Free Hestan Cue Smart Pan with purchase of qualifying GE Cooking Appliance.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"Monogram One For You One For Free Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=QJCUBZBR.pdf",
          descriptionTxt : "Receive a generous rebate or up to 3 Free Monogram Appliances with purchase of qualifying Monogram Range or Appliance Package.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"GE and GE Profile Fit Guarantee",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EFFOVKSJ.pdf",
          descriptionTxt : "Replace your Cooktop or Wall Oven with a qualifying GE Cooktop, Wall Oven, Advantium Oven, or Slide In Range and receive up to a $300 installation rebate.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"Cafe Fit Guarantee",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=YIAWPIRB.pdf",
          descriptionTxt : "Replace your Cooktop or Wall Oven with a qualifying Cafe Cooktop, Wall Oven, Advantium Oven, or Slide In Range and receive up to a $300 installation rebate.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"Cafe Express Yourself Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EKFWTLSG.pdf",
          descriptionTxt : "Receive up to a $3000 rebate with purchase of qualifying Cafe Appliances.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"GE Profile The Innovation Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=WBUBFXKV.pdf",
          descriptionTxt : "Receive up to a $2000 rebate with purchase of qualifying GE Profile Smarter Innovation Appliance Package.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "GE Appliances combines innovation, reliability, and style to bring you cutting-edge solutions for your kitchen and laundry needs. At Airport Appliance, we offer a wide selection of GE Appliances, including cooktops, refrigerators, ranges, laundry, dishwashers, and ovens. Designed to provide exceptional performance, these appliances bring convenience and modern features to your home, making everyday tasks easier and more efficient."
        },
        {        
          mainHeading: "Why Choose GE Appliances?",
          title: "GE Cooktops:",        
          descriptionTxt : "GE cooktops offer a variety of styles, including gas, electric, and induction models, providing precise control over your cooking. With intuitive controls and sleek designs, these cooktops are perfect for any kitchen."
        },
        {        
          mainHeading: "",
          title: "GE Refrigerators:",        
          descriptionTxt : "Stay organized with GE refrigerators, featuring advanced cooling technology, spacious storage options, and stylish designs. Choose from French door, side-by-side, and bottom-freezer models to suit your kitchen’s needs."
        },
        {        
          mainHeading: "",
          title: "GE Ranges & Ovens:",        
          descriptionTxt : "GE ranges and ovens provide powerful cooking capabilities with features like convection cooking, self-cleaning, and air fry options. Whether you prefer gas or electric, these ranges ensure even cooking and lasting performance."
        },
        {        
          mainHeading: "",
          title: "GE Dishwashers:",        
          descriptionTxt : "With GE dishwashers, you can enjoy a spotless clean with quiet performance and energy-efficient features. Their innovative cleaning systems, like the Piranha™ hard food disposer, remove tough messes effortlessly."
        },
        {        
          mainHeading: "",
          title: "GE Laundry Appliances:",        
          descriptionTxt : "GE laundry appliances, including washers and dryers, are built for reliability and efficiency. With cutting-edge features like steam cleaning and advanced cycles, they help make laundry day simpler."
        },
        {        
          mainHeading: "",
          title: "Upgrade Your Home with GE Appliances",        
          descriptionTxt : "Whether you're looking for a reliable range, a spacious refrigerator, or an efficient dishwasher, GE Appliances offers high-quality products that fit every home. Built with advanced technology and superior performance, these appliances are designed to enhance your everyday life."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full range of GE Appliances at Airport Appliance. From cooktops to laundry appliances, we have everything you need to create a functional, stylish, and efficient home."
        },      
      ]
    },
  },
  {
    Ge_Profile: {
      id: 60,
      title: "GE Profile",
      videoLink: "https://www.youtube.com/watch?v=5nKhUVWMnYU",
      BannerData: { 
        subheading: "Smart Innovation",
        descriptionTxt:
          "Blending smart, modern features with sleek designs to meet the needs of today's tech-savvy users.",
        bannerImg: GE_ProfilebannerImg,
        logoImg: GE_ProfilelogoImg,
      },
      brandOptions: [
        { img: GE_ProfileOption_1,
          title:'Ranges',
          slug: '/all-brands/ge-profile/ranges',
        },       
        { img: GE_ProfileOption_2,
          title:'Refrigerators', 
          slug: '/all-brands/ge-profile/refrigerators',
        },
          { 
            img: GE_ProfileOption_3,
            title:'Wall Ovens', 
            slug: '/all-brands/ge-profile/wall-ovens',
          },
          { img: GE_ProfileOption_4,
            title:'Dishwashers', 
            slug: '/all-brands/ge-profile/dishwashers',
          },
            { 
              img: GE_ProfileOption_5,
              title:'Cooktops',
              slug: '/all-brands/ge-profile/cooktops',
              imageFlag: true
            }, 
              { 
                img: GE_ProfileOption_6,
                title:'Laundry',
                slug: '/all-brands/ge-profile/laundry',
               }, 
      ],
      collectionList: [
        {
          title:"GE Free Hestan Cue Smart Pan Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=YTAHTSDN.pdf",
          descriptionTxt : "Receive a Free Hestan Cue Smart Pan with purchase of qualifying GE Cooking Appliance.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"Monogram One For You One For Free Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=QJCUBZBR.pdf",
          descriptionTxt : "Receive a generous rebate or up to 3 Free Monogram Appliances with purchase of qualifying Monogram Range or Appliance Package.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"GE and GE Profile Fit Guarantee",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EFFOVKSJ.pdf",
          descriptionTxt : "Replace your Cooktop or Wall Oven with a qualifying GE Cooktop, Wall Oven, Advantium Oven, or Slide In Range and receive up to a $300 installation rebate.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"Cafe Fit Guarantee",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=YIAWPIRB.pdf",
          descriptionTxt : "Replace your Cooktop or Wall Oven with a qualifying Cafe Cooktop, Wall Oven, Advantium Oven, or Slide In Range and receive up to a $300 installation rebate.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"Cafe Express Yourself Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EKFWTLSG.pdf",
          descriptionTxt : "Receive up to a $3000 rebate with purchase of qualifying Cafe Appliances.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"GE Profile The Innovation Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=WBUBFXKV.pdf",
          descriptionTxt : "Receive up to a $2000 rebate with purchase of qualifying GE Profile Smarter Innovation Appliance Package.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "GE Profile brings the perfect blend of cutting-edge technology, sleek design, and advanced features to your home. At Airport Appliance, we offer an exclusive selection of GE Profile appliances, including refrigerators, ranges, dishwashers, ovens, and laundry appliances. Engineered to elevate your kitchen and laundry experience, GE Profile appliances are designed with your convenience and efficiency in mind."
        },
        {        
          mainHeading: "Why Choose GE Profile Appliances?",
          title: "GE Profile Refrigerators:",        
          descriptionTxt : "GE Profile refrigerator are built with advanced cooling systems and spacious designs to keep your food fresh longer. With options like French door, side-by-side, and bottom-freezer models, you'll find a refrigerator that perfectly fits your space."
        },
        {        
          mainHeading: "",
          title: "GE Profile Ranges & Ovens:",        
          descriptionTxt : "For exceptional cooking performance, GE Profile ranges and ovens are equipped with features like convection cooking, air fry, and self-cleaning technology. Whether you prefer gas or electric, these appliances provide precise control and even cooking."
        },
        {        
          mainHeading: "",
          title: "GE Profile Dishwashers:",        
          descriptionTxt : "Experience the power of a GE Profile dishwasher with its quiet operation and innovative cleaning systems. Features like the Piranha™ hard food disposer ensure tough messes are tackled with ease, leaving your dishes sparkling clean."
        },
        {        
          mainHeading: "",
          title: "GE Profile Laundry Appliances:",        
          descriptionTxt : "Make laundry day easier with GE Profile washers and dryers. These appliances combine advanced features like steam cleaning and high-efficiency cycles to give you cleaner clothes and a smoother laundry experience."
        },
        {        
          mainHeading: "",
          title: "Elevate Your Home with GE Profile Appliances",        
          descriptionTxt : "Designed for those who demand the best, GE Profile appliances offer premium features that make everyday tasks simpler and more efficient. From sleek refrigerators to high-performance ranges, these appliances deliver both form and function."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the full selection of GE Profile appliances at Airport Appliance today. Whether you're upgrading your kitchen or laundry, you'll find the perfect appliances to suit your lifestyle and enhance your home."
        },      
      ]
    },
  },
  {
    Haier : {
      id: 52,
      title: "Haier",
      videoLink: "https://www.youtube.com/watch?v=DEj8TGyU4Wg",
      BannerData: {
        subheading: "Born for the City",
        descriptionTxt:"Offers affordable, smart, and compact appliances for modern, space-saving living.",
        bannerImg: HaierbannerImg,
        logoImg: HaierlogoImg,
      },
      brandOptions: [
        { img: HaierOption_1,
          title:'Ranges', 
          slug: '/all-brands/haier/ranges',
        },       
        { 
          img: HaierOption_2,
          title:'Refrigerators',
          slug: '/all-brands/haier/refrigerators',
        },
          { 
            img: HaierOption_3,
            title:'Dishwashers',
            slug: '/all-brands/haier/dishwashers',
            },
          { img: HaierOption_4,
            title:'Microwaves',
            slug: '/all-brands/haier/microwaves-otr',
            imageFlag: true
          },
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Haier Appliances is committed to providing innovative, high-performance solutions for your home. At Airport Appliance, we offer a range of Haier appliances, including refrigerators, ranges, dishwashers, and ovens, designed to enhance your home with modern features and exceptional quality. Whether you're upgrading your kitchen or replacing an old appliance, Haier offers reliable products that combine style, innovation, and functionality."
        },
        {        
          mainHeading: "Why Choose Haier Appliances?",
          title: "Haier Refrigerators:",        
          descriptionTxt : "Haier refrigerators are designed to provide flexibility, ample storage space, and cutting-edge cooling technology. With a variety of models, including French door and bottom-freezer options, you'll find the perfect refrigerator to suit your kitchen."
        },
        {        
          mainHeading: "",
          title: "Haier Ranges & Ovens:",        
          descriptionTxt : "Haier offers a variety of ranges and ovens, including gas, electric, and dual-fuel models, all built for superior cooking performance. Features like convection baking and self-cleaning technology ensure your meals are cooked to perfection with ease."
        },
        {        
          mainHeading: "",
          title: "Haier Dishwashers:",        
          descriptionTxt : "Efficient and quiet, Haier Haier dishwashers tackle tough messes with ease, leaving your dishes spotless. Their space-saving design and energy-efficient features make cleanup hassle-free while conserving water and energy."
        },
        {        
          mainHeading: "",
          title: "Innovative Design and Performance",        
          descriptionTxt : "Haier appliances are built with your needs in mind, offering smart solutions for modern living. Whether you're looking to upgrade your kitchen or streamline your home, Haier appliances combine convenience, modern technology, and contemporary designs to suit your style."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Discover the full range of Haier appliances at Airport Appliance today. From refrigerators to dishwashers, explore our collection of high-quality appliances that deliver efficiency and style, making your home more functional and beautiful."
        }      
      ]
    },
  },
  {
    Hotpoint : {
      id: 53,
      title: "Hotpoint",
      videoLink: "https://www.youtube.com/watch?v=kshvsVh7GsQ",
      BannerData: {
        subheading: "Hard Working Appliances",
        descriptionTxt:
          "Our appliances were built on work as hard as you do. We take on chores and get them done – day in and day out.",
        bannerImg: HotpointbannerImg,
        logoImg: HotpointlogoImg,
      },
      brandOptions: [
        { img: HotpointOption_1,
          title:'Ranges',
          slug: '/all-brands/hotpoint/ranges',
         },       
        { img: HotpointOption_2,
          title:'Refrigerators',
          slug: '/all-brands/hotpoint/refrigerators',
         },
          { img: HotpointOption_3,
            title:'Dishwashers', 
            slug: '/all-brands/hotpoint/dishwashers',
          },
          { img: HotpointOption_4,
            title:'Microwaves',
            slug: '/all-brands/hotpoint/microwaves-otr',
            imageFlag: true
          },
            { img: HotpointOption_5,
              title:'Laundry',
             slug: '/all-brands/hotpoint/laundry',
             },  
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Hotpoint Appliances offers dependable, high-performance appliances designed to meet the needs of busy households. At Airport Appliance, we proudly carry a selection of Hotpoint appliances, including ranges, Refrigerators, Laundry, Microwaves, and dishwashers. Whether you're remodeling your kitchen or updating your laundry room, Hotpoint appliances are the perfect combination of quality, functionality, and value."
        },
        {        
          mainHeading: "Why Choose Hotpoint Appliances?",
          title: "Hotpoint Ranges:",        
          descriptionTxt : "Hotpoint ranges deliver powerful cooking performance with both gas and electric options, making it easy to prepare your favorite meals. With advanced features like self-cleaning and large oven capacities, these ranges make cooking convenient and efficient."
        },
        {        
          mainHeading: "",
          title: "Hotpoint Refrigerators:",        
          descriptionTxt : "Keep your food fresh with Hotpoint refrigerator, offering plenty of storage space and reliable cooling technology. Available in top-freezer and bottom-freezer models, these refrigerators are designed to fit your home and lifestyle."
        },
        {        
          mainHeading: "",
          title: "Hotpoint Laundry Appliances:",        
          descriptionTxt : "Hotpoint laundry appliances help streamline your laundry routine. With energy-efficient washers and dryers, you can clean clothes with ease while saving time and money."
        },
        {        
          mainHeading: "",
          title: "Hotpoint Microwaves:",        
          descriptionTxt : "From reheating leftovers to cooking full meals, Hotpoint microwaves offer convenience and reliability. With easy-to-use features and spacious interiors, these microwaves fit seamlessly into your kitchen."
        },
        {        
          mainHeading: "",
          title: "Hotpoint Dishwashers:",        
          descriptionTxt : "Hotpoint dishwashers are designed to handle everyday messes with powerful cleaning capabilities, leaving your dishes spotless. Quiet and efficient, they offer advanced features like multiple wash cycles for all your cleaning needs."
        },
        {        
          mainHeading: "",
          title: "Upgrade Your Home with Hotpoint Appliances",        
          descriptionTxt : "At Airport Appliance, we offer a wide range of Hotpoint appliances to fit your home’s needs. Known for their durability, value, and efficiency, Hotpoint appliances are the smart choice for homeowners looking to enhance their kitchens and laundry rooms."
        },   
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore our full selection of Hotpoint appliances today at Airport Appliance. From ranges to dishwashers, you’ll find the right appliance to fit your lifestyle and budget."
        },   
      ]
    },
  },
  {
    Jennair: {
      id: 16,
      title: "Jennair",
      videoLink: "https://www.youtube.com/watch?v=fMVlaVip2g8",
      BannerData: {
        subheading: "Bound by Nothing",
        descriptionTxt:
          "Known for bold, innovative designs and powerful performance that defies convention in luxury kitchens.",
        bannerImg: JennairbannerImg,
        logoImg: JennairlogoImg,
      },
      brandOptions: [
        { 
          img: JennairCategory_1,
          title:'Ranges',
          slug: '/all-brands/jennair/ranges',
        },
        { 
          img: JennairCategory_2,
          title:'Refrigerators', 
          slug: '/all-brands/jennair/refrigerators',
        },
        { 
          img: JennairCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/jennair/dishwashers',
        }
      ],
      collectionList: [
        {
          title:"JennAir Delivery Or Installation Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=CMS&FORM_NUMBER=524464",
          descriptionTxt : "Receive up to a $750 Delivery or Installation rebate with purchase of qualifying JennAir Built In Refrigerator.",
          validDate:"valid from 10/1/2024 to 12/31/2024"
        },
        {
          title:"JennAir Curate Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=KVTZCKVI.pdf",
          descriptionTxt : "Receive up to 15% off in instant savings with purchase of 2 or more qualifying JennAir Appliances.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "JennAir: Our Luxury Partner",          
          descriptionTxt : "JennAir appliances redefine modern luxury with bold designs, exceptional performance, and innovative features. As one of our trusted luxury partners, JennAir offers a comprehensive range of high-end appliances, including refrigerators, cooktops, ranges, wall ovens, dishwashers, microwaves, and range hoods, perfect for the discerning homeowner."
        },
        {        
          mainHeading: "Why Choose JennAir Appliances?",
          title: "Refrigerators for Fresh Innovation",        
          descriptionTxt : "JennAir refrigerators are engineered to provide optimal freshness and modern aesthetics. From built-in models to counter-depth options, these appliances bring unmatched cooling performance and seamless integration into your kitchen design."
        },
        {        
          mainHeading: "",
          title: "Cooktops for Every Culinary Style",        
          descriptionTxt : "JennAir cooktops feature precision controls, powerful burners, and sleek designs. Whether you prefer induction, gas, or electric cooking, JennAir offers a cooktop to suit your culinary needs."
        },
        {        
          mainHeading: "",
          title: "Premium Ranges for Professional Cooking",        
          descriptionTxt : "JennAir ranges combine cutting-edge technology with high-performance capabilities. Experience versatility with dual-fuel, gas, or electric ranges, all crafted to deliver chef-inspired results."
        },
        {        
          mainHeading: "",
          title: "Wall Ovens with Advanced Features",        
          descriptionTxt : "JennAir wall ovens boast innovative features like touchscreen interfaces, precision cooking modes, and sleek designs, making every meal a masterpiece."
        },
        {        
          mainHeading: "",
          title: "Range Hoods for Superior Ventilation",        
          descriptionTxt : "JennAir range hoods deliver powerful yet quiet ventilation. Designed for style and efficiency, these hoods complement your kitchen while keeping it fresh."
        },
        {        
          mainHeading: "",
          title: "Dishwashers Built for Seamless Cleaning",        
          descriptionTxt : "JennAir dishwashers provide advanced cleaning power with minimal noise. With customizable racks and energy-efficient designs, they blend style with practicality."
        },   
        {        
          mainHeading: "",
          title: "Microwaves for Modern Convenience",        
          descriptionTxt : "JennAir microwaves offer multifunctional use with sleek aesthetics. Perfect for reheating, defrosting, or quick meal prep, they are an essential addition to your kitchen."
        },   
        {        
          mainHeading: "",
          title: "Elevate Your Home with JennAir",        
          descriptionTxt : "JennAir appliances are crafted for those who demand both luxury and performance. With cutting-edge technology and refined designs, JennAir transforms ordinary kitchens into extraordinary spaces."
        },     
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Discover the JennAir collection at Airport Appliance and bring innovation, sophistication, and excellence into your home."
        },     
      ]
    },
  },
  {
    Kitchenaid: {
      id: 56,
      title: "KitchenAid",
      videoLink: "https://www.youtube.com/watch?v=Kbg-JagsZLY",
      BannerData: {
        subheading: "For the way it's made",
        descriptionTxt:
          "Celebrates craftsmanship and culinary passion with appliances that empower home cooks and professionals alike.",
        bannerImg: KitchenAidbannerImg,
        logoImg: KitchenAidlogoImg,
      },
      brandOptions: [
        { 
          img: KitchenAidCategory_1,
          title:'Dishwashers',
          slug: '/all-brands/kitchenaid/dishwashers',
        },
        { 
          img: KitchenAidCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/kitchenaid/refrigerators',
        },
        { 
          img: KitchenAidCategory_3,
          title:'Microwaves',
          imageFlag: true,
          slug: '/all-brands/kitchenaid/microwaves-otr',
        }
      ],
      collectionList: [
        {
          title:"KitchenAid Craft Your Dream Kitchen Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=MINHTGTJ.pdf",
          descriptionTxt : "Receive up to a $3000 rebate with purchase of qualifying KitchenAid Brand Appliances.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },       
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "KitchenAid Appliances are crafted to provide both exceptional performance and timeless style. At Airport Appliance, we offer a comprehensive selection of KitchenAid appliances, including refrigerators, ranges, wall ovens, cooktops, dishwashers, microwaves, range hoods, and more. Designed for those who demand the best in their kitchens, KitchenAid combines innovation with sophistication for an outstanding cooking experience."
        },
        {        
          mainHeading: "Why Choose KitchenAid Appliances?",
          title: "KitchenAid Refrigerators:",        
          descriptionTxt : "Keep your food fresh with KitchenAid refrigerators, offering spacious interiors, advanced cooling systems, and flexible storage options. Choose from French door, side-by-side, or bottom-freezer models to suit your kitchen style and storage needs."
        },
        {        
          mainHeading: "",
          title: "KitchenAid Ranges & Wall Ovens:",        
          descriptionTxt : "Whether you prefer a gas, electric, or dual-fuel range, KitchenAid ranges deliver professional-grade performance. Their wall ovens provide even cooking with features like convection baking, ensuring that your meals are prepared to perfection."
        },
        {        
          mainHeading: "",
          title: "KitchenAid Cooktops:",        
          descriptionTxt : "Cooktops from KitchenAid offer precision and control for all your cooking needs. With options like induction and gas cooktops, you’ll have the right tool to prepare a variety of dishes."
        },
        {        
          mainHeading: "",
          title: "KitchenAid Dishwashers:",        
          descriptionTxt : "Known for their quiet operation and powerful cleaning, KitchenAid dishwashers make after-meal cleanup effortless. With features like adjustable racks, multiple wash cycles, and energy-efficient performance, these dishwashers get the job done with ease."
        },
        {        
          mainHeading: "",
          title: "KitchenAid Microwaves & Range Hoods:",        
          descriptionTxt : "The microwaves from KitchenAid offer powerful cooking and defrosting capabilities, while their Range Hoods effectively remove smoke and odors, ensuring your kitchen stays fresh."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the complete collection of KitchenAid appliances today at Airport Appliance and elevate your kitchen to new heights of style and functionality."
        },
      ]
    },
  },
  {
    Lg: {
      id: 4,
      title: "LG",
      videoLink: "https://www.youtube.com/watch?v=FANUoTrOJQM",
      BannerData: {
        subheading: "Life's Good",
        descriptionTxt:
          "Known for cutting-edge technology and smart innovations that enhance convenience in everyday life.",
        bannerImg: LG_AppliancesbannerImg,
        logoImg: LG_ApplianceslogoImg,
      },
      brandOptions: [
        { 
          img: LG_AppliancesCategory_1,
          title:'Washers',
          slug: '/all-brands/lg/laundry/washers',
        },
        { 
          img: LG_AppliancesCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/lg/refrigerators',
        },
        { 
          img: LG_AppliancesCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/lg/dishwashers',
        },
        { 
          img: LG_AppliancesCategory_4,
          title:'Microwaves',
          slug: '/all-brands/lg/microwaves-otr',
          imageFlag: true

        }
      ],
      collectionList: [
        {
          title:"LG ThinQ Appliances",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EBGSWBGM.pdf",
          descriptionTxt : "Purchase a qualifying LG product and register it through ThinQ app to receive a free 1 Year Extension on Manufacturer Warranty, valued up to $185",
          validDate:"valid from 7/11/2024 to 12/31/2024"
        },
        {
          title:"LG Buy More Save More Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=ECEMADJJ.pdf",
          descriptionTxt : "Receive up to a $1000 rebate with purchase of 2 or more qualifying LG Appliances.",
          validDate:"valid from 12/5/2024 to 1/1/2025"
        },
        {
          title:"LG ThinQ Care Warranty Promo",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EBGSWBGM.pdf",
          descriptionTxt : "Purchase a qualifying LG product and register it through ThinQ app to receive a free 1 Year Extension on Manufacturer Warranty, valued up to $185",
          validDate:"valid from 7/11/2024 to 12/31/2024"
        }
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "LG Appliances combine cutting-edge technology with sleek designs to elevate your home. At Airport Appliance, we offer a wide selection of LG appliances, including laundry machines, refrigerators, ranges, cooktops, dishwashers, microwaves, wall ovens, and range hoods. These innovative appliances are built to provide efficient, reliable, and stylish solutions for every household need."
        },
        {        
          mainHeading: "Why Choose LG Appliances?",
          title: "LG Laundry Machines:",        
          descriptionTxt : "LG laundry appliances offer innovative features such as TurboWash™, AI-powered cycles, and steam cleaning options, providing exceptional cleaning performance and energy efficiency. Whether you're looking for washers or dryers, LG makes laundry tasks easier and more efficient."
        },
        {        
          mainHeading: "",
          title: "LG Refrigerators:",        
          descriptionTxt : "Keep your food fresh with LG’s advanced refrigerators. Featuring spacious interiors, energy-efficient cooling systems, and modern innovations like InstaView™ and Door-in-Door® designs, these refrigerators offer both style and functionality for your kitchen."
        },
        {        
          mainHeading: "",
          title: "LG Ranges & Wall Ovens:",        
          descriptionTxt : "Prepare your meals with precision using LG ranges and wall ovens. With options like convection cooking, air fry, and easy-to-clean surfaces, LG ranges and ovens ensure that every dish is cooked to perfection."
        },
        {        
          mainHeading: "",
          title: "LG Cooktops & Range Hoods:",        
          descriptionTxt : "LG cooktops and range hoods are designed to complement any kitchen. Their modern designs and high-efficiency features provide both performance and elegance, ensuring you have a clean, stylish cooking environment."
        },
        {        
          mainHeading: "",
          title: "LG Dishwashers & Microwaves:",        
          descriptionTxt : "LG LG dishwashers offer quiet operation and powerful cleaning performance, while their microwaves deliver fast and even cooking. Both provide convenient solutions for your kitchen needs, saving you time and energy.h."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Elevate your kitchen and laundry room with the innovation and style of LG Appliances, available now at Airport Appliance. Explore our wide range of LG products to find the perfect fit for your home."
        },     
      ]
    },
  },
  {
    Lg_Studio: {
      id: 29,
      title: "LG Studio",
      videoLink: "https://www.youtube.com/watch?v=FANUoTrOJQM",
      BannerData: {
        subheading: "The Art of Essence",
        descriptionTxt:
          "Combines minimalist design with premium performance for a high-end, modern kitchen experience.",
        bannerImg: LG_StudiobannerImg,
        logoImg: LG_StudiologoImg,
      },
      brandOptions: [
        { 
          img: LG_StudioCategory_1,
          title:'Refrigerators',
          slug: '/all-brands/lg-studio/refrigerators',
        },
        { 
          img: LG_StudioCategory_2,
          title:'Microwaves',
          imageFlag: true,
          slug: '/all-brands/lg-studio/microwaves-otr',
        },
        { 
          img: LG_StudioCategory_3,
          title:'Laundry Centers',
          slug: '/all-brands/lg-studio/laundry/stacked-washer-dryer-sets',
        },
        { 
          img: LG_StudioCategory_4,
          title:'Dishwashers',
          slug: '/all-brands/lg-studio/dishwashers',
        }
      ],
      collectionList: [
        {
          title:"LG ThinQ Appliances",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EBGSWBGM.pdf",
          descriptionTxt : "Purchase a qualifying LG product and register it through ThinQ app to receive a free 1 Year Extension on Manufacturer Warranty, valued up to $185",
          validDate:"valid from 7/11/2024 to 12/31/2024"
        },
        {
          title:"LG ThinQ Care Warranty Promo",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EBGSWBGM.pdf",
          descriptionTxt : "Purchase a qualifying LG product and register it through ThinQ app to receive a free 1 Year Extension on Manufacturer Warranty, valued up to $185",
          validDate:"valid from 7/11/2024 to 12/31/2024"
        }
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "LG Studio Appliances provide the perfect blend of luxury, innovation, and performance. Designed for those who demand the best, LG Studio offers a wide range of high-end kitchen and laundry appliances that combine sleek aesthetics with cutting-edge technology. At Airport Appliance, we offer a premium selection of LG Studio products, including cooktops, refrigerators, ranges, wall ovens, dishwashers, microwaves, laundry appliances, and range hoods."
        },
        {        
          mainHeading: "Why Choose LG Studio Appliances?",
          title: "Luxury Design & Innovation:",        
          descriptionTxt : "LG Studio appliances offer stunning, modern designs that elevate your home. From sleek cooktops to elegant refrigerators, each piece is crafted to bring a sophisticated and high-end look to your kitchen and laundry room."
        },
        {        
          mainHeading: "",
          title: "Advanced Cooking Features:",        
          descriptionTxt : "LG Studio ranges, cooktops, and wall ovens come equipped with advanced cooking technology such as SmartThinQ™, convection cooking, and air fry options. These appliances offer superior cooking performance for all your culinary needs."
        },
        {        
          mainHeading: "",
          title: "Efficient & Smart Laundry Solutions:",        
          descriptionTxt : "LG Studio laundry appliances are built with smart features, like TurboWash™ and AI-powered cycles, for optimal cleaning efficiency. With energy-saving options, these washers and dryers make laundry day easier and more eco-friendly."
        },
        {        
          mainHeading: "",
          title: "Powerful Range Hoods & Microwaves:",        
          descriptionTxt : "LG Studio’s range hoods and microwaves are designed to seamlessly blend into your kitchen while providing high-end performance. Keep your kitchen air clean with quiet, efficient ventilation, and enjoy fast, even cooking with state-of-the-art microwave technology."
        },
        {        
          mainHeading: "",
          title: "Top-Tier Dishwashers:",        
          descriptionTxt : "LG Studio dishwashers combine powerful cleaning with quiet operation. Featuring TrueSteam™ technology and sleek designs, these dishwashers ensure your dishes are spotless while maintaining a stylish kitchen atmosphere."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Elevate your living space with the luxurious features and sophisticated design of LG Studio Appliances, available at Airport Appliance. Explore our collection to bring top-tier performance and elegance to your home."
        },     
      ]
    },
  },
  {
    Liebherr: {
      id: 30,
      title: "Liebherr",
      videoLink: "https://www.youtube.com/watch?v=ySO9MW5yooc",
      BannerData: {
        subheading: "Superior Cooling Performance",
        descriptionTxt:
          "Transform your kitchen into the ultimate safe haven for your fresh ingredients with advanced compartments that keep food crisp, flavorful, and nutrient-rich longer.",
        bannerImg: LiebherrbannerImg,
        logoImg: LiebherrlogoImg,
      },
      brandOptions: [
        {
          img: LiebherrOption_1,
          title:'French Door Refrigerators',
          slug: '/all-brands/liebherr/refrigerators/french-door-refrigerators',
        },     
        { 
          img: LiebherrOption_2,
          title:'Bottom Freezer Refrigerators', 
          slug: '/all-brands/liebherr/refrigerators/bottom-freezer-refrigerators',
        },  
        { 
          img: LiebherrOption_3,
          title:'Wine Coolers', 
          slug: '/all-brands/liebherr/wine-coolers',
        },       
        { 
          img: LiebherrOption_4,
          title:'Freezers',
          slug: '/all-brands/liebherr/freezers',
        }, 
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Liebherr: Our Luxury Partner",          
          descriptionTxt : "Lieherr is synonymous with excellence in refrigeration. As one of our esteemed luxury partners, Liebherr offers an unparalleled selection of premium refrigerators and freezers designed to meet the highest standards of quality, performance, and style."
        },
        {        
          mainHeading: "Why Choose Liebherr Appliances?",
          title: "Refrigerators Crafted for Modern Living",        
          descriptionTxt : "Liebherr refrigerators feature innovative cooling technologies to preserve freshness and taste. With advanced features like BioFresh compartments, soft-close doors, and energy-efficient operation, these refrigerators are ideal for modern homes."
        },
        {        
          mainHeading: "",
          title: "Freezers Designed for Efficiency",        
          descriptionTxt : "Liebherr freezers combine cutting-edge technology with sleek European aesthetics. With features like frost-free operation, rapid freezing capabilities, and smart storage designs, they deliver exceptional convenience and performance."
        },
        {        
          mainHeading: "",
          title: "Energy-Efficient Excellence",        
          descriptionTxt : "Liebherr appliances are designed with sustainability in mind, offering energy-efficient solutions that help reduce your environmental footprint without compromising on performance."
        },
        {        
          mainHeading: "",
          title: "Sleek and Functional Designs",        
          descriptionTxt : "With clean lines and high-quality finishes, Liebherr refrigerators and freezers seamlessly integrate into any kitchen style, from contemporary to classic."
        },
        {        
          mainHeading: "",
          title: "Transform Your Kitchen with Liebherr",        
          descriptionTxt : "Liebherr appliances bring the perfect balance of sophistication, innovation, and practicality to your home. Whether you need a high-capacity refrigerator for your family or a freezer for your culinary creations, Liebherr offers solutions tailored to your lifestyle."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Shop the Liebherr collection at Airport Appliance today and elevate your home with premium refrigeration solutions."
        },     
      ]
    },
  },
  {
    Marvel: {
      id: 58,
      title: "Marvel Refrigeration",
      videoLink: "https://www.youtube.com/watch?v=6AgtRzy7GqA",
      BannerData: {
        subheading: "Discover the Marvel Difference",
        descriptionTxt:
          "Known for premium under-counter refrigeration with advanced cooling technology and superior design.",
        bannerImg: Marvel_RefrigerationbannerImg,
        logoImg: Marvel_RefrigerationlogoImg,
      },
      brandOptions: [
        { 
          img: Marvel_RefrigerationCategory_1,
          title:'Undercounter Ice Makers',
          slug: '/all-brands/marvel/ice-makers/undercounter-ice-makers',
        },
        { 
          img: Marvel_RefrigerationCategory_2,
          title:'Beverage Centers',
          slug: '/all-brands/marvel/beverage-centers',
        },
        { 
          img: Marvel_RefrigerationCategory_3,
          title:'Beer Coolers & Kegerators',
          slug: '/all-brands/marvel/beer-coolers-&-kegerators',
        },
        { 
          img: Marvel_RefrigerationCategory_4,
          title:'Freezers',
          slug: '/all-brands/marvel/freezers',
        },
        { 
          img: Marvel_RefrigerationCategory_5,
          title:'Wine Coolers',
          slug: '/all-brands/marvel/wine-coolers',
        },        
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Marvel Appliances are known for their high-end refrigeration and freezing solutions, perfect for anyone who values both style and performance. At Airport Appliance, we offer a carefully curated selection of Marvel products, including refrigerators, freezers, and ice makers, designed to meet the needs of the modern home."
        },
        {        
          mainHeading: "Why Choose Marvel Appliances?",
          title: "Premium Refrigerators:",        
          descriptionTxt : "Marvel refrigerators combine innovative cooling technology with stylish designs. With advanced features like dual cooling systems and spacious interiors, these refrigerators keep your food fresher for longer while adding elegance to your kitchen."
        },
        {        
          mainHeading: "",
          title: "Freezers & Ice Makers:",        
          descriptionTxt : "Marvel’s freezers and ice makers provide reliable and efficient solutions for your kitchen storage. With sleek, space-saving designs, these appliances are perfect for those looking to maximize their storage capacity without compromising on aesthetics or performance."
        },
        {        
          mainHeading: "",
          title: "Customizable Features:",        
          descriptionTxt : "Marvel appliances are built for those who want to personalize their kitchen space. From customizable storage options to professional-grade finishes, Marvel offers flexible choices that blend seamlessly with your home’s style."
        },
        {        
          mainHeading: "",
          title: "Energy-Efficient Performance:",        
          descriptionTxt : "Marvel is committed to energy efficiency, helping you save on utility bills while ensuring that your appliances run smoothly and reliably. Their refrigerators and freezers are designed to be as eco-friendly as they are functional."
        },    
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Marvel Appliances offer unparalleled cooling solutions, combining luxury with performance. Browse our selection at Airport Appliance to find the perfect refrigeration and freezing products for your home."
        },     
      ]
    },
  },
  {
    Maytag: {
      id: 59,
      title: "Maytag",
      videoLink: "https://www.youtube.com/watch?v=0bwG7LIcuvo",
      BannerData: {
        subheading: "What's Inside Matters",
        descriptionTxt:
          "Trusted for its robust, dependable appliances that withstand heavy use and tough conditions.",
        bannerImg: MaytagbannerImg,
        logoImg: MaytaglogoImg,
      },
      brandOptions: [
        { 
          img: MaytagCategory_1,
          title:'Washers',
          slug: '/all-brands/maytag/laundry/washers',
        },
        { 
          img: MaytagCategory_2,
          title:'Dishwashers',
          slug: '/all-brands/maytag/dishwashers',
        },
        { 
          img: MaytagCategory_3,
          title:'Refrigerators',
          slug: '/all-brands/maytag/refrigerators',
        },
        { 
          img: MaytagCategory_4,
          title:'Ranges',
          slug: '/all-brands/maytag/ranges',
        } 
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Maytag Appliances are built to provide dependable, long-lasting performance, making them a trusted choice for homeowners who want appliances that can handle tough tasks day in and day out. At Airport Appliance, we offer a wide selection of Maytag products, including laundry machines, refrigerators, ranges, dishwashers, microwaves, cooktops, and wall ovens, designed to meet the needs of busy households."
        },
        {        
          mainHeading: "Why Choose Maytag Appliances?",
          title: "Durability & Power:",        
          descriptionTxt : "Maytag is renowned for its durable and reliable appliances. Whether you need a heavy-duty washing machine or a refrigerator built to withstand everyday use, Maytag offers powerful performance that you can rely on for years to come."
        },
        {        
          mainHeading: "",
          title: "Laundry Excellence:",        
          descriptionTxt : "Maytag washers and dryers are designed to tackle even the toughest laundry loads. With advanced features like PowerWash® and Extra Power™, you can get cleaner, fresher clothes in less time while ensuring long-lasting quality."
        },
        {        
          mainHeading: "",
          title: "Efficient Refrigeration & Cooking:",        
          descriptionTxt : "Maytag refrigerators offer ample storage and innovative cooling features, keeping your food fresh. Their ranges, cooktops, and wall ovens are equipped with advanced cooking technologies, like True Convection, to help you prepare meals with precision and ease."
        },
        {        
          mainHeading: "",
          title: "Easy-to-Use Dishwashers & Microwaves:",        
          descriptionTxt : "Maytag dishwashers feature powerful cleaning cycles and quiet operation, ensuring that your dishes are spotless with minimal effort. The microwaves provide fast, even cooking, ideal for busy families looking for convenience and efficiency."
        },    
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "With Maytag Appliances, you get reliability, power, and efficiency, all wrapped in sleek, modern designs. Visit Airport Appliance to explore our range of Maytag products, perfect for upgrading your home with appliances that work as hard as you do."
        },     
      ]
    },
  },
  {
    Miele: {
      id: 2,
      title: "Miele",
      videoLink: "https://www.youtube.com/watch?v=tz5Du0a2OnY",
      BannerData: {
        subheading: "Forever Better",
        descriptionTxt:
          "German engineering, offering high-end appliances that deliver long-lasting performance and precision.",
        bannerImg: MielebannerImg,
        logoImg: MielelogoImg,
      },
      brandOptions: [
        { 
          img: MieleCategory_1,
          title:'Washers',
          slug: '/all-brands/miele/laundry/washers',
        },
        { 
          img: MieleCategory_2,
          title:'Dishwashers',
          slug: '/all-brands/miele/dishwashers',
        },
        { 
          img: MieleCategory_3,
          title:'Microwaves',
          slug: '/all-brands/miele/microwaves-otr',
          imageFlag: true
        }
      ],
      collectionList: [
        {
          title:"Miele Elevate Your Kitchen Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=DSERFZFA.pdf",
          descriptionTxt : "Receive up to a $7500 Rebate with purchase of qualifying Miele Kitchen Appliances.",
          validDate:"valid from 3/1/2024 to 12/31/2024"
        },
      ],      
      contentList:[
          {        
            mainHeading: "",
            title: "Miele: Our Luxury Partner",          
            descriptionTxt : "Miele appliances bring unparalleled performance, innovation, and luxury to your home. As one of our luxury partners, Miele offers a diverse collection of high-end appliances, including wall ovens, cooktops, dishwashers, range hoods, refrigerators, and more, designed to elevate your kitchen and laundry spaces."
          },
          {        
            mainHeading: "Why Choose Miele Appliances?",
            title: "Wall Ovens for Precision Cooking",        
            descriptionTxt : "Miele wall ovens combine cutting-edge technology with elegant design. Features like touch controls, advanced cooking modes, and even heat distribution ensure precise results for every dish, whether you’re baking, roasting, or broiling."
          },
          {        
            mainHeading: "",
            title: "Cooktops for Culinary Versatility",        
            descriptionTxt : "Miele cooktops deliver exceptional cooking performance with sleek, minimalist designs. From gas to induction, these cooktops provide precise temperature control for both casual cooking and gourmet creations."
          },
          {        
            mainHeading: "",
            title: "Dishwashers with Superior Cleaning Power",        
            descriptionTxt : "Miele dishwashers are renowned for their quiet operation, advanced cleaning technologies, and energy-efficient designs. Customizable racks and specialized wash cycles ensure spotless results for every load."
          },
          {        
            mainHeading: "",
            title: "Refrigerators for Freshness and Style",        
            descriptionTxt : "Miele refrigerators combine innovative cooling systems with luxurious interiors. Keep your ingredients fresh longer while enhancing your kitchen's design with their seamless, built-in options."
          },    
          {        
            mainHeading: "",
            title: "Range Hoods with Powerful Ventilation",        
            descriptionTxt : "Miele range hoods offer superior ventilation to keep your kitchen air clean and fresh. With quiet operation and sleek aesthetics, they are a functional and stylish addition to any cooking space."
          },  
          {        
            mainHeading: "",
            title: "Experience the Miele Difference",        
            descriptionTxt : "Miele’s commitment to excellence ensures that every appliance delivers outstanding performance and lasting durability. Whether you're upgrading your kitchen or optimizing your laundry space, Miele offers solutions that blend functionality, style, and innovation seamlessly."
          },  
          {        
            mainHeading: "",
            title: "",        
            descriptionTxt : "Explore the premium range of Miele appliances at Airport Appliance and elevate your home with appliances designed to inspire and perform."
          },   
      ]
    },
  },
  {
    Monogram : {
      id: 47,
      title: "Monogram",
      videoLink: "https://www.youtube.com/watch?v=OkBA6EbXB7c",
      BannerData: {
        subheading: "Elevate Everything",
        descriptionTxt:
          "Delivers luxury kitchen appliances with elegant design and advanced culinary features.",
        bannerImg: MonogrambannerImg,
        logoImg: MonogramlogoImg,
      },
      brandOptions: [
        { 
          img: MonogramOption_1,
          title:'Ranges',
          slug: '/all-brands/monogram/ranges',
         },       
        { 
          img: MonogramOption_2,
          title:'Refrigerators',
          slug: '/all-brands/monogram/refrigerators',
        },
        { 
          img: MonogramOption_3,
          title:'Wall Ovens', 
          slug: '/all-brands/monogram/wall-ovens',
        },
        { 
          img: MonogramOption_4,
          title:'Dishwashers', 
          slug: '/all-brands/monogram/dishwashers',
        },
        { 
          img: MonogramOption_5,
          title:'Cooktops',
          slug: '/all-brands/monogram/cooktops',
          imageFlag: true
        }
      ],
      collectionList: [
        {
          title:"Monogram One For You One For Free Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=QJCUBZBR.pdf",
          descriptionTxt : "Receive a generous rebate or up to 3 Free Monogram Appliances with purchase of qualifying Monogram Range or Appliance Package.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"Cafe Express Yourself Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EKFWTLSG.pdf",
          descriptionTxt : "Receive up to a $3000 rebate with purchase of qualifying Cafe Appliances.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
        {
          title:"GE Profile The Innovation Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=WBUBFXKV.pdf",
          descriptionTxt : "Receive up to a $2000 rebate with purchase of qualifying GE Profile Smarter Innovation Appliance Package.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        }
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "Monogram: Our Luxury Partner",          
          descriptionTxt : "Monogram appliances are designed to redefine luxury in your kitchen. As one of our esteemed luxury partners, Monogram offers a range of wall ovens, dishwashers, refrigerators, ranges, and cooktops that combine cutting-edge innovation with elegant craftsmanship to create a premium cooking experience."
        },
        {        
          mainHeading: "Why Choose Monogram Appliances?",
          title: "Refrigerators with Elevated Performance",        
          descriptionTxt : "Monogram refrigerators deliver superior cooling technology to keep your ingredients fresh and organized. With sleek designs and spacious interiors, they effortlessly enhance your kitchen's functionality and aesthetics."
        },
        {        
          mainHeading: "",
          title: "Ranges and Cooktops for Culinary Precision",        
          descriptionTxt : "Monogram ranges and cooktops are crafted to meet the demands of professional-grade cooking at home. Their powerful burners, precise temperature controls, and stylish designs make them the centerpiece of any modern kitchen."
        },
        {        
          mainHeading: "",
          title: "Wall Ovens for Perfect Cooking Results",        
          descriptionTxt : "Monogram wall ovens bring exceptional cooking performance with advanced features like convection technology and smart controls. Whether baking, roasting, or broiling, they ensure consistent and delicious results every time."
        },
        {        
          mainHeading: "",
          title: "Dishwashers with Unmatched Efficiency",        
          descriptionTxt : "Engineered for quiet yet powerful performance, Monogram dishwashers offer customizable racks, superior cleaning cycles, and energy-efficient designs, making clean-up effortless and efficient."
        },
        {        
          mainHeading: "",
          title: "Experience Luxury with Monogram",        
          descriptionTxt : "Monogram appliances are the ultimate fusion of beauty and function, designed for those who value high-end performance and timeless elegance. Elevate your kitchen with Monogram’s innovative, luxury appliances."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Visit Airport Appliance today to explore Monogram’s exquisite collection and transform your kitchen into a culinary haven."
        },
       
      ]
    },
  },
  {
    Premier: {
      id: 21,
      title: "Premier",
      videoLink: "https://www.youtube.com/watch?v=so3jotVmGEA",
      BannerData: {
        subheading: "Built to Last",
        descriptionTxt: 
          "Today, Peerless-Premier is a complete manufacturer, designing and making its own tools and dies, stamping parts and applying porcelain enamel to the raw steel parts and then assembling hose parts into modern gas and electric ranges",
        bannerImg: PremierbannerImg,
        logoImg: PremierlogoImg,
      },
      brandOptions: [
        { 
          img: PremierCategory_1,
          title:'Ranges',
          slug: '/all-brands/premier/ranges',
        }
      ],
      collectionList: [],      
      contentList:[
          {        
            mainHeading: "Premier Appliances: Reliable Performance for Every Home",
            title: "",          
            descriptionTxt : "Premier Appliances is known for delivering high-quality, American-made kitchen appliances that combine durability, efficiency, and timeless design. Whether you're an everyday home cook or a culinary enthusiast, Premier ranges offer the perfect balance of performance and affordability, making them a trusted choice for households nationwide."
          },
          {        
            mainHeading: "Why Choose Premier Appliances?",
            title: "High-Performance Ranges for Every Kitchen",          
            descriptionTxt : "Premier ranges are designed to provide superior cooking precision with powerful burners, spacious ovens, and durable construction. Available in gas and electric models, these ranges offer reliable performance, ensuring consistent results for every meal."
          },
          {        
            mainHeading: "",
            title: "",          
            descriptionTxt : "At Airport Home Appliance, we are proud to offer Premier Appliances to help you create a kitchen that fits your cooking needs. Shop Premier today and discover quality craftsmanship built to last!"
          },
      ]
    },
  },
  {
    Samsung: {
      id: 39,
      title: "Samsung Appliances",
      videoLink: "https://www.youtube.com/watch?v=A2HqZnKIViI&pp=ygUSc2Ftc3VuZyBhcHBsaWFuY2Vz",
      BannerData: {
        subheading: "Innovations for better living",
        descriptionTxt: 
          "Pioneers smart home integration with appliances designed to seamlessly fit into connected lifestyles.",
        bannerImg: Samsung_AppliancesbannerImg,
        logoImg: Samsung_ApplianceslogoImg,
      },
      brandOptions: [
        { 
          img:  Samsung_AppliancesCategory_1,
          title:'Refrigerators',
          slug: '/all-brands/samsung/refrigerators',
        },
        { 
          img: Samsung_AppliancesCategory_2,
          title:'Ranges',
          slug: '/all-brands/samsung/ranges',
        },
        { 
          img: Samsung_AppliancesCategory_3,
          title:'Washers',
          slug: '/all-brands/samsung/laundry/washers',
        },
        { 
          img: Samsung_AppliancesCategory_4,
          title:'Dishwashers',
          slug: '/all-brands/samsung/dishwashers',
        }
      ], 
      collectionList: [
        {
          title:"Samsung Ready 2 Fit Guarantee",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=AAJVEZEU.pdf",
          descriptionTxt : "Receive up to a $50 rebate toward a countertop modification if your new qualifying Samsung Dishwasher does not fit your current dishwasher cutout.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Samsung Ready 2 Fit Guarantee",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=WRITPOGZ.pdf",
          descriptionTxt : "Receive up to a $100 rebate toward a countertop modification if your new qualifying Samsung 30inch Slide-In Range does not fit your current freestanding range cutout.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Samsung Free Induction Cookware Set Rebate",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=DOMFFYBE.pdf",
          descriptionTxt : "Receive a Free 6-Piece Circulon SteelShield Induction Cookware Set valued $430 with purchase of qualifying Samsung Induction Cooktop or Range.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Samsung Ready 2 Fit Guarantee",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=UKLIZHNT.pdf",
          descriptionTxt : "Receive up to a $300 rebate toward a cabinet cutout or countertop modification if your new qualifying Samsung 30inch or 36inch Built-In Cooktop or Wall Oven does not fit your current Cooktop or Wall Oven cutout.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Dacor 5 10 20 Promotion",
          img:"",
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=UGHAVHKH.pdf",
          descriptionTxt : "5-10-20 Promotion. Get up to 20% off. Spend $5,000 + get 5% off. Spend $10,000 + get 10% off. Spend $20,000 + get 20% off.",
          validDate:"valid from 1/1/2023 to 12/31/2024"
        },
      ],      
      contentList:[
          {        
            mainHeading: "",
            title: "",          
            descriptionTxt : "Samsung Appliances offer cutting-edge technology, sleek designs, and smart features that make everyday tasks easier and more efficient. At Airport Appliance, we feature a diverse range of Samsung products, including laundry machines, refrigerators, ranges, wall ovens, dishwashers, microwaves, cooktops, and range hoods, all crafted to elevate your home with innovation and style."
          },
          {        
            mainHeading: "Why Choose Samsung Appliances?",
            title: "Smart Technology for Everyday Convenience:",        
            descriptionTxt : "Samsung is known for integrating smart technology into their appliances. From Wi-Fi connectivity that allows you to control your appliances remotely to features like FlexZone™ and SmartThings™ compatibility, Samsung brings convenience to your fingertips."
          },
          {        
            mainHeading: "",
            title: "Innovative Laundry Solutions:",        
            descriptionTxt : "Samsung washers and dryers are packed with advanced features like Steam Wash, EcoBubble™, and Smart Control to ensure efficient, gentle, and thorough laundry care. Get cleaner clothes with less effort, all while saving energy and time."
          },
          {        
            mainHeading: "",
            title: "Efficient Refrigeration & Cooking:",        
            descriptionTxt : "Samsung refrigerators combine large capacities with innovative cooling technology to keep your food fresh longer. The range of cooking appliances, from ranges and cooktops to wall ovens, offer precision, versatility, and user-friendly features for effortless meal preparation."
          },
          {        
            mainHeading: "",
            title: "Dishwashers & Microwaves for Everyday Ease:",        
            descriptionTxt : "Samsung dishwashers deliver quiet, powerful cleaning, while their microwaves use advanced cooking technology to heat food evenly and efficiently. Both designed with sleek designs to complement any kitchen decor."
          },    
          {        
            mainHeading: "",
            title: "",        
            descriptionTxt : "Samsung appliances are built to enhance your home with high-end features, modern designs, and efficient performance. Visit Airport Appliance today to shop for Samsung products and transform your kitchen and laundry with the latest in home appliance technology."
          }
      ]
    },
  },
  {
    Sharp: {
      id: 55,
      title: "Sharp",
      videoLink: "https://www.youtube.com/watch?v=irsxlz9FT-I",
      BannerData: {
        subheading: "Simply Better Living",
        descriptionTxt: 
          "Focuses on innovative, user-friendly technology designed to enhance comfort and simplicity in the home.",
        bannerImg: SharpbannerImg,
        logoImg: SharplogoImg,
      },
      brandOptions: [
        { 
          img:  SharpCategory_1,
          title:'Microwaves',
          slug: '/all-brands/sharp/microwaves-otr',
        },
        { 
          img: SharpCategory_2,
          title:'Wall Ovens',
          slug: '/all-brands/sharp/wall-ovens',
        },
        { 
          img: SharpCategory_3,
          title:'Cooktops',
          slug: '/all-brands/sharp/cooktops',
        }
      ],
      collectionList: [],      
      contentList:[
          {        
            mainHeading: "",
            title: "",          
            descriptionTxt : "Sharp Appliances bring you the perfect blend of performance, style, and cutting-edge technology. With a focus on cooktops and microwaves, Sharp provides efficient and reliable solutions for your kitchen needs. Whether you're upgrading your cooking space or seeking space-saving solutions, Sharp's appliances are designed to deliver top-notch performance and sleek designs."
          },
          {        
            mainHeading: "Why Choose Sharp Appliances?",
            title: "High-Efficiency Cooktops:",        
            descriptionTxt : "Sharp cooktops offer precise control and sleek designs, making them a great choice for any modern kitchen. Whether you're cooking for a family or preparing a meal for yourself, Sharp's cooktops provide reliable performance and efficient cooking."
          },
          {        
            mainHeading: "",
            title: "Advanced Microwave Technology:",        
            descriptionTxt : "Sharp microwave are equipped with advanced technology to ensure fast, even cooking. From quick reheating to defrosting and cooking, Sharp microwaves are designed to save you time while delivering consistent results."
          },
          {        
            mainHeading: "",
            title: "Sleek & Functional Design:",        
            descriptionTxt : "Sharp appliances are built with style and functionality in mind. Their modern, minimalist designs complement a wide range of kitchen styles, while their smart features ensure ease of use for every home cook."
          },
          {        
            mainHeading: "",
            title: "",        
            descriptionTxt : "Sharp Appliances are built to help you cook with ease, offering the latest in technology and innovation. Explore our collection of Sharp cooktops and microwaves at Airport Appliance and elevate your kitchen experience with cutting-edge solutions."
          }
      ]
    },
  },
  {
    Signature_Kitchen_Suite: {
      id: 61,
      title: "Signature Kitchen Suite",
      videoLink: "https://www.youtube.com/watch?v=QQ0MjRXEOR4",
      BannerData: {
        subheading: "True to Food",
        descriptionTxt: 
          "Chef-inspired kitchen appliances with a focus on food preservation, precision, and performance.",
        bannerImg: SignatureKitchenbannerImg,
        logoImg: SignatureKitchenSuitelogoImg,
      },
      brandOptions: [
        { 
          img:  SignatureKitchenSuiteCategory_1,
          title:'Refrigerators',
          slug: '/all-brands/signature-kitchen-suite/refrigerators ',
        },
        { 
          img: SignatureKitchenSuiteCategory_2,
          title:'Ranges',
          slug: '/all-brands/signature-kitchen-suite/ranges',
        },
        { 
          img: SignatureKitchenSuiteCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/signature-kitchen-suite/dishwashers',
        }
      ],
      collectionList: [
        {
          title:"SKS Appliances Delivery Or Installation Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=CMS&FORM_NUMBER=523402",
          descriptionTxt : "Receive up to a $600 Delivery or Installation rebate with purchase of qualifying SKS Appliances.",
          validDate:"valid from 8/1/2024 to 12/31/2024"
        },
        {
          title:"Signature Suite Cash Back Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=TXXRADSN.pdf",
          descriptionTxt : "Receive a 5%, 10%, or 15% rebate with purchase of qualifying Signature Kitchen Suite Appliances..",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        }
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "Signature Kitchen Suite: Our Luxury Partner",          
          descriptionTxt : "Signature Kitchen Suite represents the pinnacle of innovation and luxury in home appliances. As one of our trusted luxury partners, their range of cooktops, dishwashers, refrigerators, ranges, and wall ovens embodies a commitment to precision, performance, and sophistication."
        },
        {        
          mainHeading: "Why Choose Signature Kitchen Suite Appliances?",
          title: "Refrigerators for Freshness and Style",        
          descriptionTxt : "Signature Kitchen Suite refrigerators offer advanced cooling technology to maintain freshness while showcasing elegant designs. Their spacious interiors and smart features ensure convenience meets luxury in every detail."
        },
        {        
          mainHeading: "",
          title: "Ranges and Cooktops for Culinary Excellence",        
          descriptionTxt : "Elevate your cooking experience with Signature Kitchen Suite’s ranges and cooktops. Designed for precision, their high-performance burners and sleek finishes make them an ideal choice for aspiring chefs and home cooks alike."
        },
        {        
          mainHeading: "",
          title: "Dishwashers with Superior Cleaning",        
          descriptionTxt : "Their dishwashers combine powerful cleaning cycles with energy-efficient operation. Whisper-quiet performance and customizable interiors make every wash seamless and stress-free."
        },
        {        
          mainHeading: "",
          title: "Wall Ovens for Perfect Results",        
          descriptionTxt : "Signature Kitchen Suite wall ovens feature advanced cooking modes, smart connectivity, and impeccable craftsmanship. Whether baking, roasting, or broiling, these ovens ensure perfect results every time."
        },
        {        
          mainHeading: "",
          title: "Discover True Luxury",        
          descriptionTxt : "Signature Kitchen Suite appliances offer the perfect blend of form and function, transforming your kitchen into a masterpiece. With their innovative features and elegant designs, every appliance delivers the ultimate in luxury and performance."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Visit Airport Appliance today to explore the Signature Kitchen Suite collection and experience the future of luxury kitchen appliances."
        },       
      ]
    },
  },
  {
    Speed_Queen: {
      id: 36,
      title: "Speed Queen",
      videoLink: "https://www.youtube.com/watch?v=oRyBdtOeGqY",
      BannerData: {
        subheading: "Built Better to Last Longer",
        descriptionTxt: 
          "Manufactured with American Pride, Speed Queen® builds consumer laundry products expertly engineered to deliver long-lasting commercial performance and tested to ensure ultimate durability.",
        bannerImg: SpeedQueenbannerImg,
        logoImg: SpeedQueenlogoImg,
      },
      brandOptions: [
        { 
          img:  SpeedQueenCategory_1,
          title:'Top Load Washers',
          slug: '/all-brands/speed-queen/washers/top-load-washers?fieldIds=140&fieldValueIds=27144',
        },
        { 
          img: SpeedQueenCategory_2,
          title:'Front Load Washers',
          slug: '/all-brands/speed-queen/washers/front-load-washers?fieldIds=140&fieldValueIds=27145',
        },
        { 
          img: SpeedQueenCategory_3,
          title:'Dryers',
          slug: '/all-brands/speed-queen/laundry/dryers',
        },
        { 
          img: SpeedQueenCategory_4,
          title:'Laundry Centers',
          slug: '/all-brands/speed-queen/laundry/stacked-washer-dryer-sets',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Speed Queen Appliances are celebrated for their durability, reliability, and unmatched laundry performance. Whether you’re upgrading your home laundry setup or seeking robust solutions for commercial use, Speed Queen has a wide array of washers, dryers, and stacked units designed to meet your needs."
        },
        {        
          mainHeading: "Why Choose Speed Queen Appliances?",
          title: "Efficient Washers for Every Home:",        
          descriptionTxt : "Speed Queen washers deliver outstanding cleaning performance with advanced features for energy and water efficiency. Built to last, they ensure consistent results and simplify your laundry routine."
        },
        {        
          mainHeading: "",
          title: "High-Performance Dryers:",        
          descriptionTxt : "Engineered for speed and precision, Speed Queen dryers are designed to handle large loads and provide optimal drying results. Their robust construction ensures years of reliable use."
        },
        {        
          mainHeading: "",
          title: "Stacked Washer-Dryer Units:",        
          descriptionTxt : "Perfect for compact spaces, Speed Queen’s stacked Speed Queen’s stacked washer-dryer units combine functionality and convenience. These units offer a space-saving design without compromising on performance."
        },
        {        
          mainHeading: "",
          title: "Commercial Laundry Solutions:",        
          descriptionTxt : "For businesses and heavy-duty needs, Speed Queen’s commercial washers and dryers are built to endure constant use while maintaining exceptional efficiency and cleaning power."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Speed Queen appliances offer the perfect blend of innovation and longevity, making them a trusted choice for homes and businesses alike. Shop Speed Queen at Airport Appliance to experience superior laundry solutions crafted for performance and reliability."
        },       
      ]
    },
  },
  {
    Sub_Zero: {
      id: 9,
      title: "Sub Zero Refrigerators",
      videoLink: "https://www.youtube.com/watch?v=Oi_qhW4qpg8&embeds_referring_euri=https%3A%2F%2Fwww.airportappliance.com%2F&embeds_referring_origin=https%3A%2F%2Fwww.airportappliance.com&source_ve_path=OTY3MTQ",
      BannerData: {
        subheading: "Three Specialists. One Extraordinary Kitchen",
        descriptionTxt: 
          "Icons of design and paragons of performance, Sub-Zero, Wolf, and Cove are the pinnacle of luxury in refrigeration, cooking, and dishwashing. Together, these brands craft a kitchen experience that transcends the ordinary, delivering a symphony of luxury, performance, and innovation.",
        bannerImg: WolfbannerImg,
        logoImg: WolflogoImg,
      },
      brandOptions: [
        { 
          img: WolfCategory_3,
          title:'Wolf Cooking', 
          slug: '',
          desc: 'With a proven professional kitchen pedigree, Wolf equips home cooks with the confidence to create the meals that the most delicious memories are made of.',
          fullImage: true
        },
        { 
          img: WolfCategory_1,
          title:'Sub-Zero Refrigeration',
          slug: '',
          desc: 'More than just a refrigerator, Sub-Zero is the preservation specialist keeping food fresher longer and guarding wine against its enemies.',
          fullImage: true
        },
        { 
          img: WolfCategory_2,
          title:'Cove Dishwashing',
          slug: '',
          desc: 'From completely flexible interiors to near-silent operation, Cove ensures spotlessly clean and dry dishes with every load.',
          fullImage: true
        },
       
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Sub-Zero: Our Luxury Partner",        
          descriptionTxt : "Sub-Zero is a renowned name in the world of luxury appliances, celebrated for its exceptional craftsmanship and advanced technology. As one of our trusted luxury partners, Sub-Zero offers a curated range of premium refrigerators, dishwashers, and cooktops designed to redefine modern living."
        },
        {        
          mainHeading: "Why Choose Sub-Zero Appliances?",
          title: "Refrigerators Built for Precision",        
          descriptionTxt : "Sub-Zero refrigerators are engineered to maintain the perfect temperature and humidity levels, ensuring that your food stays fresher for longer. With advanced air purification systems and dual-compressor technology, these refrigerators set the standard for luxury cooling."
        },
        {        
          mainHeading: "",
          title: "Dishwashers for Effortless Cleaning",        
          descriptionTxt : "Sub-Zero dishwashers combine superior cleaning performance with sleek aesthetics. Featuring customizable cycles, quiet operation, and durable construction, they provide the reliability and sophistication that every kitchen deserves."
        },
        {        
          mainHeading: "",
          title: "Cooktops Designed for Culinary Excellence",        
          descriptionTxt : "Sub-Zero cooktops are a dream for home chefs. With precise temperature control, powerful burners, and elegant designs, they enhance your cooking experience while complementing any kitchen décor."
        },
        {        
          mainHeading: "",
          title: "Luxury Meets Functionality",        
          descriptionTxt : "Sub-Zero appliances are designed to seamlessly blend luxury with functionality. From their stunning stainless-steel finishes to innovative features, they provide the perfect balance of form and function."
        },
        {        
          mainHeading: "",
          title: "Elevate Your Kitchen with Sub-Zero",        
          descriptionTxt : "Sub-Zero appliances are more than just kitchen tools; they are a statement of quality and refinement. Whether you’re upgrading your refrigerator, adding a high-performance cooktop, or investing in a dependable dishwasher, Sub-Zero offers unparalleled luxury and performance."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the Sub-Zero collection at Airport Appliance and transform your home with premium appliances built to last."
        },
      ]
    },
  },
  {
    Summit: {
      id: 10,
      title: "Summit",
      videoLink: "https://www.youtube.com/watch?v=5hoSSPr3Ioc",
      BannerData: {
        subheading: "Your Solution for Smaller Spaces",
        descriptionTxt: 
          "Specializes in compact, space-saving appliances with versatile designs for small or unique spaces.",
        bannerImg: SummitbannerImg,
        logoImg: SummitlogoImg,
      },
      brandOptions: [
        { 
          img:  SummitCategory_1,
          title:'Dishwashers',
          slug: '/all-brands/summit/dishwashers',
        },
        { 
          img: SummitCategory_2,
          title:'Cooktops',
          slug: '/all-brands/summit/cooktops',
        },
        { 
          img: SummitCategory_3,
          title:'Refrigerators',
          slug: '/all-brands/summit/refrigerators',
        },
        { 
          img: SummitCategory_4,
          title:'Washer Dryer Combos',
          slug: '/all-brands/summit/laundry/washer-dryer-combo-units',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Summit Appliances offers exceptional high-quality products tailored for compact spaces and versatile lifestyles. Focusing on innovative solutions and sleek designs, Summit’s lineup includes refrigerators, cooktops, freezers, ranges, wall ovens, dishwashers, and more. Whether for home, apartment, or commercial spaces, Summit combines functionality and style to meet your needs."
        },
        {        
          mainHeading: "Explore Summit Appliances",
          title: "Refrigerators:",        
          descriptionTxt : "Summit refrigerators are ideal for small spaces, offering efficient cooling without sacrificing storage. These compact units blend practicality with modern aesthetics, perfect for apartments, offices, or secondary kitchens."
        },
        {        
          mainHeading: "",
          title: "Cooktops:",        
          descriptionTxt : "Summit cooktops provide precision cooking with space-saving designs. Available in gas, electric, and induction options, they cater to diverse cooking preferences and compact kitchens."
        },
        {        
          mainHeading: "",
          title: "Freezers & Ice Makers:",        
          descriptionTxt : "From extra food storage to ice production, Summit’s freezers and ice makers deliver reliable performance and energy efficiency, making them essential for busy households."
        },
        {        
          mainHeading: "",
          title: "Ranges & Wall Ovens:",        
          descriptionTxt : "Summit ranges and wall ovens combine powerful performance with space-conscious designs, perfect for any modern or compact kitchen setup."
        },
        {        
          mainHeading: "",
          title: "Dishwashers & Range Hoods:",        
          descriptionTxt : "Summit dishwashers and range hoods are built for convenience and efficiency. These appliances simplify your daily tasks while enhancing the overall aesthetic of your kitchen."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Whether you're furnishing a small apartment, upgrading a home, or creating a commercial space, Summit Appliances delivers innovative and reliable solutions. Shop now at Airport Appliance and find the perfect Summit appliances for your needs."
        },   
      ]
    },
  },
  {
    Thermador: {
      id: 3,
      title: "Thermador",
      videoLink: "https://www.youtube.com/watch?v=t6z0bZMs-oo",
      BannerData: {
        subheading: "To Inspire Like No Other",
        descriptionTxt: 
          "Professional-grade kitchen appliances, designed for culinary enthusiasts.",
        bannerImg: ThermadorbannerImg,
        logoImg: ThermadorlogoImg,
      },
      brandOptions: [
        { 
          img:  ThermadorCategory_1,
          title:'Refrigerators',
          slug: '/all-brands/thermador/refrigerators',
        },
        { 
          img: ThermadorCategory_2,
          title:'Ranges',
          slug: '/all-brands/thermador/ranges',
        },
        { 
          img: ThermadorCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/thermador/dishwashers',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Thermador: Our Luxury Partner",          
          descriptionTxt : "Thermador is a name synonymous with luxury, innovation, and timeless design. As one of our trusted luxury partners, Thermador appliances bring professional-grade performance and unmatched style to your home. With a legacy of excellence, Thermador’s products are crafted to elevate your culinary experience and kitchen aesthetics."
        },
        {        
          mainHeading: "Explore Thermador Appliances",
          title: "Powerful Ranges",        
          descriptionTxt : "Thermador ranges deliver precision and power, featuring advanced cooking technologies like ExtraLow® simmer burners and convection capabilities. These ranges are perfect for home chefs seeking exceptional results and elegant design."
        },
        {        
          mainHeading: "",
          title: "Sophisticated Refrigerators",        
          descriptionTxt : "Thermador refrigerators redefine food preservation with innovative cooling technologies and customizable designs. From column refrigerators to French-door models, Thermador ensures fresh storage solutions tailored to your needs."
        },
        {        
          mainHeading: "",
          title: "Elegant Wall Ovens",        
          descriptionTxt : "Thermador wall ovens combine culinary innovation with sophisticated design. Features like Steam and Convection Cooking ensure restaurant-quality results, while their sleek appearance enhances any kitchen."
        },
        {        
          mainHeading: "",
          title: "Efficient Range Hoods",        
          descriptionTxt : "Thermador range hoods offer superior ventilation with whisper-quiet operation. Their modern designs and robust performance keep your kitchen fresh and free of smoke or grease."
        },
        {        
          mainHeading: "",
          title: "Precision Cooktops",        
          descriptionTxt : "Available in gas, induction, and electric options, Thermador cooktops offer precise heat control and seamless integration. Each model is designed for efficient and safe cooking with a touch of luxury."
        },       
        {        
          mainHeading: "",
          title: "Dishwashers & More",        
          descriptionTxt : "Thermador dishwashers provide crystal-clear cleaning with advanced drying technologies. Complement your kitchen with freezers, microwaves, and other premium appliances for a complete luxury experience."
        },   
        {        
          mainHeading: "",
          title: "Why Choose Thermador?",        
          descriptionTxt : "- Luxury & Innovation: Combining style with cutting-edge technology."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "- Reliability: Built with high-quality materials for long-lasting performance."
        }, 
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "- Culinary Excellence: Trusted by home chefs and culinary professionals worldwide."
        }, 
        {        
          mainHeading: "",
          title: "Transform Your Kitchen with Thermador",        
          descriptionTxt : "Thermador appliances are designed to deliver superior performance, luxury, and reliability. Whether you're cooking for your family or entertaining guests, Thermador makes every moment in the kitchen extraordinary."
        }, 
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Shop the Thermador collection today at Airport Appliance and bring timeless sophistication and professional-grade performance to your home."
        }, 
      ]
    },
  },
  {
    True_Residential: {
      id: 176,
      title: "True Residential",
      videoLink: "https://www.youtube.com/watch?v=ixfr9yDSiPk",
      BannerData: {
        subheading: "Driven by performance, made for self expression",
        descriptionTxt:
          "Redefining luxury refrigeration with commercial-grade performance, bold customizable designs, and unparalleled craftsmanship for the ultimate style and functionality.",
        bannerImg: trueResidential_hero,
        logoImg: TrueResidential_logo,
      },
      brandOptions: [
        { 
          img: TrueResidential_SidebySideRefrigerators_1,
          title:'Refrigerators',
          slug: '/all-brands/true-residential/refrigerators',
        },       
        { 
          img: TrueResidential_BottomFreezerRefrigerators_2,
          title:'Freezer Refrigerators', 
          slug: '/all-brands/true-residential/freezers',
        },
        { 
          img: TrueResidential_ColumnRefrigerators_3,
          title:'Column Refrigerators', 
          slug: '/all-brands/true-residential/freezers/upright-freezers',
        },
        { 
          img: TrueResidential_UnderCounterRefrigerators_4,
          title:'Undercounter Refrigerators',
          slug: '/all-brands/true-residential/freezers/undercounter-freezers',
        },
        {
          img: TrueResidential_IceMakers_5,
          title:'Ice Makers', 
          slug: '/all-brands/true-residential/ice-makers',
        }, 
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "True Residential: Luxury Refrigeration for Modern Homes",
          title: "",          
          descriptionTxt : "True Residential appliances are built for those who demand the highest level of performance, design, and durability. With commercial-grade cooling technology and sleek, customizable aesthetics, True Residential brings professional refrigeration into the home, ensuring optimal food preservation and effortless style."
        },
        {        
          mainHeading: "Why Choose True Residential?",
          title: "Refrigerators: Superior Cooling and Timeless Design",          
          descriptionTxt : "True Residential refrigerators are crafted with precision cooling technology to keep your food fresher for longer. Featuring stainless steel interiors, advanced airflow systems, and customizable finishes, these refrigerators deliver both performance and elegance."
        },
        {        
          mainHeading: "",
          title: "Freezer Refrigerators: Maximum Storage and Efficiency",          
          descriptionTxt : "For those who need both refrigeration and freezing in one unit, True Residential freezer refrigerators offer powerful cooling with spacious compartments, energy-efficient operation, and seamless integration into any kitchen layout."
        },
        {        
          mainHeading: "",
          title: "Column Refrigerators: Modular Design for Ultimate Flexibility",          
          descriptionTxt : "True Residential column refrigerators provide the ultimate in customizable refrigeration. With independent cooling zones and panel-ready designs, these units allow you to create a tailored refrigeration solution that fits your kitchen’s unique needs."
        },
        {        
          mainHeading: "",
          title: "Undercounter Refrigerators: Compact, Stylish, and Versatile",          
          descriptionTxt : "Designed for smaller spaces and entertainment areas, True Residential undercounter refrigerators offer professional-grade cooling in a sleek, compact form. Perfect for home bars, outdoor kitchens, or additional cold storage, these refrigerators bring convenience and luxury anywhere you need them."
        },
        {        
          mainHeading: "",
          title: "Ice Makers: Fresh Ice on Demand",          
          descriptionTxt : "True Residential ice makers ensure a constant supply of crystal-clear ice, perfect for entertaining or everyday use. With durable construction and energy-efficient performance, these ice makers provide reliability and convenience in any kitchen or bar setup."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "At Airport Home Appliance, we are proud to offer True Residential appliances, delivering professional-grade refrigeration for the modern home. Shop True Residential today and experience the best in luxury cooling solutions!"
        }
      ]
    },
  }, 
  {
    Thor_Kitchen: {
      id: 154,
      title: "Thor Kitchen",
      videoLink: "https://www.youtube.com/watch?v=_G7B68fpoVk",
      BannerData: {
        subheading: "Cook Like a God",
        descriptionTxt: 
          "Delivers powerful, professional-style kitchen appliances designed for home chefs who seek restaurant-level performance.",
        bannerImg: ThorKitchenbannerImg,
        logoImg: ThorKitchenlogoImg,
      },
      brandOptions: [
        { 
          img:  ThorKitchenCategory_1,
          title:'Ranges',
          slug: '/all-brands/thor-kitchen/ranges',
        },
        { 
          img: ThorKitchenCategory_2,
          title:'Wine Coolers',
          slug: '/all-brands/thor-kitchen/wine-coolers',
        },
        { 
          img: ThorKitchenCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/thor-kitchen/dishwashers',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Thor Kitchen: Our Luxury Partner",          
          descriptionTxt : "Thor Kitchen stands out as a premier luxury brand, delivering high-quality appliances that combine professional-grade performance with sleek, modern designs. As one of our esteemed luxury partners, Thor Kitchen offers a diverse lineup of appliances, ideal for home chefs and design enthusiasts alike."
        },
        {        
          mainHeading: "Explore Thor Kitchen Appliances",
          title: "Professional Ranges",          
          descriptionTxt : "Thor Kitchen ranges are engineered for those who demand precision in their cooking. With powerful burners, convection ovens, and premium finishes, these ranges deliver exceptional performance for both everyday meals and gourmet creations."
        },
        {        
          mainHeading: "",
          title: "Efficient Range Hoods",          
          descriptionTxt : "Thor Kitchen range hoods provide reliable ventilation, keeping your kitchen free of smoke, grease, and odors. With robust suction power and elegant designs, these hoods ensure your cooking experience is as enjoyable as it is efficient."
        },
        {        
          mainHeading: "",
          title: "Refrigerators & Freezers",          
          descriptionTxt : "Thor Kitchen refrigerators and freezers offer ample storage with innovative features to keep your food fresh. With sleek designs and spacious interiors, they seamlessly integrate into any kitchen style."
        },
        {        
          mainHeading: "",
          title: "Versatile Cooktops",          
          descriptionTxt : "Whether gas or electric, Thor Kitchen cooktops deliver precise control for every recipe. Durable and stylish, they’re perfect for both small kitchens and expansive culinary spaces."
        },
        {        
          mainHeading: "",
          title: "Microwaves & Dishwashers",          
          descriptionTxt : "Thor Kitchen microwaves simplify cooking with advanced settings and efficient performance, while dishwashers ensure sparkling clean results, making cleanup effortless."
        },
        {        
          mainHeading: "",
          title: "Why Choose Thor Kitchen?",          
          descriptionTxt : "- Professional-Grade Features: Designed for home chefs who want commercial-level performance."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "- Durable Construction: Built with high-quality materials for long-lasting reliability."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "- Sleek Aesthetic: Combines functionality with modern, elegant designs to elevate your kitchen."
        },
        {        
          mainHeading: "",
          title: "Elevate Your Kitchen with Thor Kitchen",          
          descriptionTxt : "Thor Kitchen appliances blend luxury, practicality, and exceptional performance, making them a go-to choice for homeowners looking to upgrade their kitchens. From cooking to cooling, Thor Kitchen provides reliable solutions for every culinary need."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Shop  the Thor Kitchen collection today at Airport Appliance and transform your cooking experience with professional-grade appliances."
        }
      ]
    },
  },
  {
    Perlick: {
      id: 51,
      title: "Perlick",
      videoLink: "https://www.youtube.com/watch?v=qsyGC1ej0VU",
      BannerData: {
        subheading: "Refrigeration Perfected",
        descriptionTxt: 
          "Renowned for luxury refrigeration solutions, combining performance with precision-engineered design.",
        bannerImg: PerlickbannerImg,
        logoImg: PerlicklogoImg,
      },
      brandOptions: [
        { 
          img:  PerlickCategory_1,
          title:'Ice Makers', 
          slug: '/all-brands/perlick/ice-makers',
        },
        { 
          img: PerlickCategory_2,
          title:'Compact Refrigerators',
          slug: '/all-brands/perlick/refrigerators/compact-refrigerators',
        },
        { 
          img: PerlickCategory_3,
          title:'Beer Coolers & Kegerators',
          slug: '/all-brands/perlick/beer-coolers-&-kegerators',
        },
        { 
          img: PerlickCategory_4,
          title:'Wine Coolers',
          slug: '/all-brands/perlick/wine-coolers',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Perlick Appliances are designed for those who appreciate quality craftsmanship and innovative features. Specializing in wine coolers, compact refrigerators, freezers, and ice makers, Perlick offers a range of appliances that are perfect for home bar setups, small spaces, and those who want to elevate their kitchen with professional-grade cooling solutions."
        },
        {        
          mainHeading: "Why Choose Perlick Appliances?",
          title: "Wine Coolers for the Connoisseur:",          
          descriptionTxt : "Perlick wine coolers are a must-have for wine lovers. With precise temperature control and sleek designs, these wine coolers keep your collection at the perfect temperature, ensuring every bottle is ready to be enjoyed."
        },
        {        
          mainHeading: "",
          title: "Compact Refrigerators:",          
          descriptionTxt : "Ideal for smaller spaces, Perlick's compact fridges deliver reliable cooling performance while maintaining a modern, space-saving design. Perfect for apartments, offices, or secondary kitchens, these fridges offer the right balance of convenience and capacity."
        },
        {        
          mainHeading: "",
          title: "Freezers & Ice Makers:",          
          descriptionTxt : "Perlick's freezers and ice makers offer high-efficiency cooling for a variety of needs. Whether you're storing extra food or creating a steady supply of ice for entertaining, these appliances are designed to provide long-lasting performance."
        },
        {        
          mainHeading: "",
          title: "Sleek and Efficient Designs:",          
          descriptionTxt : "Perlick appliances are built with both functionality and aesthetics in mind. Their sleek, stainless steel exteriors and space-efficient designs fit seamlessly into any kitchen, home bar, or entertainment area."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Whether you're looking to enhance your kitchen, wet bar, or entertaining space, Perlick Appliances provide the perfect solutions with their stylish, durable, and efficient cooling products. Shop now at Airport Appliance and elevate your home with Perlick’s premium appliances."
        },
      ]
    },
  },
  {
    U_Line: {
      id: 63,
      title: "Uline",
      videoLink: "https://www.youtube.com/watch?v=CbonrJkNbC4",
      BannerData: {
        subheading: "Refrigeration for Every Room",
        descriptionTxt: 
          "Known for versatile and reliable refrigeration solutions, designed to fit seamlessly into any room of the home.",
        bannerImg: UlinebannerImg,
        logoImg: UlinelogoImg,
      },
      brandOptions: [
        { 
          img:  UlineCategory_1,
          title:'Beverage Centers',
          slug: '/all-brands/u-line/beverage-centers',
        },
        { 
          img: UlineCategory_2,
          title:'Ice Makers',
          slug: '/all-brands/u-line/ice-makers',
        },
        { 
          img: UlineCategory_3,
          title:'Wine Coolers',
          slug: '/all-brands/u-line/wine-coolers',
        },
        { 
          img: UlineCategory_4,
          title:'Beer Coolers & Kegerators',
          slug: '/all-brands/u-line/beer-coolers-&-kegerators',
        }
      ],
      collectionList: [
        {
          title:"U-Line Cool Savings Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=RCALKQTY.pdf",
          descriptionTxt : "Receive up to a $2500 rebate with purchase of qualifying U-Line Models.",
          validDate:"valid from 2/1/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "U-Line Appliances are the epitome of quality and innovation, specializing in wine coolers and ice makers that elevate your home, kitchen, or bar setup. Designed with both functionality and style in mind, U-Line’s compact appliances deliver reliable performance for modern living."
        },
        {        
          mainHeading: "Why Choose U-Line Appliances?",
          title: "Wine Coolers for Connoisseurs:",          
          descriptionTxt : "U-Line wine coolers are crafted to keep your wine collection at the perfect temperature. With precise controls, quiet operation, and elegant designs, these coolers are a must-have for enthusiasts who value preservation and presentation."
        },
        {        
          mainHeading: "",
          title: "Efficient Ice Makers:",          
          descriptionTxt : "U-Line ice makers provide a constant supply of crystal-clear ice for all your entertaining needs. Compact and efficient, they seamlessly fit into kitchens, bars, or outdoor spaces while delivering reliable performance."
        },
        {        
          mainHeading: "",
          title: "Stylish and Space-Saving Designs:",          
          descriptionTxt : "With sleek aesthetics and compact designs, U-Line appliances blend effortlessly into any environment, offering a balance of style and convenience."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Whether you’re creating the ultimate home bar or upgrading your kitchen, U-Line’s wine coolers and ice makers deliver premium solutions that combine elegance and efficiency. Shop U-Line Appliances now at Airport Appliance to enhance your home with these exceptional products."
        }
      ]
    },
  },
  {
    Unique_Appliances: {
      id: 155,
      title: "Unique Appliances",
      videoLink: "https://www.youtube.com/watch?v=_XLhhCf-pxQ",
      BannerData: {
        subheading: "Modern Appliances with a Retro Twist",
        descriptionTxt: 
          "Stands out for offering stylish, energy-efficient appliances, including off-grid solutions.",
        bannerImg: UniqueAppliancesbannerImg,
        logoImg: UniqueApplianceslogoImg,
      },
      brandOptions: [
        { 
          img:  UniqueAppliancesCategory_1,
          title:'Refrigerators',
          slug: '/all-brands/unique-appliances/refrigerators',
        },
        { 
          img: UniqueAppliancesCategory_2,
          title:'Under-Cabinet Range Hoods',
          slug: '/all-brands/unique-appliances/range-hoods/under-cabinet-range-hoods',
          imageFlag: true
        },
        { 
          img: UniqueAppliancesCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/unique-appliances/dishwashers',
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Unique Appliances offers a perfect blend of functionality and timeless design, making it a trusted choice for homeowners seeking high-quality kitchen solutions. From refrigerators to dishwashers, ranges, and range hoods, Unique Appliances delivers reliable performance and energy-efficient designs for modern living."
        },
        {        
          mainHeading: "Why Choose Unique Appliances?",
          title: "Efficient Refrigerators:",          
          descriptionTxt : "Unique’s refrigerators combine energy efficiency with innovative features, ensuring optimal food preservation. Their sleek designs make them a perfect addition to any kitchen, offering both practicality and style."
        },
        {        
          mainHeading: "",
          title: "Reliable Dishwashers:",          
          descriptionTxt : "Keep your kitchen spotless with Unique’s dishwashers, designed for powerful cleaning performance. With advanced washing systems and quiet operation, these dishwashers simplify cleanup while conserving water and energy."
        },
        {        
          mainHeading: "",
          title: "Durable Ranges:",          
          descriptionTxt : "Unique’s ranges are crafted to handle diverse cooking needs with precision and durability. Their user-friendly controls and even heat distribution make cooking an effortless and enjoyable experience."
        },
        {        
          mainHeading: "",
          title: "Stylish Range Hoods:",          
          descriptionTxt : "Unique’s range hoods offer effective ventilation solutions while adding a touch of elegance to your kitchen. Designed to remove odors and smoke efficiently, they ensure a clean and comfortable cooking environment."
        },
        {        
          mainHeading: "",
          title: "",          
          descriptionTxt : "Transform your kitchen with Unique Appliances, where innovative design meets dependable performance. Visit Airport Appliance today to shop the complete range of Unique refrigerators, dishwashers, ranges, and range hoods."
        }
      ]
    },
  },
  {
    Ventahood: {
      id: 15,
      title: "Vent A Hood", 
      videoLink: "https://www.youtube.com/watch?v=ZVUC7gHWnbo",
      BannerData: {
        subheading: "Your Dream Starts Here",
        descriptionTxt: 
          "Known for its quiet and highly efficient range hoods, utilizing proprietary technology for superior ventilation.",
        bannerImg: Vent_A_HoodbannerImg,
        logoImg: Vent_A_HoodlogoImg,
      },
      brandOptions: [
        { 
          img:  Vent_A_HoodCategory_1,
          title:'Insert Range Hoods',
          slug: '/all-brands/ventahood/range-hoods/insert-range-hoods',
          imageFlag: true
        },
        { 
          img: Vent_A_HoodCategory_2,
          title:'Under-Cabinet Range Hoods',
          slug: '/all-brands/ventahood/range-hoods/under-cabinet-range-hoods',
          imageFlag: true
        },
        { 
          img: Vent_A_HoodCategory_3,
          title:'Wall Mounted Range Hoods',
          slug: '/all-brands/ventahood/range-hoods/wall-mounted-range-hoods',
          imageFlag: true
        },
        { 
          img: Vent_A_HoodCategory_4,
          title:'Island Range Hoods',
          slug: '/all-brands/ventahood/range-hoods/island-range-hoods',
          imageFlag: true
        }
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Vent-A-Hood: Our Luxury Partner",          
          descriptionTxt : "Vent-A-Hood is the epitome of luxury and innovation in kitchen ventilation. As one of our trusted luxury partners, Vent-A-Hood specializes exclusively in range hoods that combine cutting-edge technology, superior performance, and stunning designs to meet the needs of modern kitchens."
        },
        {        
          mainHeading: "Why Choose Vent-A-Hood Range Hoods?",
          title: "Exceptional Ventilation Performance",        
          descriptionTxt : "Vent-A-Hood range hoods are engineered to provide powerful, efficient airflow while maintaining a quiet operation. Their patented Magic Lung® blower system captures grease, eliminates smoke, and ensures a clean and odor-free cooking environment."
        },
        {        
          mainHeading: "",
          title: "Elegant Designs for Every Kitchen",        
          descriptionTxt : "With a variety of styles, finishes, and customizable options, Vent-A-Hood range hoods seamlessly integrate into any kitchen aesthetic. From contemporary stainless steel to timeless classic designs, there’s a perfect fit for your space."
        },
        {        
          mainHeading: "",
          title: "Durability and Quality Craftsmanship",        
          descriptionTxt : "Crafted with premium materials and meticulous attention to detail, Vent-A-Hood products are built to last. Their exceptional quality ensures reliable performance and long-term satisfaction."
        },
        {        
          mainHeading: "",
          title: "Easy Maintenance",        
          descriptionTxt : "Designed for convenience, Vent-A-Hood range hoods are easy to clean and maintain. Their grease filters are dishwasher-safe, making upkeep a hassle-free process."
        },
        {        
          mainHeading: "",
          title: "Elevate Your Kitchen with Vent-A-Hood",        
          descriptionTxt : "Vent-A-Hood range hoods are more than just functional appliances—they are an essential element of a well-designed, high-performing kitchen. Whether you’re a passionate home chef or looking to enhance your kitchen’s aesthetic, Vent-A-Hood offers the perfect solution."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Explore the collection of Vent-A-Hood range hoods at Airport Appliance and experience the difference in quality and performance today."
        },     
      ]
    },
  },
  {
    Viking: {
      id: 165,
      title: "Viking",
      videoLink: "https://www.youtube.com/watch?v=WV7Z5Av5zv4",
      BannerData: {
        subheading: "Simply Iconic",
        descriptionTxt: 
          "Pioneers professional-style kitchen appliances, blending commercial-grade performance with luxury design.",
        bannerImg: VikingbannerImg,
        logoImg: VikinglogoImg,
      },
      brandOptions: [
        { 
          img: VikingCategory_1,
          title:'Cooktops',
          slug: '/all-brands/viking/cooktops',
          imageFlag: true
        },
        { 
          img: VikingCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/viking/refrigerators',
        },
        { 
          img: VikingCategory_3,
          title:'Dishwashers',
           slug: '/all-brands/viking/dishwashers',
        },
        { 
          img: VikingCategory_4,
          title:'Ranges',
          slug: '/all-brands/viking/ranges',
        }
      ],
      collectionList: [
        {
          title:"Viking Buy One Get One Event",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=WXQKPFGN.pdf",
          descriptionTxt : "Purchase qualifying Viking Kitchen Appliances and receive a Free qualifying Viking Appliance or $1,000 allowance towards non-qualifying product valued $1,500 or more.",
          validDate:"valid from 1/1/2024 to 12/31/2024"
        },
        {
          title:"Viking Tuscany Range Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=EWLSOWFE.pdf",
          descriptionTxt : "Receive a 15% rebate when you purchase a qualifying Viking Tuscany Range.",
          validDate:""
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "Viking: Our Luxury Partner",        
          descriptionTxt : "Viking appliances set the standard for professional-grade performance and luxurious design in the home. As one of our premier luxury partners, Viking offers an expansive collection of high-quality kitchen and outdoor appliances, including ranges, wall ovens, refrigerators, range hoods, cooktops, and more, tailored to transform your living spaces."
        },
        {        
          mainHeading: "Why Choose Viking Appliances?",
          title: "Professional Ranges for Masterful Cooking",        
          descriptionTxt : "Viking ranges bring restaurant-quality cooking to your home with powerful burners, precision temperature controls, and innovative features like dual-fuel configurations and convection cooking. Their iconic design enhances both performance and aesthetics in your kitchen."
        },
        {        
          mainHeading: "",
          title: "Wall Ovens for Culinary Excellence",        
          descriptionTxt : "Viking wall ovens combine advanced cooking technologies with a sleek, professional look. From convection to steam options, these ovens ensure perfect results for everything from roasting to baking."
        },
        {        
          mainHeading: "",
          title: "Refrigerators for Sophistication and Freshness",        
          descriptionTxt : "Viking refrigerators feature cutting-edge cooling systems and spacious interiors, keeping your food fresh longer while complementing your kitchen’s style. Choose from built-in and freestanding options to match your needs."
        },
        {        
          mainHeading: "",
          title: "Range Hoods for Superior Ventilation",        
          descriptionTxt : "Viking range hoods offer powerful and quiet ventilation, effectively removing smoke, grease, and odors. With a range of sizes and finishes, they seamlessly integrate into any kitchen design."
        },
        {        
          mainHeading: "",
          title: "Cooktops and Outdoor Grills for Versatility",        
          descriptionTxt : "From gas and induction cooktops to premium outdoor grills, Viking provides versatile cooking solutions for both indoor and outdoor culinary experiences."
        },       
        {        
          mainHeading: "",
          title: "Dishwashers and Microwaves for Everyday Convenience",        
          descriptionTxt : "Viking dishwashers ensure efficient cleaning with robust washing systems, while their microwaves deliver precision and speed for quick meals and reheating."
        },    
        {        
          mainHeading: "",
          title: "Elevate Your Home with Viking Appliances",        
          descriptionTxt : "Viking is synonymous with durability, style, and top-tier performance, making it a trusted choice for home chefs and design enthusiasts alike. Whether you're upgrading your kitchen or creating an outdoor cooking haven, Viking appliances offer unmatched quality and innovation."
        },  
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Discover the full range of Viking appliances at Airport Appliance and experience professional-grade luxury in every corner of your home."
        },
      ]
    },
  },
  {
    Wolf: {
      id: 31,
      title: "Wolf",
      videoLink: "https://www.youtube.com/watch?v=Oi_qhW4qpg8&embeds_referring_euri=https%3A%2F%2Fwww.airportappliance.com%2F&embeds_referring_origin=https%3A%2F%2Fwww.airportappliance.com&source_ve_path=OTY3MTQ",
      BannerData: {
        subheading: "Three Specialists. One Extraordinary Kitchen",
        descriptionTxt: 
          "Icons of design and paragons of performance, Sub-Zero, Wolf, and Cove are the pinnacle of luxury in refrigeration, cooking, and dishwashing. Together, these brands craft a kitchen experience that transcends the ordinary, delivering a symphony of luxury, performance, and innovation.",
        bannerImg: WolfbannerImg,
        logoImg: WolflogoImg,
      },
      brandOptions: [
        { 
          img: WolfCategory_3,
          title:'Wolf Cooking', 
          slug: '',
          desc: 'With a proven professional kitchen pedigree, Wolf equips home cooks with the confidence to create the meals that the most delicious memories are made of.',
          fullImage: true
        },
        { 
          img: WolfCategory_1,
          title:'Sub-Zero Refrigeration',
          slug: '',
          desc: 'More than just a refrigerator, Sub-Zero is the preservation specialist keeping food fresher longer and guarding wine against its enemies.',
          fullImage: true
        },
        { 
          img: WolfCategory_2,
          title:'Cove Dishwashing',
          slug: '',
          desc: 'From completely flexible interiors to near-silent operation, Cove ensures spotlessly clean and dry dishes with every load.',
          fullImage: true
        },
       
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "Wolf: Our Luxury Partner",        
          descriptionTxt : "Wolf appliances are the epitome of precision, power, and luxury. Renowned for their meticulous craftsmanship and cutting-edge technology, Wolf products are trusted by culinary professionals and home chefs alike. As a proud luxury partner, we bring you the best of Wolf’s innovative kitchen solutions to transform your home."
        },
        {        
          mainHeading: "Explore the Wolf Appliance Collection",
          title: "High-Performance Cooktops",        
          descriptionTxt : "Wolf cooktops set the standard for precision cooking. Available in gas, induction, and electric models, they offer unparalleled heat control and sleek designs that integrate seamlessly into luxury kitchens. Features like dual-stacked sealed burners or magnetic induction technology ensure consistent results every time."
        },
        {        
          mainHeading: "",
          title: "Innovative Refrigerators",        
          descriptionTxt : "Wolf refrigerators combine state-of-the-art preservation technology with stunning aesthetics. Engineered for precise temperature and humidity control, they ensure your food stays fresh longer. Whether you choose a built-in or column design, Wolf refrigerators elevate your kitchen with unmatched style and function."
        },
        {        
          mainHeading: "",
          title: "Effortless Dishwashers",        
          descriptionTxt : "Wolf dishwashers deliver exceptional cleaning performance while operating quietly. With advanced wash cycles and energy-efficient technology, they ensure your dishes, glasses, and cookware come out spotless. The sleek design complements any luxury kitchen setting."
        },
        {        
          mainHeading: "",
          title: "Why Choose Wolf?",        
          descriptionTxt : "- Professional-Grade Performance: Trusted by culinary experts for precision and reliability."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "- Cutting-Edge Technology: Advanced features designed for modern kitchens."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "- Elegant Design: Seamlessly integrates luxury with functionality."
        },    
        {        
          mainHeading: "",
          title: "Elevate Your Kitchen with Wolf",        
          descriptionTxt : "Wolf appliances offer a perfect blend of innovation, style, and performance. Whether you're upgrading your kitchen or designing a new space, Wolf cooktops, refrigerators, and dishwashers bring professional-grade quality to your home."
        },  
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Shop the Wolf collection today at Airport Appliance and experience the ultimate in luxury kitchen appliances."
        },
      ]
    },
  },
  {
    Whirlpool: {
      id: 27,
      title: "Whirlpool",
      videoLink: "https://www.youtube.com/watch?v=pR_8HhrEvAs",
      BannerData: {
        subheading: "Every Day, Care",
        descriptionTxt: 
          "Combines durability with thoughtful features aimed at simplifying household care.",
        bannerImg: WhirlpoolbannerImg,
        logoImg: WhirlpoollogoImg,
      },
      brandOptions: [
        { 
          img: WhirlpoolCategory_1,
          title:'Dryers',
          slug: '/all-brands/whirlpool/dryers',
        },
        { 
          img: WhirlpoolCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/whirlpool/refrigerators',
        },
        { 
          img: WhirlpoolCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/whirlpool/dishwashers',
        },
        { 
          img: WhirlpoolCategory_4,
          title:'Cooktops',
          slug: '/all-brands/whirlpool/cooktops',
          imageFlag: true
        }
      ],
      collectionList: [
        {
          title:"JennAir Curate Rebate",
          img:'',
          link: "",
          pdf: "http://demo36655.appliances.dev.rwsgateway.com/_CGI/VIEW_REBATE_FORM?PROTOCOL=S3&FORM_NUMBER=KVTZCKVI.pdf",
          descriptionTxt : "Receive up to 15% off in instant savings with purchase of 2 or more qualifying JennAir Appliances.",
          validDate:"valid from 7/1/2024 to 12/31/2024"
        },
      ],
      contentList:[
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Whirlpool Appliances are trusted for their reliability, innovation, and efficiency, making them a staple in modern households. From refrigerators to laundry solutions, ranges, dishwashers, and more, Whirlpool delivers high-performing appliances designed to simplify your daily routine and enhance your home’s functionality."
        },
        {        
          mainHeading: "Why Choose Whirlpool Appliances?",
          title: "Refrigerators with Advanced Cooling:",        
          descriptionTxt : "Whirlpool refrigerators are designed to keep your food fresh and organized. With features like adjustable shelving and precise temperature control, these fridges cater to a variety of storage needs."
        },
        {        
          mainHeading: "",
          title: "Efficient Laundry Solutions:",        
          descriptionTxt : "Whirlpool’s Whirlpool’s washers and dryers offer cutting-edge features like steam cleaning, energy-efficient operation, and large capacities, making laundry day quicker and easier."
        },
        {        
          mainHeading: "",
          title: "Versatile Ranges and Cooktops:",        
          descriptionTxt : "Whirlpool’s ranges and cooktops provide precise temperature control and even heat distribution, perfect for cooking meals to perfection. Choose from gas, electric, or induction options to fit your kitchen style."
        },
        {        
          mainHeading: "",
          title: "Reliable Dishwashers and Microwaves:",        
          descriptionTxt : "Simplify your cleanup and reheating tasks with Whirlpool’s dishwashers and microwaves. Their advanced technologies ensure spotless dishes and evenly heated meals every time."
        },
        {        
          mainHeading: "",
          title: "Innovative Wall Ovens and Range Hoods:",        
          descriptionTxt : "Upgrade your cooking experience with Whirlpool wall ovens featuring smart functions and sleek designs. Pair them with Whirlpool’s range hoods to keep your kitchen fresh and odor-free."
        },       
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "From compactors to freezers, Whirlpool Appliances cater to every household need with a focus on efficiency and style. Explore the entire Whirlpool collection at Airport Appliance and find the perfect appliances to elevate your home."
        },    
      ]
    },
  },
  {
    Zephyr: {
      id: 1,
      title: "Zephyr",
      videoLink: "https://www.youtube.com/watch?v=6sZywRcExDA",
      BannerData: {
        subheading: "Design Beyond Expectations",
        descriptionTxt: 
          "Known for stylish, high-performance ventilation hoods that prioritize both form and function.",
        bannerImg: ZephyrbannerImg,
        logoImg: ZephyrlogoImg,
      },
      brandOptions: [
        { 
          img: ZephyrCategory_1,
          title:'Range Hoods',
          slug: '/all-brands/zephyr/range-hoods',
          imageFlag: true
        },
        { 
          img: ZephyrCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/zephyr/refrigerators',
        },
        // { 
        //   img: ZephyrCategory_1,
        //   title:'Range Hoods',
        // },
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Zephyr Appliances are renowned for their sophisticated designs and innovative technology, offering products that seamlessly blend style and performance. From state-of-the-art range hoods to elegant wine coolers, refrigerators, and beverage centers, Zephyr has everything you need to enhance your home’s functionality and aesthetic appeal."
        },
        {        
          mainHeading: "Why Choose Zephyr Appliances?",
          title: "Refrigerators with Modern Efficiency:",        
          descriptionTxt : "Zephyr refrigerators combine sleek aesthetics with advanced cooling technologies. They ensure optimal food preservation while adding a touch of modern sophistication to your kitchen."
        },
        {        
          mainHeading: "",
          title: "Stylish and Functional Range Hoods:",        
          descriptionTxt : "Zephyr’s range hoods are designed to deliver superior ventilation while complementing your kitchen’s design. Choose from a variety of styles, including wall-mounted and island hoods, to keep your kitchen fresh and odor-free."
        },
        {        
          mainHeading: "",
          title: "Wine Coolers for Connoisseurs:",        
          descriptionTxt : "Protect your wine collection with Zephyr wine coolers, featuring precise temperature control and elegant designs. These coolers are ideal for wine enthusiasts who value both form and function."
        },
        {        
          mainHeading: "",
          title: "Beverage Centers for Versatile Storage:",        
          descriptionTxt : "Zephyr beverage centers provide the perfect solution for storing drinks and snacks at the ideal temperature. Whether it’s for entertaining guests or everyday use, these centers offer convenience and style."
        },
        {        
          mainHeading: "",
          title: "",        
          descriptionTxt : "Zephyr Appliances are designed to transform your home into a space of comfort and sophistication. Explore their premium collection at Airport Appliance and find the perfect appliances to suit your needs and elevate your lifestyle."
        },   
      ]
    },
  },
  {
    Zline: {
      id: 166,
      title: "Zline",
      videoLink: "https://www.youtube.com/watch?v=f9IS_JVBrZI",
      BannerData: {
        subheading: "Attainable Luxury",
        descriptionTxt: 
          "Known for offering luxury kitchen appliances with professional performance at an affordable price.",
        bannerImg: ZlinebannerImg,
        logoImg: ZlinelogoImg,
      },
      brandOptions: [
        { 
          img: ZlineCategory_1,
          title:'Ranges',
          slug: '/all-brands/zline/ranges',
        },
        { 
          img: ZlineCategory_2,
          title:'Refrigerators',
          slug: '/all-brands/zline/refrigerators',
        },
        { 
          img: ZlineCategory_3,
          title:'Dishwashers',
          slug: '/all-brands/zline/dishwashers',
        },
        { 
          img: ZlineCategory_4,
          title:'Wall Ovens',
          slug: '/all-brands/zline/wall-ovens',
          imageFlag: true
        },
        { 
          img: ZlineCategory_5,
          title:'Cooktops',
          slug: '/all-brands/zline/cooktops',
          imageFlag: true
        },
        { 
          img: ZlineCategory_6,
          title:'Range Hoods',
          slug: '/all-brands/zline/range-hoods',
          imageFlag: true
        },
        { 
          img: ZlineCategory_7,
          title:'Microwaves',
          slug: '/all-brands/zline/microwaves-otr',
          imageFlag: true
        },
      ],
      collectionList: [],
      contentList:[
        {        
          mainHeading: "ZLINE Appliances: Affordable Luxury for Every Kitchen",
          title: "",        
          descriptionTxt : "ZLINE is a leader in high-end kitchen appliances, offering professional-grade performance, stylish designs, and innovative features at an affordable price. Whether you’re upgrading your cooking space or designing a luxury kitchen, ZLINE appliances bring elegance and efficiency to every home."
        },
        {        
          mainHeading: "Why Choose ZLINE Appliances?",
          title: "Ranges: Power and Precision in Every Meal",        
          descriptionTxt : "ZLINE ranges combine high-BTU burners, spacious ovens, and durable construction for a restaurant-quality cooking experience. Available in gas, dual fuel, and induction models, these ranges provide superior performance and a sleek, modern look."
        },
        {        
          mainHeading: "",
          title: "Refrigerators: Advanced Cooling with a Stylish Touch",        
          descriptionTxt : "Designed to keep your ingredients fresher for longer, ZLINE refrigerators feature powerful cooling technology, spacious interiors, and sleek designs. With options like French doors, counter-depth configurations, and customizable finishes, these refrigerators add both function and style to your kitchen."
        },
        {        
          mainHeading: "",
          title: "Dishwashers: Quiet, Efficient, and Powerful Cleaning",
          descriptionTxt : "ZLINE dishwashers offer whisper-quiet operation and industry-leading cleaning technology. With multiple wash cycles, stainless steel interiors, and energy-efficient performance, they ensure spotless dishes with every load."
        },
        {        
          mainHeading: "",
          title: "Wall Ovens: Elevate Your Cooking Experience",
          descriptionTxt : "For precision baking and roasting, ZLINE wall ovens deliver consistent heat distribution and modern technology. With sleek stainless steel finishes and advanced cooking modes, these ovens bring professional-quality results to your kitchen."
        },
        {        
          mainHeading: "",
          title: "Cooktops: Sleek Design, Superior Performance",
          descriptionTxt : "ZLINE cooktops offer high-powered burners, smooth-touch controls, and durable grates, making them ideal for any cooking style. Whether you prefer gas, electric, or induction, these cooktops provide flexibility and precision in every dish."
        },
        {        
          mainHeading: "",
          title: "Range Hoods: Powerful Ventilation for a Clean Kitchen",
          descriptionTxt : "ZLINE range hoods are designed to eliminate smoke, grease, and odors while adding a touch of elegance to your space. Available in wall-mounted, under-cabinet, and island designs, these hoods offer powerful airflow and customizable finishes to match your kitchen’s aesthetic."
        },
        {        
          mainHeading: "",
          title: "Microwaves: Convenient Cooking with Modern Technology",
          descriptionTxt : "ZLINE microwaves make meal prep easier with advanced cooking modes, spacious interiors, and sleek designs. Whether built-in, drawer-style, or over-the-range, these microwaves provide quick and efficient cooking solutions for any home."
        },
        {        
          mainHeading: "",
          title: "",
          descriptionTxt : "At Airport Home Appliance, we are proud to offer ZLINE appliances, delivering professional-grade quality at an unbeatable value. Shop ZLINE today and bring style, performance, and innovation into your kitchen!"
        }
      ]
    },
  } 
];
